/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const addCardsToCardGroup = /* GraphQL */ `mutation AddCardsToCardGroup($input: AddCardsToCardGroupInput!) {
  addCardsToCardGroup(input: $input) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddCardsToCardGroupMutationVariables,
  APITypes.AddCardsToCardGroupMutation
>;
export const createAgaveProject = /* GraphQL */ `mutation CreateAgaveProject(
  $input: CreateAgaveProjectInput!
  $condition: ModelAgaveProjectConditionInput
) {
  createAgaveProject(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    address {
      street_1
      street_2
      city
      state
      postal_code
      country
      __typename
    }
    amount
    completion_date
    name
    number
    start_date
    status
    type
    source_create_time
    source_update_time
    source_data {
      CreationDate
      data
      DeliveryAddressLine
      DeliveryCity
      DeliveryCountry
      DeliveryPostcode
      DeliveryState
      FaxNumber
      LogoPath
      ProjectOwnerOrganizationId
      ProjectOwnerOrganizationName
      PhoneNumber
      PostalAddressLine
      PostalCity
      PostalCountry
      PostalPostcode
      PostalState
      ProjectAddressLine
      ProjectCity
      ProjectCode
      ProjectCountry
      ProjectDescription
      ProjectId
      ProjectName
      ProjectPostcode
      ProjectShortName
      ProjectState
      ProjectType
      ProjectValue
      ProjectResponsibilities
      StartDate
      StopDate
      __typename
    }
    createdAt
    updatedAt
    fullName
    relatedIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveProjectMutationVariables,
  APITypes.CreateAgaveProjectMutation
>;
export const updateAgaveProject = /* GraphQL */ `mutation UpdateAgaveProject(
  $input: UpdateAgaveProjectInput!
  $condition: ModelAgaveProjectConditionInput
) {
  updateAgaveProject(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    address {
      street_1
      street_2
      city
      state
      postal_code
      country
      __typename
    }
    amount
    completion_date
    name
    number
    start_date
    status
    type
    source_create_time
    source_update_time
    source_data {
      CreationDate
      data
      DeliveryAddressLine
      DeliveryCity
      DeliveryCountry
      DeliveryPostcode
      DeliveryState
      FaxNumber
      LogoPath
      ProjectOwnerOrganizationId
      ProjectOwnerOrganizationName
      PhoneNumber
      PostalAddressLine
      PostalCity
      PostalCountry
      PostalPostcode
      PostalState
      ProjectAddressLine
      ProjectCity
      ProjectCode
      ProjectCountry
      ProjectDescription
      ProjectId
      ProjectName
      ProjectPostcode
      ProjectShortName
      ProjectState
      ProjectType
      ProjectValue
      ProjectResponsibilities
      StartDate
      StopDate
      __typename
    }
    createdAt
    updatedAt
    fullName
    relatedIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveProjectMutationVariables,
  APITypes.UpdateAgaveProjectMutation
>;
export const deleteAgaveProject = /* GraphQL */ `mutation DeleteAgaveProject(
  $input: DeleteAgaveProjectInput!
  $condition: ModelAgaveProjectConditionInput
) {
  deleteAgaveProject(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    address {
      street_1
      street_2
      city
      state
      postal_code
      country
      __typename
    }
    amount
    completion_date
    name
    number
    start_date
    status
    type
    source_create_time
    source_update_time
    source_data {
      CreationDate
      data
      DeliveryAddressLine
      DeliveryCity
      DeliveryCountry
      DeliveryPostcode
      DeliveryState
      FaxNumber
      LogoPath
      ProjectOwnerOrganizationId
      ProjectOwnerOrganizationName
      PhoneNumber
      PostalAddressLine
      PostalCity
      PostalCountry
      PostalPostcode
      PostalState
      ProjectAddressLine
      ProjectCity
      ProjectCode
      ProjectCountry
      ProjectDescription
      ProjectId
      ProjectName
      ProjectPostcode
      ProjectShortName
      ProjectState
      ProjectType
      ProjectValue
      ProjectResponsibilities
      StartDate
      StopDate
      __typename
    }
    createdAt
    updatedAt
    fullName
    relatedIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveProjectMutationVariables,
  APITypes.DeleteAgaveProjectMutation
>;
export const createAgaveGlCode = /* GraphQL */ `mutation CreateAgaveGlCode(
  $input: CreateAgaveGlCodeInput!
  $condition: ModelAgaveGlCodeConditionInput
) {
  createAgaveGlCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    classification
    currency_code
    current_balance
    description
    name
    number
    status
    type
    source_create_time
    source_update_time
    source_data {
      CreationDate
      data
      DeliveryAddressLine
      DeliveryCity
      DeliveryCountry
      DeliveryPostcode
      DeliveryState
      FaxNumber
      LogoPath
      ProjectOwnerOrganizationId
      ProjectOwnerOrganizationName
      PhoneNumber
      PostalAddressLine
      PostalCity
      PostalCountry
      PostalPostcode
      PostalState
      ProjectAddressLine
      ProjectCity
      ProjectCode
      ProjectCountry
      ProjectDescription
      ProjectId
      ProjectName
      ProjectPostcode
      ProjectShortName
      ProjectState
      ProjectType
      ProjectValue
      ProjectResponsibilities
      StartDate
      StopDate
      __typename
    }
    createdAt
    updatedAt
    fullName
    relatedIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveGlCodeMutationVariables,
  APITypes.CreateAgaveGlCodeMutation
>;
export const updateAgaveGlCode = /* GraphQL */ `mutation UpdateAgaveGlCode(
  $input: UpdateAgaveGlCodeInput!
  $condition: ModelAgaveGlCodeConditionInput
) {
  updateAgaveGlCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    classification
    currency_code
    current_balance
    description
    name
    number
    status
    type
    source_create_time
    source_update_time
    source_data {
      CreationDate
      data
      DeliveryAddressLine
      DeliveryCity
      DeliveryCountry
      DeliveryPostcode
      DeliveryState
      FaxNumber
      LogoPath
      ProjectOwnerOrganizationId
      ProjectOwnerOrganizationName
      PhoneNumber
      PostalAddressLine
      PostalCity
      PostalCountry
      PostalPostcode
      PostalState
      ProjectAddressLine
      ProjectCity
      ProjectCode
      ProjectCountry
      ProjectDescription
      ProjectId
      ProjectName
      ProjectPostcode
      ProjectShortName
      ProjectState
      ProjectType
      ProjectValue
      ProjectResponsibilities
      StartDate
      StopDate
      __typename
    }
    createdAt
    updatedAt
    fullName
    relatedIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveGlCodeMutationVariables,
  APITypes.UpdateAgaveGlCodeMutation
>;
export const deleteAgaveGlCode = /* GraphQL */ `mutation DeleteAgaveGlCode(
  $input: DeleteAgaveGlCodeInput!
  $condition: ModelAgaveGlCodeConditionInput
) {
  deleteAgaveGlCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    classification
    currency_code
    current_balance
    description
    name
    number
    status
    type
    source_create_time
    source_update_time
    source_data {
      CreationDate
      data
      DeliveryAddressLine
      DeliveryCity
      DeliveryCountry
      DeliveryPostcode
      DeliveryState
      FaxNumber
      LogoPath
      ProjectOwnerOrganizationId
      ProjectOwnerOrganizationName
      PhoneNumber
      PostalAddressLine
      PostalCity
      PostalCountry
      PostalPostcode
      PostalState
      ProjectAddressLine
      ProjectCity
      ProjectCode
      ProjectCountry
      ProjectDescription
      ProjectId
      ProjectName
      ProjectPostcode
      ProjectShortName
      ProjectState
      ProjectType
      ProjectValue
      ProjectResponsibilities
      StartDate
      StopDate
      __typename
    }
    createdAt
    updatedAt
    fullName
    relatedIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveGlCodeMutationVariables,
  APITypes.DeleteAgaveGlCodeMutation
>;
export const createAgaveCostCode = /* GraphQL */ `mutation CreateAgaveCostCode(
  $input: CreateAgaveCostCodeInput!
  $condition: ModelAgaveCostCodeConditionInput
) {
  createAgaveCostCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    asset_account_id
    source_id
    formatted_full_code
    code
    full_code
    cost_unit_of_measure
    description
    expense_account_id
    income_account_id
    name
    parent_id
    project_id
    price_unit_of_measure
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    status
    type
    unit_cost
    unit_price
    vendor_id
    sub_job_id
    createdAt
    updatedAt
    projectId
    paidolProject
    projectIds
    cost_type_ids
    fullName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveCostCodeMutationVariables,
  APITypes.CreateAgaveCostCodeMutation
>;
export const updateAgaveCostCode = /* GraphQL */ `mutation UpdateAgaveCostCode(
  $input: UpdateAgaveCostCodeInput!
  $condition: ModelAgaveCostCodeConditionInput
) {
  updateAgaveCostCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    asset_account_id
    source_id
    formatted_full_code
    code
    full_code
    cost_unit_of_measure
    description
    expense_account_id
    income_account_id
    name
    parent_id
    project_id
    price_unit_of_measure
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    status
    type
    unit_cost
    unit_price
    vendor_id
    sub_job_id
    createdAt
    updatedAt
    projectId
    paidolProject
    projectIds
    cost_type_ids
    fullName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveCostCodeMutationVariables,
  APITypes.UpdateAgaveCostCodeMutation
>;
export const deleteAgaveCostCode = /* GraphQL */ `mutation DeleteAgaveCostCode(
  $input: DeleteAgaveCostCodeInput!
  $condition: ModelAgaveCostCodeConditionInput
) {
  deleteAgaveCostCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    asset_account_id
    source_id
    formatted_full_code
    code
    full_code
    cost_unit_of_measure
    description
    expense_account_id
    income_account_id
    name
    parent_id
    project_id
    price_unit_of_measure
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    status
    type
    unit_cost
    unit_price
    vendor_id
    sub_job_id
    createdAt
    updatedAt
    projectId
    paidolProject
    projectIds
    cost_type_ids
    fullName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveCostCodeMutationVariables,
  APITypes.DeleteAgaveCostCodeMutation
>;
export const createAgaveSubJob = /* GraphQL */ `mutation CreateAgaveSubJob(
  $input: CreateAgaveSubJobInput!
  $condition: ModelAgaveSubJobConditionInput
) {
  createAgaveSubJob(input: $input, condition: $condition) {
    id
    agaveSubJobId
    paidolId
    authPaidolId
    source_id
    name
    number
    code
    status
    type
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    createdAt
    updatedAt
    projectId
    fullName
    cost_code_ids
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveSubJobMutationVariables,
  APITypes.CreateAgaveSubJobMutation
>;
export const updateAgaveSubJob = /* GraphQL */ `mutation UpdateAgaveSubJob(
  $input: UpdateAgaveSubJobInput!
  $condition: ModelAgaveSubJobConditionInput
) {
  updateAgaveSubJob(input: $input, condition: $condition) {
    id
    agaveSubJobId
    paidolId
    authPaidolId
    source_id
    name
    number
    code
    status
    type
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    createdAt
    updatedAt
    projectId
    fullName
    cost_code_ids
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveSubJobMutationVariables,
  APITypes.UpdateAgaveSubJobMutation
>;
export const deleteAgaveSubJob = /* GraphQL */ `mutation DeleteAgaveSubJob(
  $input: DeleteAgaveSubJobInput!
  $condition: ModelAgaveSubJobConditionInput
) {
  deleteAgaveSubJob(input: $input, condition: $condition) {
    id
    agaveSubJobId
    paidolId
    authPaidolId
    source_id
    name
    number
    code
    status
    type
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    createdAt
    updatedAt
    projectId
    fullName
    cost_code_ids
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveSubJobMutationVariables,
  APITypes.DeleteAgaveSubJobMutation
>;
export const createAgaveProjectCostCode = /* GraphQL */ `mutation CreateAgaveProjectCostCode(
  $input: CreateAgaveProjectCostCodeInput!
  $condition: ModelAgaveProjectCostCodeConditionInput
) {
  createAgaveProjectCostCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    projectId
    costCodeId
    projectIdCostCodeId
    costCodeName
    costCodeCode
    projectName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveProjectCostCodeMutationVariables,
  APITypes.CreateAgaveProjectCostCodeMutation
>;
export const updateAgaveProjectCostCode = /* GraphQL */ `mutation UpdateAgaveProjectCostCode(
  $input: UpdateAgaveProjectCostCodeInput!
  $condition: ModelAgaveProjectCostCodeConditionInput
) {
  updateAgaveProjectCostCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    projectId
    costCodeId
    projectIdCostCodeId
    costCodeName
    costCodeCode
    projectName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveProjectCostCodeMutationVariables,
  APITypes.UpdateAgaveProjectCostCodeMutation
>;
export const deleteAgaveProjectCostCode = /* GraphQL */ `mutation DeleteAgaveProjectCostCode(
  $input: DeleteAgaveProjectCostCodeInput!
  $condition: ModelAgaveProjectCostCodeConditionInput
) {
  deleteAgaveProjectCostCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    projectId
    costCodeId
    projectIdCostCodeId
    costCodeName
    costCodeCode
    projectName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveProjectCostCodeMutationVariables,
  APITypes.DeleteAgaveProjectCostCodeMutation
>;
export const createAgaveProjectSubJob = /* GraphQL */ `mutation CreateAgaveProjectSubJob(
  $input: CreateAgaveProjectSubJobInput!
  $condition: ModelAgaveProjectSubJobConditionInput
) {
  createAgaveProjectSubJob(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    projectId
    subJobId
    projectIdSubJobId
    subJobName
    subJobNumber
    projectName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveProjectSubJobMutationVariables,
  APITypes.CreateAgaveProjectSubJobMutation
>;
export const updateAgaveProjectSubJob = /* GraphQL */ `mutation UpdateAgaveProjectSubJob(
  $input: UpdateAgaveProjectSubJobInput!
  $condition: ModelAgaveProjectSubJobConditionInput
) {
  updateAgaveProjectSubJob(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    projectId
    subJobId
    projectIdSubJobId
    subJobName
    subJobNumber
    projectName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveProjectSubJobMutationVariables,
  APITypes.UpdateAgaveProjectSubJobMutation
>;
export const deleteAgaveProjectSubJob = /* GraphQL */ `mutation DeleteAgaveProjectSubJob(
  $input: DeleteAgaveProjectSubJobInput!
  $condition: ModelAgaveProjectSubJobConditionInput
) {
  deleteAgaveProjectSubJob(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    projectId
    subJobId
    projectIdSubJobId
    subJobName
    subJobNumber
    projectName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveProjectSubJobMutationVariables,
  APITypes.DeleteAgaveProjectSubJobMutation
>;
export const createAgaveSubJobCostCode = /* GraphQL */ `mutation CreateAgaveSubJobCostCode(
  $input: CreateAgaveSubJobCostCodeInput!
  $condition: ModelAgaveSubJobCostCodeConditionInput
) {
  createAgaveSubJobCostCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    subJobId
    costCodeId
    projectId
    subJobIdCostCodeId
    costCodeName
    costCodeCode
    subJobName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveSubJobCostCodeMutationVariables,
  APITypes.CreateAgaveSubJobCostCodeMutation
>;
export const updateAgaveSubJobCostCode = /* GraphQL */ `mutation UpdateAgaveSubJobCostCode(
  $input: UpdateAgaveSubJobCostCodeInput!
  $condition: ModelAgaveSubJobCostCodeConditionInput
) {
  updateAgaveSubJobCostCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    subJobId
    costCodeId
    projectId
    subJobIdCostCodeId
    costCodeName
    costCodeCode
    subJobName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveSubJobCostCodeMutationVariables,
  APITypes.UpdateAgaveSubJobCostCodeMutation
>;
export const deleteAgaveSubJobCostCode = /* GraphQL */ `mutation DeleteAgaveSubJobCostCode(
  $input: DeleteAgaveSubJobCostCodeInput!
  $condition: ModelAgaveSubJobCostCodeConditionInput
) {
  deleteAgaveSubJobCostCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    subJobId
    costCodeId
    projectId
    subJobIdCostCodeId
    costCodeName
    costCodeCode
    subJobName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveSubJobCostCodeMutationVariables,
  APITypes.DeleteAgaveSubJobCostCodeMutation
>;
export const createAgaveProjectLocation = /* GraphQL */ `mutation CreateAgaveProjectLocation(
  $input: CreateAgaveProjectLocationInput!
  $condition: ModelAgaveProjectLocationConditionInput
) {
  createAgaveProjectLocation(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    projectId
    locationId
    projectName
    locationName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveProjectLocationMutationVariables,
  APITypes.CreateAgaveProjectLocationMutation
>;
export const updateAgaveProjectLocation = /* GraphQL */ `mutation UpdateAgaveProjectLocation(
  $input: UpdateAgaveProjectLocationInput!
  $condition: ModelAgaveProjectLocationConditionInput
) {
  updateAgaveProjectLocation(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    projectId
    locationId
    projectName
    locationName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveProjectLocationMutationVariables,
  APITypes.UpdateAgaveProjectLocationMutation
>;
export const deleteAgaveProjectLocation = /* GraphQL */ `mutation DeleteAgaveProjectLocation(
  $input: DeleteAgaveProjectLocationInput!
  $condition: ModelAgaveProjectLocationConditionInput
) {
  deleteAgaveProjectLocation(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    projectId
    locationId
    projectName
    locationName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveProjectLocationMutationVariables,
  APITypes.DeleteAgaveProjectLocationMutation
>;
export const createAgaveProjectDepartment = /* GraphQL */ `mutation CreateAgaveProjectDepartment(
  $input: CreateAgaveProjectDepartmentInput!
  $condition: ModelAgaveProjectDepartmentConditionInput
) {
  createAgaveProjectDepartment(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    projectId
    departmentId
    projectName
    departmentName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveProjectDepartmentMutationVariables,
  APITypes.CreateAgaveProjectDepartmentMutation
>;
export const updateAgaveProjectDepartment = /* GraphQL */ `mutation UpdateAgaveProjectDepartment(
  $input: UpdateAgaveProjectDepartmentInput!
  $condition: ModelAgaveProjectDepartmentConditionInput
) {
  updateAgaveProjectDepartment(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    projectId
    departmentId
    projectName
    departmentName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveProjectDepartmentMutationVariables,
  APITypes.UpdateAgaveProjectDepartmentMutation
>;
export const deleteAgaveProjectDepartment = /* GraphQL */ `mutation DeleteAgaveProjectDepartment(
  $input: DeleteAgaveProjectDepartmentInput!
  $condition: ModelAgaveProjectDepartmentConditionInput
) {
  deleteAgaveProjectDepartment(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    projectId
    departmentId
    projectName
    departmentName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveProjectDepartmentMutationVariables,
  APITypes.DeleteAgaveProjectDepartmentMutation
>;
export const createAgaveEmployeeEntity = /* GraphQL */ `mutation CreateAgaveEmployeeEntity(
  $input: CreateAgaveEmployeeEntityInput!
  $condition: ModelAgaveEmployeeEntityConditionInput
) {
  createAgaveEmployeeEntity(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    fullName
    firstName
    lastName
    email
    status
    source_id
    source_create_time
    source_update_time
    createdAt
    updatedAt
    source_data
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveEmployeeEntityMutationVariables,
  APITypes.CreateAgaveEmployeeEntityMutation
>;
export const updateAgaveEmployeeEntity = /* GraphQL */ `mutation UpdateAgaveEmployeeEntity(
  $input: UpdateAgaveEmployeeEntityInput!
  $condition: ModelAgaveEmployeeEntityConditionInput
) {
  updateAgaveEmployeeEntity(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    fullName
    firstName
    lastName
    email
    status
    source_id
    source_create_time
    source_update_time
    createdAt
    updatedAt
    source_data
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveEmployeeEntityMutationVariables,
  APITypes.UpdateAgaveEmployeeEntityMutation
>;
export const deleteAgaveEmployeeEntity = /* GraphQL */ `mutation DeleteAgaveEmployeeEntity(
  $input: DeleteAgaveEmployeeEntityInput!
  $condition: ModelAgaveEmployeeEntityConditionInput
) {
  deleteAgaveEmployeeEntity(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    fullName
    firstName
    lastName
    email
    status
    source_id
    source_create_time
    source_update_time
    createdAt
    updatedAt
    source_data
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveEmployeeEntityMutationVariables,
  APITypes.DeleteAgaveEmployeeEntityMutation
>;
export const createAgaveEmployeeLocation = /* GraphQL */ `mutation CreateAgaveEmployeeLocation(
  $input: CreateAgaveEmployeeLocationInput!
  $condition: ModelAgaveEmployeeLocationConditionInput
) {
  createAgaveEmployeeLocation(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    employeeId
    locationId
    employeeName
    locationName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveEmployeeLocationMutationVariables,
  APITypes.CreateAgaveEmployeeLocationMutation
>;
export const updateAgaveEmployeeLocation = /* GraphQL */ `mutation UpdateAgaveEmployeeLocation(
  $input: UpdateAgaveEmployeeLocationInput!
  $condition: ModelAgaveEmployeeLocationConditionInput
) {
  updateAgaveEmployeeLocation(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    employeeId
    locationId
    employeeName
    locationName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveEmployeeLocationMutationVariables,
  APITypes.UpdateAgaveEmployeeLocationMutation
>;
export const deleteAgaveEmployeeLocation = /* GraphQL */ `mutation DeleteAgaveEmployeeLocation(
  $input: DeleteAgaveEmployeeLocationInput!
  $condition: ModelAgaveEmployeeLocationConditionInput
) {
  deleteAgaveEmployeeLocation(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    employeeId
    locationId
    employeeName
    locationName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveEmployeeLocationMutationVariables,
  APITypes.DeleteAgaveEmployeeLocationMutation
>;
export const createAgaveEmployeeDepartment = /* GraphQL */ `mutation CreateAgaveEmployeeDepartment(
  $input: CreateAgaveEmployeeDepartmentInput!
  $condition: ModelAgaveEmployeeDepartmentConditionInput
) {
  createAgaveEmployeeDepartment(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    employeeId
    departmentId
    employeeName
    departmentName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveEmployeeDepartmentMutationVariables,
  APITypes.CreateAgaveEmployeeDepartmentMutation
>;
export const updateAgaveEmployeeDepartment = /* GraphQL */ `mutation UpdateAgaveEmployeeDepartment(
  $input: UpdateAgaveEmployeeDepartmentInput!
  $condition: ModelAgaveEmployeeDepartmentConditionInput
) {
  updateAgaveEmployeeDepartment(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    employeeId
    departmentId
    employeeName
    departmentName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveEmployeeDepartmentMutationVariables,
  APITypes.UpdateAgaveEmployeeDepartmentMutation
>;
export const deleteAgaveEmployeeDepartment = /* GraphQL */ `mutation DeleteAgaveEmployeeDepartment(
  $input: DeleteAgaveEmployeeDepartmentInput!
  $condition: ModelAgaveEmployeeDepartmentConditionInput
) {
  deleteAgaveEmployeeDepartment(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    employeeId
    departmentId
    employeeName
    departmentName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveEmployeeDepartmentMutationVariables,
  APITypes.DeleteAgaveEmployeeDepartmentMutation
>;
export const createAgaveCostType = /* GraphQL */ `mutation CreateAgaveCostType(
  $input: CreateAgaveCostTypeInput!
  $condition: ModelAgaveCostTypeConditionInput
) {
  createAgaveCostType(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    project_id
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    createdAt
    updatedAt
    projectId
    paidolProject
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveCostTypeMutationVariables,
  APITypes.CreateAgaveCostTypeMutation
>;
export const updateAgaveCostType = /* GraphQL */ `mutation UpdateAgaveCostType(
  $input: UpdateAgaveCostTypeInput!
  $condition: ModelAgaveCostTypeConditionInput
) {
  updateAgaveCostType(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    project_id
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    createdAt
    updatedAt
    projectId
    paidolProject
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveCostTypeMutationVariables,
  APITypes.UpdateAgaveCostTypeMutation
>;
export const deleteAgaveCostType = /* GraphQL */ `mutation DeleteAgaveCostType(
  $input: DeleteAgaveCostTypeInput!
  $condition: ModelAgaveCostTypeConditionInput
) {
  deleteAgaveCostType(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    project_id
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    createdAt
    updatedAt
    projectId
    paidolProject
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveCostTypeMutationVariables,
  APITypes.DeleteAgaveCostTypeMutation
>;
export const createAgaveEquipment = /* GraphQL */ `mutation CreateAgaveEquipment(
  $input: CreateAgaveEquipmentInput!
  $condition: ModelAgaveEquipmentConditionInput
) {
  createAgaveEquipment(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    fullName
    emGroup
    emCo
    category
    department
    status
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    lastSeenAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveEquipmentMutationVariables,
  APITypes.CreateAgaveEquipmentMutation
>;
export const updateAgaveEquipment = /* GraphQL */ `mutation UpdateAgaveEquipment(
  $input: UpdateAgaveEquipmentInput!
  $condition: ModelAgaveEquipmentConditionInput
) {
  updateAgaveEquipment(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    fullName
    emGroup
    emCo
    category
    department
    status
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    lastSeenAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveEquipmentMutationVariables,
  APITypes.UpdateAgaveEquipmentMutation
>;
export const deleteAgaveEquipment = /* GraphQL */ `mutation DeleteAgaveEquipment(
  $input: DeleteAgaveEquipmentInput!
  $condition: ModelAgaveEquipmentConditionInput
) {
  deleteAgaveEquipment(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    fullName
    emGroup
    emCo
    category
    department
    status
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    lastSeenAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveEquipmentMutationVariables,
  APITypes.DeleteAgaveEquipmentMutation
>;
export const createAgaveEmCostCode = /* GraphQL */ `mutation CreateAgaveEmCostCode(
  $input: CreateAgaveEmCostCodeInput!
  $condition: ModelAgaveEmCostCodeConditionInput
) {
  createAgaveEmCostCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    fullName
    emGroup
    emCostTypeCodes
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    lastSeenAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveEmCostCodeMutationVariables,
  APITypes.CreateAgaveEmCostCodeMutation
>;
export const updateAgaveEmCostCode = /* GraphQL */ `mutation UpdateAgaveEmCostCode(
  $input: UpdateAgaveEmCostCodeInput!
  $condition: ModelAgaveEmCostCodeConditionInput
) {
  updateAgaveEmCostCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    fullName
    emGroup
    emCostTypeCodes
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    lastSeenAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveEmCostCodeMutationVariables,
  APITypes.UpdateAgaveEmCostCodeMutation
>;
export const deleteAgaveEmCostCode = /* GraphQL */ `mutation DeleteAgaveEmCostCode(
  $input: DeleteAgaveEmCostCodeInput!
  $condition: ModelAgaveEmCostCodeConditionInput
) {
  deleteAgaveEmCostCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    fullName
    emGroup
    emCostTypeCodes
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    lastSeenAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveEmCostCodeMutationVariables,
  APITypes.DeleteAgaveEmCostCodeMutation
>;
export const createAgaveEmDepartment = /* GraphQL */ `mutation CreateAgaveEmDepartment(
  $input: CreateAgaveEmDepartmentInput!
  $condition: ModelAgaveEmDepartmentConditionInput
) {
  createAgaveEmDepartment(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    fullName
    emCo
    costCodeKeys
    costTypeKeys
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    lastSeenAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveEmDepartmentMutationVariables,
  APITypes.CreateAgaveEmDepartmentMutation
>;
export const updateAgaveEmDepartment = /* GraphQL */ `mutation UpdateAgaveEmDepartment(
  $input: UpdateAgaveEmDepartmentInput!
  $condition: ModelAgaveEmDepartmentConditionInput
) {
  updateAgaveEmDepartment(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    fullName
    emCo
    costCodeKeys
    costTypeKeys
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    lastSeenAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveEmDepartmentMutationVariables,
  APITypes.UpdateAgaveEmDepartmentMutation
>;
export const deleteAgaveEmDepartment = /* GraphQL */ `mutation DeleteAgaveEmDepartment(
  $input: DeleteAgaveEmDepartmentInput!
  $condition: ModelAgaveEmDepartmentConditionInput
) {
  deleteAgaveEmDepartment(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    fullName
    emCo
    costCodeKeys
    costTypeKeys
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    lastSeenAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveEmDepartmentMutationVariables,
  APITypes.DeleteAgaveEmDepartmentMutation
>;
export const createAgaveEmCostType = /* GraphQL */ `mutation CreateAgaveEmCostType(
  $input: CreateAgaveEmCostTypeInput!
  $condition: ModelAgaveEmCostTypeConditionInput
) {
  createAgaveEmCostType(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    fullName
    emGroup
    abbreviation
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    lastSeenAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveEmCostTypeMutationVariables,
  APITypes.CreateAgaveEmCostTypeMutation
>;
export const updateAgaveEmCostType = /* GraphQL */ `mutation UpdateAgaveEmCostType(
  $input: UpdateAgaveEmCostTypeInput!
  $condition: ModelAgaveEmCostTypeConditionInput
) {
  updateAgaveEmCostType(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    fullName
    emGroup
    abbreviation
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    lastSeenAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveEmCostTypeMutationVariables,
  APITypes.UpdateAgaveEmCostTypeMutation
>;
export const deleteAgaveEmCostType = /* GraphQL */ `mutation DeleteAgaveEmCostType(
  $input: DeleteAgaveEmCostTypeInput!
  $condition: ModelAgaveEmCostTypeConditionInput
) {
  deleteAgaveEmCostType(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    code
    name
    fullName
    emGroup
    abbreviation
    source_create_time
    source_update_time
    source_data {
      path
      content_type
      data
      __typename
    }
    lastSeenAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveEmCostTypeMutationVariables,
  APITypes.DeleteAgaveEmCostTypeMutation
>;
export const createAgaveCostCodeCostType = /* GraphQL */ `mutation CreateAgaveCostCodeCostType(
  $input: CreateAgaveCostCodeCostTypeInput!
  $condition: ModelAgaveCostCodeCostTypeConditionInput
) {
  createAgaveCostCodeCostType(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    costCodeId
    costTypeId
    projectId
    costCodeCode
    costCodeName
    costTypeCode
    costTypeName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveCostCodeCostTypeMutationVariables,
  APITypes.CreateAgaveCostCodeCostTypeMutation
>;
export const updateAgaveCostCodeCostType = /* GraphQL */ `mutation UpdateAgaveCostCodeCostType(
  $input: UpdateAgaveCostCodeCostTypeInput!
  $condition: ModelAgaveCostCodeCostTypeConditionInput
) {
  updateAgaveCostCodeCostType(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    costCodeId
    costTypeId
    projectId
    costCodeCode
    costCodeName
    costTypeCode
    costTypeName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveCostCodeCostTypeMutationVariables,
  APITypes.UpdateAgaveCostCodeCostTypeMutation
>;
export const deleteAgaveCostCodeCostType = /* GraphQL */ `mutation DeleteAgaveCostCodeCostType(
  $input: DeleteAgaveCostCodeCostTypeInput!
  $condition: ModelAgaveCostCodeCostTypeConditionInput
) {
  deleteAgaveCostCodeCostType(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    costCodeId
    costTypeId
    projectId
    costCodeCode
    costCodeName
    costTypeCode
    costTypeName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveCostCodeCostTypeMutationVariables,
  APITypes.DeleteAgaveCostCodeCostTypeMutation
>;
export const createAgaveEmCostCodeCostType = /* GraphQL */ `mutation CreateAgaveEmCostCodeCostType(
  $input: CreateAgaveEmCostCodeCostTypeInput!
  $condition: ModelAgaveEmCostCodeCostTypeConditionInput
) {
  createAgaveEmCostCodeCostType(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    emCostCodeId
    emCostTypeId
    emGroup
    emCostCodeCode
    emCostCodeName
    emCostTypeCode
    emCostTypeName
    unitOfMeasure
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveEmCostCodeCostTypeMutationVariables,
  APITypes.CreateAgaveEmCostCodeCostTypeMutation
>;
export const updateAgaveEmCostCodeCostType = /* GraphQL */ `mutation UpdateAgaveEmCostCodeCostType(
  $input: UpdateAgaveEmCostCodeCostTypeInput!
  $condition: ModelAgaveEmCostCodeCostTypeConditionInput
) {
  updateAgaveEmCostCodeCostType(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    emCostCodeId
    emCostTypeId
    emGroup
    emCostCodeCode
    emCostCodeName
    emCostTypeCode
    emCostTypeName
    unitOfMeasure
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveEmCostCodeCostTypeMutationVariables,
  APITypes.UpdateAgaveEmCostCodeCostTypeMutation
>;
export const deleteAgaveEmCostCodeCostType = /* GraphQL */ `mutation DeleteAgaveEmCostCodeCostType(
  $input: DeleteAgaveEmCostCodeCostTypeInput!
  $condition: ModelAgaveEmCostCodeCostTypeConditionInput
) {
  deleteAgaveEmCostCodeCostType(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    emCostCodeId
    emCostTypeId
    emGroup
    emCostCodeCode
    emCostCodeName
    emCostTypeCode
    emCostTypeName
    unitOfMeasure
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveEmCostCodeCostTypeMutationVariables,
  APITypes.DeleteAgaveEmCostCodeCostTypeMutation
>;
export const createAgaveCostCodeCostTypeGl = /* GraphQL */ `mutation CreateAgaveCostCodeCostTypeGl(
  $input: CreateAgaveCostCodeCostTypeGlInput!
  $condition: ModelAgaveCostCodeCostTypeGlConditionInput
) {
  createAgaveCostCodeCostTypeGl(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    projectId
    costCodeId
    costTypeId
    glCodeId
    projectCostCodeCostTypeKey
    glCodeSourceId
    glCodeNumber
    itemSourceId
    itemName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveCostCodeCostTypeGlMutationVariables,
  APITypes.CreateAgaveCostCodeCostTypeGlMutation
>;
export const updateAgaveCostCodeCostTypeGl = /* GraphQL */ `mutation UpdateAgaveCostCodeCostTypeGl(
  $input: UpdateAgaveCostCodeCostTypeGlInput!
  $condition: ModelAgaveCostCodeCostTypeGlConditionInput
) {
  updateAgaveCostCodeCostTypeGl(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    projectId
    costCodeId
    costTypeId
    glCodeId
    projectCostCodeCostTypeKey
    glCodeSourceId
    glCodeNumber
    itemSourceId
    itemName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveCostCodeCostTypeGlMutationVariables,
  APITypes.UpdateAgaveCostCodeCostTypeGlMutation
>;
export const deleteAgaveCostCodeCostTypeGl = /* GraphQL */ `mutation DeleteAgaveCostCodeCostTypeGl(
  $input: DeleteAgaveCostCodeCostTypeGlInput!
  $condition: ModelAgaveCostCodeCostTypeGlConditionInput
) {
  deleteAgaveCostCodeCostTypeGl(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    projectId
    costCodeId
    costTypeId
    glCodeId
    projectCostCodeCostTypeKey
    glCodeSourceId
    glCodeNumber
    itemSourceId
    itemName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveCostCodeCostTypeGlMutationVariables,
  APITypes.DeleteAgaveCostCodeCostTypeGlMutation
>;
export const createAgaveLocation = /* GraphQL */ `mutation CreateAgaveLocation(
  $input: CreateAgaveLocationInput!
  $condition: ModelAgaveLocationConditionInput
) {
  createAgaveLocation(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    fullName
    parent_id
    source_id
    source_create_time
    source_update_time
    createdAt
    updatedAt
    source_data
    relatedIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveLocationMutationVariables,
  APITypes.CreateAgaveLocationMutation
>;
export const updateAgaveLocation = /* GraphQL */ `mutation UpdateAgaveLocation(
  $input: UpdateAgaveLocationInput!
  $condition: ModelAgaveLocationConditionInput
) {
  updateAgaveLocation(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    fullName
    parent_id
    source_id
    source_create_time
    source_update_time
    createdAt
    updatedAt
    source_data
    relatedIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveLocationMutationVariables,
  APITypes.UpdateAgaveLocationMutation
>;
export const deleteAgaveLocation = /* GraphQL */ `mutation DeleteAgaveLocation(
  $input: DeleteAgaveLocationInput!
  $condition: ModelAgaveLocationConditionInput
) {
  deleteAgaveLocation(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    fullName
    parent_id
    source_id
    source_create_time
    source_update_time
    createdAt
    updatedAt
    source_data
    relatedIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveLocationMutationVariables,
  APITypes.DeleteAgaveLocationMutation
>;
export const createAgaveDepartment = /* GraphQL */ `mutation CreateAgaveDepartment(
  $input: CreateAgaveDepartmentInput!
  $condition: ModelAgaveDepartmentConditionInput
) {
  createAgaveDepartment(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    code
    name
    fullName
    status
    type
    source_id
    source_create_time
    source_update_time
    createdAt
    updatedAt
    source_data
    relatedIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveDepartmentMutationVariables,
  APITypes.CreateAgaveDepartmentMutation
>;
export const updateAgaveDepartment = /* GraphQL */ `mutation UpdateAgaveDepartment(
  $input: UpdateAgaveDepartmentInput!
  $condition: ModelAgaveDepartmentConditionInput
) {
  updateAgaveDepartment(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    code
    name
    fullName
    status
    type
    source_id
    source_create_time
    source_update_time
    createdAt
    updatedAt
    source_data
    relatedIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveDepartmentMutationVariables,
  APITypes.UpdateAgaveDepartmentMutation
>;
export const deleteAgaveDepartment = /* GraphQL */ `mutation DeleteAgaveDepartment(
  $input: DeleteAgaveDepartmentInput!
  $condition: ModelAgaveDepartmentConditionInput
) {
  deleteAgaveDepartment(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    code
    name
    fullName
    status
    type
    source_id
    source_create_time
    source_update_time
    createdAt
    updatedAt
    source_data
    relatedIds
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveDepartmentMutationVariables,
  APITypes.DeleteAgaveDepartmentMutation
>;
export const createAgaveSubaccount = /* GraphQL */ `mutation CreateAgaveSubaccount(
  $input: CreateAgaveSubaccountInput!
  $condition: ModelAgaveSubaccountConditionInput
) {
  createAgaveSubaccount(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    code
    name
    status
    type
    source_id
    source_create_time
    source_update_time
    createdAt
    updatedAt
    source_data
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveSubaccountMutationVariables,
  APITypes.CreateAgaveSubaccountMutation
>;
export const updateAgaveSubaccount = /* GraphQL */ `mutation UpdateAgaveSubaccount(
  $input: UpdateAgaveSubaccountInput!
  $condition: ModelAgaveSubaccountConditionInput
) {
  updateAgaveSubaccount(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    code
    name
    status
    type
    source_id
    source_create_time
    source_update_time
    createdAt
    updatedAt
    source_data
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveSubaccountMutationVariables,
  APITypes.UpdateAgaveSubaccountMutation
>;
export const deleteAgaveSubaccount = /* GraphQL */ `mutation DeleteAgaveSubaccount(
  $input: DeleteAgaveSubaccountInput!
  $condition: ModelAgaveSubaccountConditionInput
) {
  deleteAgaveSubaccount(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    code
    name
    status
    type
    source_id
    source_create_time
    source_update_time
    createdAt
    updatedAt
    source_data
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveSubaccountMutationVariables,
  APITypes.DeleteAgaveSubaccountMutation
>;
export const createAgaveVendor = /* GraphQL */ `mutation CreateAgaveVendor(
  $input: CreateAgaveVendorInput!
  $condition: ModelAgaveVendorConditionInput
) {
  createAgaveVendor(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    address {
      street_1
      street_2
      city
      state
      country
      postal_code
      __typename
    }
    code
    email
    fax
    name
    phone
    status
    tax_number
    terms
    type
    website
    source_create_time
    source_update_time
    source_data {
      V1099YN
      V1099Type
      V1099Box
      EFT
      data
      __typename
    }
    createdAt
    updatedAt
    fullName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAgaveVendorMutationVariables,
  APITypes.CreateAgaveVendorMutation
>;
export const updateAgaveVendor = /* GraphQL */ `mutation UpdateAgaveVendor(
  $input: UpdateAgaveVendorInput!
  $condition: ModelAgaveVendorConditionInput
) {
  updateAgaveVendor(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    address {
      street_1
      street_2
      city
      state
      country
      postal_code
      __typename
    }
    code
    email
    fax
    name
    phone
    status
    tax_number
    terms
    type
    website
    source_create_time
    source_update_time
    source_data {
      V1099YN
      V1099Type
      V1099Box
      EFT
      data
      __typename
    }
    createdAt
    updatedAt
    fullName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAgaveVendorMutationVariables,
  APITypes.UpdateAgaveVendorMutation
>;
export const deleteAgaveVendor = /* GraphQL */ `mutation DeleteAgaveVendor(
  $input: DeleteAgaveVendorInput!
  $condition: ModelAgaveVendorConditionInput
) {
  deleteAgaveVendor(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    source_id
    address {
      street_1
      street_2
      city
      state
      country
      postal_code
      __typename
    }
    code
    email
    fax
    name
    phone
    status
    tax_number
    terms
    type
    website
    source_create_time
    source_update_time
    source_data {
      V1099YN
      V1099Type
      V1099Box
      EFT
      data
      __typename
    }
    createdAt
    updatedAt
    fullName
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAgaveVendorMutationVariables,
  APITypes.DeleteAgaveVendorMutation
>;
export const updateUser = /* GraphQL */ `mutation UpdateUser(
  $input: UpdateUserInput!
  $condition: ModelUserConditionInput
) {
  updateUser(input: $input, condition: $condition) {
    id
    username
    email
    first_name
    middle_name
    last_name
    suffix
    paidol_users {
      nextToken
      __typename
    }
    picture
    is_speedster
    birthdate
    address
    phone_number
    phone_extension
    password_updated_at
    finicityCustomerId
    dwollaCustomerId
    firstRunBanner {
      insights
      transactions
      reimbursements
      cardsManagement
      spendRules
      funding
      teamMembers
      groups
      wallet
      settings
      connections
      __typename
    }
    is_support
    deletedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserMutationVariables,
  APITypes.UpdateUserMutation
>;
export const createPaidolAgaveSync = /* GraphQL */ `mutation CreatePaidolAgaveSync(
  $input: CreatePaidolAgaveSyncInput!
  $condition: ModelPaidolAgaveSyncConditionInput
) {
  createPaidolAgaveSync(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    inProgress
    error
    lastRunStart
    lastRunEnd
    taskArn
    syncEntityFilter
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePaidolAgaveSyncMutationVariables,
  APITypes.CreatePaidolAgaveSyncMutation
>;
export const updatePaidolAgaveSync = /* GraphQL */ `mutation UpdatePaidolAgaveSync(
  $input: UpdatePaidolAgaveSyncInput!
  $condition: ModelPaidolAgaveSyncConditionInput
) {
  updatePaidolAgaveSync(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    inProgress
    error
    lastRunStart
    lastRunEnd
    taskArn
    syncEntityFilter
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePaidolAgaveSyncMutationVariables,
  APITypes.UpdatePaidolAgaveSyncMutation
>;
export const deletePaidolAgaveSync = /* GraphQL */ `mutation DeletePaidolAgaveSync(
  $input: DeletePaidolAgaveSyncInput!
  $condition: ModelPaidolAgaveSyncConditionInput
) {
  deletePaidolAgaveSync(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    inProgress
    error
    lastRunStart
    lastRunEnd
    taskArn
    syncEntityFilter
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePaidolAgaveSyncMutationVariables,
  APITypes.DeletePaidolAgaveSyncMutation
>;
export const createPaymentFileQueue = /* GraphQL */ `mutation CreatePaymentFileQueue(
  $input: CreatePaymentFileQueueInput!
  $condition: ModelPaymentFileQueueConditionInput
) {
  createPaymentFileQueue(input: $input, condition: $condition) {
    id
    user_id
    user {
      id
      username
      email
      first_name
      middle_name
      last_name
      suffix
      picture
      is_speedster
      birthdate
      address
      phone_number
      phone_extension
      password_updated_at
      finicityCustomerId
      dwollaCustomerId
      is_support
      deletedAt
      createdAt
      updatedAt
      __typename
    }
    paidol_id
    paidol {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    key
    status
    processed_at
    error_messages
    num_vendors
    num_payments
    num_success
    num_failed
    total {
      value
      currency
      __typename
    }
    createdAt
    filename
    supplier_vendor_paidol_ids
    referenced_vendors
    invoice_ids
    invoice_spx_ids
    priority_status
    priority_file_id
    priority_process_on
    priority_response
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePaymentFileQueueMutationVariables,
  APITypes.CreatePaymentFileQueueMutation
>;
export const updatePaymentFileQueue = /* GraphQL */ `mutation UpdatePaymentFileQueue(
  $input: UpdatePaymentFileQueueInput!
  $condition: ModelPaymentFileQueueConditionInput
) {
  updatePaymentFileQueue(input: $input, condition: $condition) {
    id
    user_id
    user {
      id
      username
      email
      first_name
      middle_name
      last_name
      suffix
      picture
      is_speedster
      birthdate
      address
      phone_number
      phone_extension
      password_updated_at
      finicityCustomerId
      dwollaCustomerId
      is_support
      deletedAt
      createdAt
      updatedAt
      __typename
    }
    paidol_id
    paidol {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    key
    status
    processed_at
    error_messages
    num_vendors
    num_payments
    num_success
    num_failed
    total {
      value
      currency
      __typename
    }
    createdAt
    filename
    supplier_vendor_paidol_ids
    referenced_vendors
    invoice_ids
    invoice_spx_ids
    priority_status
    priority_file_id
    priority_process_on
    priority_response
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePaymentFileQueueMutationVariables,
  APITypes.UpdatePaymentFileQueueMutation
>;
export const deletePaymentFileQueue = /* GraphQL */ `mutation DeletePaymentFileQueue(
  $input: DeletePaymentFileQueueInput!
  $condition: ModelPaymentFileQueueConditionInput
) {
  deletePaymentFileQueue(input: $input, condition: $condition) {
    id
    user_id
    user {
      id
      username
      email
      first_name
      middle_name
      last_name
      suffix
      picture
      is_speedster
      birthdate
      address
      phone_number
      phone_extension
      password_updated_at
      finicityCustomerId
      dwollaCustomerId
      is_support
      deletedAt
      createdAt
      updatedAt
      __typename
    }
    paidol_id
    paidol {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    key
    status
    processed_at
    error_messages
    num_vendors
    num_payments
    num_success
    num_failed
    total {
      value
      currency
      __typename
    }
    createdAt
    filename
    supplier_vendor_paidol_ids
    referenced_vendors
    invoice_ids
    invoice_spx_ids
    priority_status
    priority_file_id
    priority_process_on
    priority_response
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePaymentFileQueueMutationVariables,
  APITypes.DeletePaymentFileQueueMutation
>;
export const createPaidolVendor = /* GraphQL */ `mutation CreatePaidolVendor(
  $input: CreatePaidolVendorInput!
  $condition: ModelPaidolVendorConditionInput
) {
  createPaidolVendor(input: $input, condition: $condition) {
    id
    user_vendor_id
    is_migration
    paidol_id
    vendor {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    vendor_paidol_id
    priority_active
    payment_terms
    priority_account_balance
    contact_name
    priority_billing_code
    priority_repeate_code
    priority_group_code
    email_addresses
    priority_document_delivery
    priority_regular_inv
    priority_summary_inv
    foreign_name
    remarks
    box_1099
    form_code_1099
    remark_1
    priority_response
    cron_status
    priority_status
    priority_supplier_id
    virtual_card_email
    bankAccounts {
      bankId
      accountType
      accountNumber
      routingNumber
      defaults
      isActive
      __typename
    }
    achEnabled
    virtualCardEnabled
    checkIssuingEnabled
    checkIssuingPayableTo
    checkIssuingStreet
    checkIssuingCity
    checkIssuingState
    checkIssuingCountry
    checkIssuingPostalCode
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePaidolVendorMutationVariables,
  APITypes.CreatePaidolVendorMutation
>;
export const updatePaidolVendor = /* GraphQL */ `mutation UpdatePaidolVendor(
  $input: UpdatePaidolVendorInput!
  $condition: ModelPaidolVendorConditionInput
) {
  updatePaidolVendor(input: $input, condition: $condition) {
    id
    user_vendor_id
    is_migration
    paidol_id
    vendor {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    vendor_paidol_id
    priority_active
    payment_terms
    priority_account_balance
    contact_name
    priority_billing_code
    priority_repeate_code
    priority_group_code
    email_addresses
    priority_document_delivery
    priority_regular_inv
    priority_summary_inv
    foreign_name
    remarks
    box_1099
    form_code_1099
    remark_1
    priority_response
    cron_status
    priority_status
    priority_supplier_id
    virtual_card_email
    bankAccounts {
      bankId
      accountType
      accountNumber
      routingNumber
      defaults
      isActive
      __typename
    }
    achEnabled
    virtualCardEnabled
    checkIssuingEnabled
    checkIssuingPayableTo
    checkIssuingStreet
    checkIssuingCity
    checkIssuingState
    checkIssuingCountry
    checkIssuingPostalCode
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePaidolVendorMutationVariables,
  APITypes.UpdatePaidolVendorMutation
>;
export const deletePaidolVendor = /* GraphQL */ `mutation DeletePaidolVendor(
  $input: DeletePaidolVendorInput!
  $condition: ModelPaidolVendorConditionInput
) {
  deletePaidolVendor(input: $input, condition: $condition) {
    id
    user_vendor_id
    is_migration
    paidol_id
    vendor {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    vendor_paidol_id
    priority_active
    payment_terms
    priority_account_balance
    contact_name
    priority_billing_code
    priority_repeate_code
    priority_group_code
    email_addresses
    priority_document_delivery
    priority_regular_inv
    priority_summary_inv
    foreign_name
    remarks
    box_1099
    form_code_1099
    remark_1
    priority_response
    cron_status
    priority_status
    priority_supplier_id
    virtual_card_email
    bankAccounts {
      bankId
      accountType
      accountNumber
      routingNumber
      defaults
      isActive
      __typename
    }
    achEnabled
    virtualCardEnabled
    checkIssuingEnabled
    checkIssuingPayableTo
    checkIssuingStreet
    checkIssuingCity
    checkIssuingState
    checkIssuingCountry
    checkIssuingPostalCode
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePaidolVendorMutationVariables,
  APITypes.DeletePaidolVendorMutation
>;
export const createInvoice = /* GraphQL */ `mutation CreateInvoice(
  $input: CreateInvoiceInput!
  $condition: ModelInvoiceConditionInput
) {
  createInvoice(input: $input, condition: $condition) {
    id
    id_base58
    id_base58_short
    payment_file_queue_id
    payment_file {
      id
      user_id
      paidol_id
      key
      status
      processed_at
      error_messages
      num_vendors
      num_payments
      num_success
      num_failed
      createdAt
      filename
      supplier_vendor_paidol_ids
      referenced_vendors
      invoice_ids
      invoice_spx_ids
      priority_status
      priority_file_id
      priority_process_on
      priority_response
      updatedAt
      __typename
    }
    buyer_paidol_id
    paidol_vendor_id
    paidol_vendor {
      id
      user_vendor_id
      is_migration
      paidol_id
      vendor_paidol_id
      priority_active
      payment_terms
      priority_account_balance
      contact_name
      priority_billing_code
      priority_repeate_code
      priority_group_code
      email_addresses
      priority_document_delivery
      priority_regular_inv
      priority_summary_inv
      foreign_name
      remarks
      box_1099
      form_code_1099
      remark_1
      priority_response
      cron_status
      priority_status
      priority_supplier_id
      virtual_card_email
      achEnabled
      virtualCardEnabled
      checkIssuingEnabled
      checkIssuingPayableTo
      checkIssuingStreet
      checkIssuingCity
      checkIssuingState
      checkIssuingCountry
      checkIssuingPostalCode
      createdAt
      updatedAt
      __typename
    }
    supplier_paidol_id
    supplier_paidol {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    user_invoice_id
    date
    balance_due {
      value
      currency
      __typename
    }
    createdAt
    updatedAt
    transaction_id
    priority_payment_id
    priority_payment_status
    priority_payment_type
    priority_payment_date
    priority_payment_auth_message
    priority_response
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInvoiceMutationVariables,
  APITypes.CreateInvoiceMutation
>;
export const updateInvoice = /* GraphQL */ `mutation UpdateInvoice(
  $input: UpdateInvoiceInput!
  $condition: ModelInvoiceConditionInput
) {
  updateInvoice(input: $input, condition: $condition) {
    id
    id_base58
    id_base58_short
    payment_file_queue_id
    payment_file {
      id
      user_id
      paidol_id
      key
      status
      processed_at
      error_messages
      num_vendors
      num_payments
      num_success
      num_failed
      createdAt
      filename
      supplier_vendor_paidol_ids
      referenced_vendors
      invoice_ids
      invoice_spx_ids
      priority_status
      priority_file_id
      priority_process_on
      priority_response
      updatedAt
      __typename
    }
    buyer_paidol_id
    paidol_vendor_id
    paidol_vendor {
      id
      user_vendor_id
      is_migration
      paidol_id
      vendor_paidol_id
      priority_active
      payment_terms
      priority_account_balance
      contact_name
      priority_billing_code
      priority_repeate_code
      priority_group_code
      email_addresses
      priority_document_delivery
      priority_regular_inv
      priority_summary_inv
      foreign_name
      remarks
      box_1099
      form_code_1099
      remark_1
      priority_response
      cron_status
      priority_status
      priority_supplier_id
      virtual_card_email
      achEnabled
      virtualCardEnabled
      checkIssuingEnabled
      checkIssuingPayableTo
      checkIssuingStreet
      checkIssuingCity
      checkIssuingState
      checkIssuingCountry
      checkIssuingPostalCode
      createdAt
      updatedAt
      __typename
    }
    supplier_paidol_id
    supplier_paidol {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    user_invoice_id
    date
    balance_due {
      value
      currency
      __typename
    }
    createdAt
    updatedAt
    transaction_id
    priority_payment_id
    priority_payment_status
    priority_payment_type
    priority_payment_date
    priority_payment_auth_message
    priority_response
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateInvoiceMutationVariables,
  APITypes.UpdateInvoiceMutation
>;
export const deleteInvoice = /* GraphQL */ `mutation DeleteInvoice(
  $input: DeleteInvoiceInput!
  $condition: ModelInvoiceConditionInput
) {
  deleteInvoice(input: $input, condition: $condition) {
    id
    id_base58
    id_base58_short
    payment_file_queue_id
    payment_file {
      id
      user_id
      paidol_id
      key
      status
      processed_at
      error_messages
      num_vendors
      num_payments
      num_success
      num_failed
      createdAt
      filename
      supplier_vendor_paidol_ids
      referenced_vendors
      invoice_ids
      invoice_spx_ids
      priority_status
      priority_file_id
      priority_process_on
      priority_response
      updatedAt
      __typename
    }
    buyer_paidol_id
    paidol_vendor_id
    paidol_vendor {
      id
      user_vendor_id
      is_migration
      paidol_id
      vendor_paidol_id
      priority_active
      payment_terms
      priority_account_balance
      contact_name
      priority_billing_code
      priority_repeate_code
      priority_group_code
      email_addresses
      priority_document_delivery
      priority_regular_inv
      priority_summary_inv
      foreign_name
      remarks
      box_1099
      form_code_1099
      remark_1
      priority_response
      cron_status
      priority_status
      priority_supplier_id
      virtual_card_email
      achEnabled
      virtualCardEnabled
      checkIssuingEnabled
      checkIssuingPayableTo
      checkIssuingStreet
      checkIssuingCity
      checkIssuingState
      checkIssuingCountry
      checkIssuingPostalCode
      createdAt
      updatedAt
      __typename
    }
    supplier_paidol_id
    supplier_paidol {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    user_invoice_id
    date
    balance_due {
      value
      currency
      __typename
    }
    createdAt
    updatedAt
    transaction_id
    priority_payment_id
    priority_payment_status
    priority_payment_type
    priority_payment_date
    priority_payment_auth_message
    priority_response
    status
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteInvoiceMutationVariables,
  APITypes.DeleteInvoiceMutation
>;
export const createSupplierFileQueue = /* GraphQL */ `mutation CreateSupplierFileQueue(
  $input: CreateSupplierFileQueueInput!
  $condition: ModelSupplierFileQueueConditionInput
) {
  createSupplierFileQueue(input: $input, condition: $condition) {
    id
    user_id
    user {
      id
      username
      email
      first_name
      middle_name
      last_name
      suffix
      picture
      is_speedster
      birthdate
      address
      phone_number
      phone_extension
      password_updated_at
      finicityCustomerId
      dwollaCustomerId
      is_support
      deletedAt
      createdAt
      updatedAt
      __typename
    }
    paidol_id
    paidol {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    key
    status
    processed_at
    error_messages
    num_vendors
    num_success
    num_failed
    createdAt
    is_migration
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSupplierFileQueueMutationVariables,
  APITypes.CreateSupplierFileQueueMutation
>;
export const updateSupplierFileQueue = /* GraphQL */ `mutation UpdateSupplierFileQueue(
  $input: UpdateSupplierFileQueueInput!
  $condition: ModelSupplierFileQueueConditionInput
) {
  updateSupplierFileQueue(input: $input, condition: $condition) {
    id
    user_id
    user {
      id
      username
      email
      first_name
      middle_name
      last_name
      suffix
      picture
      is_speedster
      birthdate
      address
      phone_number
      phone_extension
      password_updated_at
      finicityCustomerId
      dwollaCustomerId
      is_support
      deletedAt
      createdAt
      updatedAt
      __typename
    }
    paidol_id
    paidol {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    key
    status
    processed_at
    error_messages
    num_vendors
    num_success
    num_failed
    createdAt
    is_migration
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSupplierFileQueueMutationVariables,
  APITypes.UpdateSupplierFileQueueMutation
>;
export const deleteSupplierFileQueue = /* GraphQL */ `mutation DeleteSupplierFileQueue(
  $input: DeleteSupplierFileQueueInput!
  $condition: ModelSupplierFileQueueConditionInput
) {
  deleteSupplierFileQueue(input: $input, condition: $condition) {
    id
    user_id
    user {
      id
      username
      email
      first_name
      middle_name
      last_name
      suffix
      picture
      is_speedster
      birthdate
      address
      phone_number
      phone_extension
      password_updated_at
      finicityCustomerId
      dwollaCustomerId
      is_support
      deletedAt
      createdAt
      updatedAt
      __typename
    }
    paidol_id
    paidol {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    key
    status
    processed_at
    error_messages
    num_vendors
    num_success
    num_failed
    createdAt
    is_migration
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSupplierFileQueueMutationVariables,
  APITypes.DeleteSupplierFileQueueMutation
>;
export const createPaymentStatusDownload = /* GraphQL */ `mutation CreatePaymentStatusDownload(
  $input: CreatePaymentStatusDownloadInput!
  $condition: ModelPaymentStatusDownloadConditionInput
) {
  createPaymentStatusDownload(input: $input, condition: $condition) {
    id
    user_id
    paidol_id
    start_date
    end_date
    s3_key
    cron_status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePaymentStatusDownloadMutationVariables,
  APITypes.CreatePaymentStatusDownloadMutation
>;
export const updatePaymentStatusDownload = /* GraphQL */ `mutation UpdatePaymentStatusDownload(
  $input: UpdatePaymentStatusDownloadInput!
  $condition: ModelPaymentStatusDownloadConditionInput
) {
  updatePaymentStatusDownload(input: $input, condition: $condition) {
    id
    user_id
    paidol_id
    start_date
    end_date
    s3_key
    cron_status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePaymentStatusDownloadMutationVariables,
  APITypes.UpdatePaymentStatusDownloadMutation
>;
export const deletePaymentStatusDownload = /* GraphQL */ `mutation DeletePaymentStatusDownload(
  $input: DeletePaymentStatusDownloadInput!
  $condition: ModelPaymentStatusDownloadConditionInput
) {
  deletePaymentStatusDownload(input: $input, condition: $condition) {
    id
    user_id
    paidol_id
    start_date
    end_date
    s3_key
    cron_status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeletePaymentStatusDownloadMutationVariables,
  APITypes.DeletePaymentStatusDownloadMutation
>;
export const updatePaidolHighnoteIntegration = /* GraphQL */ `mutation UpdatePaidolHighnoteIntegration(
  $input: UpdatePaidolHighnoteIntegrationInput!
  $condition: ModelPaidolHighnoteIntegrationConditionInput
) {
  updatePaidolHighnoteIntegration(input: $input, condition: $condition) {
    id
    paidolId
    userId
    legalBusinessName
    businessAccountHolderId
    primaryAuthorizedPersonId
    financialAccountId
    externalFinancialBankAccountId
    hasInitialFunding
    accountHolderCardProductApplicationId
    isApplicationAccepted
    isDisconnected
    highnoteProductId
    highnoteProduct {
      id
      type
      isActive
      createdAt
      updatedAt
      __typename
    }
    finicityCustomerId
    dwollaCustomerId
    cardProfileId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePaidolHighnoteIntegrationMutationVariables,
  APITypes.UpdatePaidolHighnoteIntegrationMutation
>;
export const createHighnotePaymentCard = /* GraphQL */ `mutation CreateHighnotePaymentCard(
  $input: CreateHighnotePaymentCardInput!
  $condition: ModelHighnotePaymentCardConditionInput
) {
  createHighnotePaymentCard(input: $input, condition: $condition) {
    paymentCardId
    paidolId
    authPaidolId
    paidolUsers {
      nextToken
      __typename
    }
    name
    cardGroupId
    group {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    status
    bin
    last4
    network
    formFactor
    expirationDate
    budget {
      __typename
    }
    hasPin
    procoreEmployee {
      id
      name
      email_address
      __typename
    }
    cardholderId
    cardholder {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    cardholderName
    isAdminLocked
    lastActionByRole
    lastActionByPaidolUserId
    lastActionByName
    lastActionByEmail
    lastActionAt
    merchantSpendRuleId
    isAuthorizedUserCard
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHighnotePaymentCardMutationVariables,
  APITypes.CreateHighnotePaymentCardMutation
>;
export const updateHighnotePaymentCard = /* GraphQL */ `mutation UpdateHighnotePaymentCard(
  $input: UpdateHighnotePaymentCardInput!
  $condition: ModelHighnotePaymentCardConditionInput
) {
  updateHighnotePaymentCard(input: $input, condition: $condition) {
    paymentCardId
    paidolId
    authPaidolId
    paidolUsers {
      nextToken
      __typename
    }
    name
    cardGroupId
    group {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    status
    bin
    last4
    network
    formFactor
    expirationDate
    budget {
      __typename
    }
    hasPin
    procoreEmployee {
      id
      name
      email_address
      __typename
    }
    cardholderId
    cardholder {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    cardholderName
    isAdminLocked
    lastActionByRole
    lastActionByPaidolUserId
    lastActionByName
    lastActionByEmail
    lastActionAt
    merchantSpendRuleId
    isAuthorizedUserCard
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateHighnotePaymentCardMutationVariables,
  APITypes.UpdateHighnotePaymentCardMutation
>;
export const deleteHighnotePaymentCard = /* GraphQL */ `mutation DeleteHighnotePaymentCard(
  $input: DeleteHighnotePaymentCardInput!
  $condition: ModelHighnotePaymentCardConditionInput
) {
  deleteHighnotePaymentCard(input: $input, condition: $condition) {
    paymentCardId
    paidolId
    authPaidolId
    paidolUsers {
      nextToken
      __typename
    }
    name
    cardGroupId
    group {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    status
    bin
    last4
    network
    formFactor
    expirationDate
    budget {
      __typename
    }
    hasPin
    procoreEmployee {
      id
      name
      email_address
      __typename
    }
    cardholderId
    cardholder {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    cardholderName
    isAdminLocked
    lastActionByRole
    lastActionByPaidolUserId
    lastActionByName
    lastActionByEmail
    lastActionAt
    merchantSpendRuleId
    isAuthorizedUserCard
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteHighnotePaymentCardMutationVariables,
  APITypes.DeleteHighnotePaymentCardMutation
>;
export const createSpendRules = /* GraphQL */ `mutation CreateSpendRules(
  $input: CreateSpendRulesInput!
  $condition: ModelSpendRulesConditionInput
) {
  createSpendRules(input: $input, condition: $condition) {
    spendRuleId
    paidolId
    authPaidolId
    name
    maximumAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    merchantCategoryAllowed
    merchantCategoryBlocked
    merchantCountryAllowed
    merchantCountryBlocked
    streetAddressAllowed
    streetAddressBlocked
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSpendRulesMutationVariables,
  APITypes.CreateSpendRulesMutation
>;
export const updateSpendRules = /* GraphQL */ `mutation UpdateSpendRules(
  $input: UpdateSpendRulesInput!
  $condition: ModelSpendRulesConditionInput
) {
  updateSpendRules(input: $input, condition: $condition) {
    spendRuleId
    paidolId
    authPaidolId
    name
    maximumAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    merchantCategoryAllowed
    merchantCategoryBlocked
    merchantCountryAllowed
    merchantCountryBlocked
    streetAddressAllowed
    streetAddressBlocked
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSpendRulesMutationVariables,
  APITypes.UpdateSpendRulesMutation
>;
export const deleteSpendRules = /* GraphQL */ `mutation DeleteSpendRules(
  $input: DeleteSpendRulesInput!
  $condition: ModelSpendRulesConditionInput
) {
  deleteSpendRules(input: $input, condition: $condition) {
    spendRuleId
    paidolId
    authPaidolId
    name
    maximumAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    merchantCategoryAllowed
    merchantCategoryBlocked
    merchantCountryAllowed
    merchantCountryBlocked
    streetAddressAllowed
    streetAddressBlocked
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSpendRulesMutationVariables,
  APITypes.DeleteSpendRulesMutation
>;
export const createVelocityRules = /* GraphQL */ `mutation CreateVelocityRules(
  $input: CreateVelocityRulesInput!
  $condition: ModelVelocityRulesConditionInput
) {
  createVelocityRules(input: $input, condition: $condition) {
    velocityRuleId
    paidolId
    authPaidolId
    name
    maximumAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    cumulativeRuleId
    monthlyLimitResetTimestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateVelocityRulesMutationVariables,
  APITypes.CreateVelocityRulesMutation
>;
export const updateVelocityRules = /* GraphQL */ `mutation UpdateVelocityRules(
  $input: UpdateVelocityRulesInput!
  $condition: ModelVelocityRulesConditionInput
) {
  updateVelocityRules(input: $input, condition: $condition) {
    velocityRuleId
    paidolId
    authPaidolId
    name
    maximumAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    cumulativeRuleId
    monthlyLimitResetTimestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateVelocityRulesMutationVariables,
  APITypes.UpdateVelocityRulesMutation
>;
export const deleteVelocityRules = /* GraphQL */ `mutation DeleteVelocityRules(
  $input: DeleteVelocityRulesInput!
  $condition: ModelVelocityRulesConditionInput
) {
  deleteVelocityRules(input: $input, condition: $condition) {
    velocityRuleId
    paidolId
    authPaidolId
    name
    maximumAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    cumulativeRuleId
    monthlyLimitResetTimestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteVelocityRulesMutationVariables,
  APITypes.DeleteVelocityRulesMutation
>;
export const createReceiptSummaryField = /* GraphQL */ `mutation CreateReceiptSummaryField(
  $input: CreateReceiptSummaryFieldInput!
  $condition: ModelReceiptSummaryFieldConditionInput
) {
  createReceiptSummaryField(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    receiptUploadId
    type
    typeConfidenceScore
    label
    labelConfidenceScore
    value
    valueConfidenceScore
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReceiptSummaryFieldMutationVariables,
  APITypes.CreateReceiptSummaryFieldMutation
>;
export const updateReceiptSummaryField = /* GraphQL */ `mutation UpdateReceiptSummaryField(
  $input: UpdateReceiptSummaryFieldInput!
  $condition: ModelReceiptSummaryFieldConditionInput
) {
  updateReceiptSummaryField(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    receiptUploadId
    type
    typeConfidenceScore
    label
    labelConfidenceScore
    value
    valueConfidenceScore
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReceiptSummaryFieldMutationVariables,
  APITypes.UpdateReceiptSummaryFieldMutation
>;
export const deleteReceiptSummaryField = /* GraphQL */ `mutation DeleteReceiptSummaryField(
  $input: DeleteReceiptSummaryFieldInput!
  $condition: ModelReceiptSummaryFieldConditionInput
) {
  deleteReceiptSummaryField(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    receiptUploadId
    type
    typeConfidenceScore
    label
    labelConfidenceScore
    value
    valueConfidenceScore
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteReceiptSummaryFieldMutationVariables,
  APITypes.DeleteReceiptSummaryFieldMutation
>;
export const createReceiptLineItem = /* GraphQL */ `mutation CreateReceiptLineItem(
  $input: CreateReceiptLineItemInput!
  $condition: ModelReceiptLineItemConditionInput
) {
  createReceiptLineItem(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    receiptUploadId
    lineItemFields {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReceiptLineItemMutationVariables,
  APITypes.CreateReceiptLineItemMutation
>;
export const updateReceiptLineItem = /* GraphQL */ `mutation UpdateReceiptLineItem(
  $input: UpdateReceiptLineItemInput!
  $condition: ModelReceiptLineItemConditionInput
) {
  updateReceiptLineItem(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    receiptUploadId
    lineItemFields {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReceiptLineItemMutationVariables,
  APITypes.UpdateReceiptLineItemMutation
>;
export const deleteReceiptLineItem = /* GraphQL */ `mutation DeleteReceiptLineItem(
  $input: DeleteReceiptLineItemInput!
  $condition: ModelReceiptLineItemConditionInput
) {
  deleteReceiptLineItem(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    receiptUploadId
    lineItemFields {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteReceiptLineItemMutationVariables,
  APITypes.DeleteReceiptLineItemMutation
>;
export const createReceiptLineItemField = /* GraphQL */ `mutation CreateReceiptLineItemField(
  $input: CreateReceiptLineItemFieldInput!
  $condition: ModelReceiptLineItemFieldConditionInput
) {
  createReceiptLineItemField(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    receiptLineItemId
    type
    typeConfidenceScore
    label
    labelConfidenceScore
    value
    valueConfidenceScore
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReceiptLineItemFieldMutationVariables,
  APITypes.CreateReceiptLineItemFieldMutation
>;
export const updateReceiptLineItemField = /* GraphQL */ `mutation UpdateReceiptLineItemField(
  $input: UpdateReceiptLineItemFieldInput!
  $condition: ModelReceiptLineItemFieldConditionInput
) {
  updateReceiptLineItemField(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    receiptLineItemId
    type
    typeConfidenceScore
    label
    labelConfidenceScore
    value
    valueConfidenceScore
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReceiptLineItemFieldMutationVariables,
  APITypes.UpdateReceiptLineItemFieldMutation
>;
export const deleteReceiptLineItemField = /* GraphQL */ `mutation DeleteReceiptLineItemField(
  $input: DeleteReceiptLineItemFieldInput!
  $condition: ModelReceiptLineItemFieldConditionInput
) {
  deleteReceiptLineItemField(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    receiptLineItemId
    type
    typeConfidenceScore
    label
    labelConfidenceScore
    value
    valueConfidenceScore
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteReceiptLineItemFieldMutationVariables,
  APITypes.DeleteReceiptLineItemFieldMutation
>;
export const createReceiptUpload = /* GraphQL */ `mutation CreateReceiptUpload(
  $input: CreateReceiptUploadInput!
  $condition: ModelReceiptUploadConditionInput
) {
  createReceiptUpload(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    document
    status
    summaryFields {
      nextToken
      __typename
    }
    lineItems {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReceiptUploadMutationVariables,
  APITypes.CreateReceiptUploadMutation
>;
export const updateReceiptUpload = /* GraphQL */ `mutation UpdateReceiptUpload(
  $input: UpdateReceiptUploadInput!
  $condition: ModelReceiptUploadConditionInput
) {
  updateReceiptUpload(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    document
    status
    summaryFields {
      nextToken
      __typename
    }
    lineItems {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReceiptUploadMutationVariables,
  APITypes.UpdateReceiptUploadMutation
>;
export const deleteReceiptUpload = /* GraphQL */ `mutation DeleteReceiptUpload(
  $input: DeleteReceiptUploadInput!
  $condition: ModelReceiptUploadConditionInput
) {
  deleteReceiptUpload(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    document
    status
    summaryFields {
      nextToken
      __typename
    }
    lineItems {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteReceiptUploadMutationVariables,
  APITypes.DeleteReceiptUploadMutation
>;
export const createTransactionToReceiptUpload = /* GraphQL */ `mutation CreateTransactionToReceiptUpload(
  $input: CreateTransactionToReceiptUploadInput!
  $condition: ModelTransactionToReceiptUploadConditionInput
) {
  createTransactionToReceiptUpload(input: $input, condition: $condition) {
    id
    highnoteTransactionEventId
    reimbursementTransactionId
    receiptUploadId
    receiptUpload {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    createdAt
    authPaidolId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTransactionToReceiptUploadMutationVariables,
  APITypes.CreateTransactionToReceiptUploadMutation
>;
export const updateTransactionToReceiptUpload = /* GraphQL */ `mutation UpdateTransactionToReceiptUpload(
  $input: UpdateTransactionToReceiptUploadInput!
  $condition: ModelTransactionToReceiptUploadConditionInput
) {
  updateTransactionToReceiptUpload(input: $input, condition: $condition) {
    id
    highnoteTransactionEventId
    reimbursementTransactionId
    receiptUploadId
    receiptUpload {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    createdAt
    authPaidolId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTransactionToReceiptUploadMutationVariables,
  APITypes.UpdateTransactionToReceiptUploadMutation
>;
export const deleteTransactionToReceiptUpload = /* GraphQL */ `mutation DeleteTransactionToReceiptUpload(
  $input: DeleteTransactionToReceiptUploadInput!
  $condition: ModelTransactionToReceiptUploadConditionInput
) {
  deleteTransactionToReceiptUpload(input: $input, condition: $condition) {
    id
    highnoteTransactionEventId
    reimbursementTransactionId
    receiptUploadId
    receiptUpload {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    createdAt
    authPaidolId
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTransactionToReceiptUploadMutationVariables,
  APITypes.DeleteTransactionToReceiptUploadMutation
>;
export const createTransaction = /* GraphQL */ `mutation CreateTransaction(
  $input: CreateTransactionInput!
  $condition: ModelTransactionConditionInput
) {
  createTransaction(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    transactionDate
    reimbursementTransactionId
    reimbursementTransaction {
      id
      paidolId
      authPaidolId
      dwollaTransferId
      transactionDate
      status
      checkrunStatus
      note
      contestNote
      deniedNote
      merchantName
      receiptLineItems
      jobCodeId
      reimbursementDate
      decisionDate
      reviewedByPaidolUserId
      reviewedByName
      reviewedByRole
      reviewedAt
      paidolUserId
      transactionType
      expenseTypeId
      receiptId
      procoreProjectId
      procoreWBSCodeId
      agaveGlCodeId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveVendorId
      agaveSubJobId
      agaveLocationId
      agaveDepartmentId
      agaveSubaccountId
      agaveEmployeeId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      flexGlCodeId
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexVendorId
      createdAt
      updatedAt
      __typename
    }
    highnoteTransactionId
    highnoteTransaction {
      transactionId
      paymentCardId
      paidolId
      authPaidolId
      cardGroupId
      status
      transactionDate
      merchantName
      merchantCategoryCode
      merchantCategory
      transactionEvents
      note
      jobCodeId
      procoreCompanyId
      procoreProjectId
      procoreWBSCodeId
      procoreDirectCostId
      procoreDirectCostLineItemId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveExpenseId
      agaveVendorId
      agaveGlCodeId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      receiptPath
      receiptId
      erpApprovalStatus
      erpBypassStatus
      last4
      userId
      email
      approvedAmountValue
      approvedAmountCurrencyCode
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      selectedCodingOption
      agaveGlCostTypeId
      flexCodeTransactionStatus
      approveWithoutNotes
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTransactionMutationVariables,
  APITypes.CreateTransactionMutation
>;
export const updateTransaction = /* GraphQL */ `mutation UpdateTransaction(
  $input: UpdateTransactionInput!
  $condition: ModelTransactionConditionInput
) {
  updateTransaction(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    transactionDate
    reimbursementTransactionId
    reimbursementTransaction {
      id
      paidolId
      authPaidolId
      dwollaTransferId
      transactionDate
      status
      checkrunStatus
      note
      contestNote
      deniedNote
      merchantName
      receiptLineItems
      jobCodeId
      reimbursementDate
      decisionDate
      reviewedByPaidolUserId
      reviewedByName
      reviewedByRole
      reviewedAt
      paidolUserId
      transactionType
      expenseTypeId
      receiptId
      procoreProjectId
      procoreWBSCodeId
      agaveGlCodeId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveVendorId
      agaveSubJobId
      agaveLocationId
      agaveDepartmentId
      agaveSubaccountId
      agaveEmployeeId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      flexGlCodeId
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexVendorId
      createdAt
      updatedAt
      __typename
    }
    highnoteTransactionId
    highnoteTransaction {
      transactionId
      paymentCardId
      paidolId
      authPaidolId
      cardGroupId
      status
      transactionDate
      merchantName
      merchantCategoryCode
      merchantCategory
      transactionEvents
      note
      jobCodeId
      procoreCompanyId
      procoreProjectId
      procoreWBSCodeId
      procoreDirectCostId
      procoreDirectCostLineItemId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveExpenseId
      agaveVendorId
      agaveGlCodeId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      receiptPath
      receiptId
      erpApprovalStatus
      erpBypassStatus
      last4
      userId
      email
      approvedAmountValue
      approvedAmountCurrencyCode
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      selectedCodingOption
      agaveGlCostTypeId
      flexCodeTransactionStatus
      approveWithoutNotes
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTransactionMutationVariables,
  APITypes.UpdateTransactionMutation
>;
export const deleteTransaction = /* GraphQL */ `mutation DeleteTransaction(
  $input: DeleteTransactionInput!
  $condition: ModelTransactionConditionInput
) {
  deleteTransaction(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    transactionDate
    reimbursementTransactionId
    reimbursementTransaction {
      id
      paidolId
      authPaidolId
      dwollaTransferId
      transactionDate
      status
      checkrunStatus
      note
      contestNote
      deniedNote
      merchantName
      receiptLineItems
      jobCodeId
      reimbursementDate
      decisionDate
      reviewedByPaidolUserId
      reviewedByName
      reviewedByRole
      reviewedAt
      paidolUserId
      transactionType
      expenseTypeId
      receiptId
      procoreProjectId
      procoreWBSCodeId
      agaveGlCodeId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveVendorId
      agaveSubJobId
      agaveLocationId
      agaveDepartmentId
      agaveSubaccountId
      agaveEmployeeId
      agaveEquipmentId
      agaveEmCostCodeId
      agaveEmCostTypeId
      codingType
      accountingDate
      flexGlCodeId
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexVendorId
      createdAt
      updatedAt
      __typename
    }
    highnoteTransactionId
    highnoteTransaction {
      transactionId
      paymentCardId
      paidolId
      authPaidolId
      cardGroupId
      status
      transactionDate
      merchantName
      merchantCategoryCode
      merchantCategory
      transactionEvents
      note
      jobCodeId
      procoreCompanyId
      procoreProjectId
      procoreWBSCodeId
      procoreDirectCostId
      procoreDirectCostLineItemId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveExpenseId
      agaveVendorId
      agaveGlCodeId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      receiptPath
      receiptId
      erpApprovalStatus
      erpBypassStatus
      last4
      userId
      email
      approvedAmountValue
      approvedAmountCurrencyCode
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      selectedCodingOption
      agaveGlCostTypeId
      flexCodeTransactionStatus
      approveWithoutNotes
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTransactionMutationVariables,
  APITypes.DeleteTransactionMutation
>;
export const createReimbursementTransaction = /* GraphQL */ `mutation CreateReimbursementTransaction(
  $input: CreateReimbursementTransactionInput!
  $condition: ModelReimbursementTransactionConditionInput
) {
  createReimbursementTransaction(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    dwollaTransferId
    transactionDate
    amount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    status
    checkrunStatus
    note
    contestNote
    deniedNote
    merchantName
    receiptLineItems
    jobCodeId
    jobCode {
      id
      paidolId
      authPaidolId
      description
      code
      isActive
      budget
      jobCodeImportId
      createdAt
      updatedAt
      __typename
    }
    reimbursementDate
    decisionDate
    reviewedByPaidolUserId
    reviewedByName
    reviewedByRole
    reviewedAt
    paidolUserId
    paidolUser {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    transactionType
    expenseTypeId
    expenseType {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    receiptId
    receipt {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    procoreProjectId
    procoreProject {
      id
      active
      display_name
      name
      created_at
      start_date
      completion_date
      project_number
      total_value
      __typename
    }
    procoreWBSCodeId
    procoreWBSCode {
      id
      flat_code
      flat_name
      description
      status
      __typename
    }
    agaveGlCodeId
    agaveGlCode {
      id
      paidolId
      authPaidolId
      source_id
      classification
      currency_code
      current_balance
      description
      name
      number
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveProjectId
    agaveProject {
      id
      paidolId
      authPaidolId
      source_id
      amount
      completion_date
      name
      number
      start_date
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveCostCodeId
    agaveCostCode {
      id
      paidolId
      authPaidolId
      asset_account_id
      source_id
      formatted_full_code
      code
      full_code
      cost_unit_of_measure
      description
      expense_account_id
      income_account_id
      name
      parent_id
      project_id
      price_unit_of_measure
      source_create_time
      source_update_time
      status
      type
      unit_cost
      unit_price
      vendor_id
      sub_job_id
      createdAt
      updatedAt
      projectId
      paidolProject
      projectIds
      cost_type_ids
      fullName
      __typename
    }
    agaveCostTypeId
    agaveCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      project_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      paidolProject
      __typename
    }
    agaveVendorId
    agaveVendor {
      id
      paidolId
      authPaidolId
      source_id
      code
      email
      fax
      name
      phone
      status
      tax_number
      terms
      type
      website
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      __typename
    }
    agaveSubJobId
    agaveSubJob {
      id
      agaveSubJobId
      paidolId
      authPaidolId
      source_id
      name
      number
      code
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      fullName
      cost_code_ids
      __typename
    }
    agaveLocationId
    agaveLocation {
      id
      paidolId
      authPaidolId
      name
      fullName
      parent_id
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveDepartmentId
    agaveDepartment {
      id
      paidolId
      authPaidolId
      code
      name
      fullName
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveSubaccountId
    agaveSubaccount {
      id
      paidolId
      authPaidolId
      code
      name
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveEmployeeId
    agaveEmployee {
      id
      paidolId
      authPaidolId
      name
      fullName
      firstName
      lastName
      email
      status
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveEquipmentId
    agaveEquipment {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCo
      category
      department
      status
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostCodeId
    agaveEmCostCode {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCostTypeCodes
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostTypeId
    agaveEmCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      abbreviation
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    codingType
    accountingDate
    flexGlCodeId
    flexGlCode {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCodeId
    flexCode {
      id
      paidolId
      authPaidolId
      projectName
      projectCode
      isActive
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostCodeId
    flexCostCode {
      id
      paidolId
      authPaidolId
      code
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostTypeId
    flexCostType {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexVendorId
    flexVendor {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReimbursementTransactionMutationVariables,
  APITypes.CreateReimbursementTransactionMutation
>;
export const updateReimbursementTransaction = /* GraphQL */ `mutation UpdateReimbursementTransaction(
  $input: UpdateReimbursementTransactionInput!
  $condition: ModelReimbursementTransactionConditionInput
) {
  updateReimbursementTransaction(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    dwollaTransferId
    transactionDate
    amount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    status
    checkrunStatus
    note
    contestNote
    deniedNote
    merchantName
    receiptLineItems
    jobCodeId
    jobCode {
      id
      paidolId
      authPaidolId
      description
      code
      isActive
      budget
      jobCodeImportId
      createdAt
      updatedAt
      __typename
    }
    reimbursementDate
    decisionDate
    reviewedByPaidolUserId
    reviewedByName
    reviewedByRole
    reviewedAt
    paidolUserId
    paidolUser {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    transactionType
    expenseTypeId
    expenseType {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    receiptId
    receipt {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    procoreProjectId
    procoreProject {
      id
      active
      display_name
      name
      created_at
      start_date
      completion_date
      project_number
      total_value
      __typename
    }
    procoreWBSCodeId
    procoreWBSCode {
      id
      flat_code
      flat_name
      description
      status
      __typename
    }
    agaveGlCodeId
    agaveGlCode {
      id
      paidolId
      authPaidolId
      source_id
      classification
      currency_code
      current_balance
      description
      name
      number
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveProjectId
    agaveProject {
      id
      paidolId
      authPaidolId
      source_id
      amount
      completion_date
      name
      number
      start_date
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveCostCodeId
    agaveCostCode {
      id
      paidolId
      authPaidolId
      asset_account_id
      source_id
      formatted_full_code
      code
      full_code
      cost_unit_of_measure
      description
      expense_account_id
      income_account_id
      name
      parent_id
      project_id
      price_unit_of_measure
      source_create_time
      source_update_time
      status
      type
      unit_cost
      unit_price
      vendor_id
      sub_job_id
      createdAt
      updatedAt
      projectId
      paidolProject
      projectIds
      cost_type_ids
      fullName
      __typename
    }
    agaveCostTypeId
    agaveCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      project_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      paidolProject
      __typename
    }
    agaveVendorId
    agaveVendor {
      id
      paidolId
      authPaidolId
      source_id
      code
      email
      fax
      name
      phone
      status
      tax_number
      terms
      type
      website
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      __typename
    }
    agaveSubJobId
    agaveSubJob {
      id
      agaveSubJobId
      paidolId
      authPaidolId
      source_id
      name
      number
      code
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      fullName
      cost_code_ids
      __typename
    }
    agaveLocationId
    agaveLocation {
      id
      paidolId
      authPaidolId
      name
      fullName
      parent_id
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveDepartmentId
    agaveDepartment {
      id
      paidolId
      authPaidolId
      code
      name
      fullName
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveSubaccountId
    agaveSubaccount {
      id
      paidolId
      authPaidolId
      code
      name
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveEmployeeId
    agaveEmployee {
      id
      paidolId
      authPaidolId
      name
      fullName
      firstName
      lastName
      email
      status
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveEquipmentId
    agaveEquipment {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCo
      category
      department
      status
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostCodeId
    agaveEmCostCode {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCostTypeCodes
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostTypeId
    agaveEmCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      abbreviation
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    codingType
    accountingDate
    flexGlCodeId
    flexGlCode {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCodeId
    flexCode {
      id
      paidolId
      authPaidolId
      projectName
      projectCode
      isActive
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostCodeId
    flexCostCode {
      id
      paidolId
      authPaidolId
      code
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostTypeId
    flexCostType {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexVendorId
    flexVendor {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateReimbursementTransactionMutationVariables,
  APITypes.UpdateReimbursementTransactionMutation
>;
export const deleteReimbursementTransaction = /* GraphQL */ `mutation DeleteReimbursementTransaction(
  $input: DeleteReimbursementTransactionInput!
  $condition: ModelReimbursementTransactionConditionInput
) {
  deleteReimbursementTransaction(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    dwollaTransferId
    transactionDate
    amount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    status
    checkrunStatus
    note
    contestNote
    deniedNote
    merchantName
    receiptLineItems
    jobCodeId
    jobCode {
      id
      paidolId
      authPaidolId
      description
      code
      isActive
      budget
      jobCodeImportId
      createdAt
      updatedAt
      __typename
    }
    reimbursementDate
    decisionDate
    reviewedByPaidolUserId
    reviewedByName
    reviewedByRole
    reviewedAt
    paidolUserId
    paidolUser {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    transactionType
    expenseTypeId
    expenseType {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    receiptId
    receipt {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    procoreProjectId
    procoreProject {
      id
      active
      display_name
      name
      created_at
      start_date
      completion_date
      project_number
      total_value
      __typename
    }
    procoreWBSCodeId
    procoreWBSCode {
      id
      flat_code
      flat_name
      description
      status
      __typename
    }
    agaveGlCodeId
    agaveGlCode {
      id
      paidolId
      authPaidolId
      source_id
      classification
      currency_code
      current_balance
      description
      name
      number
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveProjectId
    agaveProject {
      id
      paidolId
      authPaidolId
      source_id
      amount
      completion_date
      name
      number
      start_date
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveCostCodeId
    agaveCostCode {
      id
      paidolId
      authPaidolId
      asset_account_id
      source_id
      formatted_full_code
      code
      full_code
      cost_unit_of_measure
      description
      expense_account_id
      income_account_id
      name
      parent_id
      project_id
      price_unit_of_measure
      source_create_time
      source_update_time
      status
      type
      unit_cost
      unit_price
      vendor_id
      sub_job_id
      createdAt
      updatedAt
      projectId
      paidolProject
      projectIds
      cost_type_ids
      fullName
      __typename
    }
    agaveCostTypeId
    agaveCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      project_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      paidolProject
      __typename
    }
    agaveVendorId
    agaveVendor {
      id
      paidolId
      authPaidolId
      source_id
      code
      email
      fax
      name
      phone
      status
      tax_number
      terms
      type
      website
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      __typename
    }
    agaveSubJobId
    agaveSubJob {
      id
      agaveSubJobId
      paidolId
      authPaidolId
      source_id
      name
      number
      code
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      fullName
      cost_code_ids
      __typename
    }
    agaveLocationId
    agaveLocation {
      id
      paidolId
      authPaidolId
      name
      fullName
      parent_id
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveDepartmentId
    agaveDepartment {
      id
      paidolId
      authPaidolId
      code
      name
      fullName
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveSubaccountId
    agaveSubaccount {
      id
      paidolId
      authPaidolId
      code
      name
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveEmployeeId
    agaveEmployee {
      id
      paidolId
      authPaidolId
      name
      fullName
      firstName
      lastName
      email
      status
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveEquipmentId
    agaveEquipment {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCo
      category
      department
      status
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostCodeId
    agaveEmCostCode {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCostTypeCodes
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostTypeId
    agaveEmCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      abbreviation
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    codingType
    accountingDate
    flexGlCodeId
    flexGlCode {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCodeId
    flexCode {
      id
      paidolId
      authPaidolId
      projectName
      projectCode
      isActive
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostCodeId
    flexCostCode {
      id
      paidolId
      authPaidolId
      code
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostTypeId
    flexCostType {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexVendorId
    flexVendor {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteReimbursementTransactionMutationVariables,
  APITypes.DeleteReimbursementTransactionMutation
>;
export const createProjectGroup = /* GraphQL */ `mutation CreateProjectGroup(
  $input: CreateProjectGroupInput!
  $condition: ModelProjectGroupConditionInput
) {
  createProjectGroup(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    groupProjects
    paymentCards {
      nextToken
      __typename
    }
    monthlyBudget {
      value
      currency
      __typename
    }
    isMonthlyBudgetUnlimited
    spendGroupId
    spendGroup {
      id
      paidolId
      authPaidolId
      name
      paymentCards
      merchantCountrySpendRuleId
      merchantCategorySpendRuleId
      amountLimitSpendRuleId
      monthlyLimitSpendRuleId
      monthlyLimitCumulativeRuleId
      merchantCategoryAllowed
      merchantCategoryBlocked
      merchantCountryAllowed
      merchantCountryBlocked
      monthlyLimitResetTimestamp
      createdAt
      updatedAt
      __typename
    }
    monthlyBudgetSpend {
      nextToken
      __typename
    }
    transactions {
      nextToken
      __typename
    }
    groupAdmins {
      nextToken
      __typename
    }
    deletedAt
    glCodeVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    projectVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    hasReviewers
    spentThisMonth {
      amount
      yearAndMonth
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProjectGroupMutationVariables,
  APITypes.CreateProjectGroupMutation
>;
export const updateProjectGroup = /* GraphQL */ `mutation UpdateProjectGroup(
  $input: UpdateProjectGroupInput!
  $condition: ModelProjectGroupConditionInput
) {
  updateProjectGroup(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    groupProjects
    paymentCards {
      nextToken
      __typename
    }
    monthlyBudget {
      value
      currency
      __typename
    }
    isMonthlyBudgetUnlimited
    spendGroupId
    spendGroup {
      id
      paidolId
      authPaidolId
      name
      paymentCards
      merchantCountrySpendRuleId
      merchantCategorySpendRuleId
      amountLimitSpendRuleId
      monthlyLimitSpendRuleId
      monthlyLimitCumulativeRuleId
      merchantCategoryAllowed
      merchantCategoryBlocked
      merchantCountryAllowed
      merchantCountryBlocked
      monthlyLimitResetTimestamp
      createdAt
      updatedAt
      __typename
    }
    monthlyBudgetSpend {
      nextToken
      __typename
    }
    transactions {
      nextToken
      __typename
    }
    groupAdmins {
      nextToken
      __typename
    }
    deletedAt
    glCodeVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    projectVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    hasReviewers
    spentThisMonth {
      amount
      yearAndMonth
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProjectGroupMutationVariables,
  APITypes.UpdateProjectGroupMutation
>;
export const deleteProjectGroup = /* GraphQL */ `mutation DeleteProjectGroup(
  $input: DeleteProjectGroupInput!
  $condition: ModelProjectGroupConditionInput
) {
  deleteProjectGroup(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    groupProjects
    paymentCards {
      nextToken
      __typename
    }
    monthlyBudget {
      value
      currency
      __typename
    }
    isMonthlyBudgetUnlimited
    spendGroupId
    spendGroup {
      id
      paidolId
      authPaidolId
      name
      paymentCards
      merchantCountrySpendRuleId
      merchantCategorySpendRuleId
      amountLimitSpendRuleId
      monthlyLimitSpendRuleId
      monthlyLimitCumulativeRuleId
      merchantCategoryAllowed
      merchantCategoryBlocked
      merchantCountryAllowed
      merchantCountryBlocked
      monthlyLimitResetTimestamp
      createdAt
      updatedAt
      __typename
    }
    monthlyBudgetSpend {
      nextToken
      __typename
    }
    transactions {
      nextToken
      __typename
    }
    groupAdmins {
      nextToken
      __typename
    }
    deletedAt
    glCodeVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    projectVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    hasReviewers
    spentThisMonth {
      amount
      yearAndMonth
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProjectGroupMutationVariables,
  APITypes.DeleteProjectGroupMutation
>;
export const createCardGroup = /* GraphQL */ `mutation CreateCardGroup(
  $input: CreateCardGroupInput!
  $condition: ModelCardGroupConditionInput
) {
  createCardGroup(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    groupProjects
    paymentCards {
      nextToken
      __typename
    }
    monthlyBudget {
      value
      currency
      __typename
    }
    isMonthlyBudgetUnlimited
    spendGroupId
    spendGroup {
      id
      paidolId
      authPaidolId
      name
      paymentCards
      merchantCountrySpendRuleId
      merchantCategorySpendRuleId
      amountLimitSpendRuleId
      monthlyLimitSpendRuleId
      monthlyLimitCumulativeRuleId
      merchantCategoryAllowed
      merchantCategoryBlocked
      merchantCountryAllowed
      merchantCountryBlocked
      monthlyLimitResetTimestamp
      createdAt
      updatedAt
      __typename
    }
    monthlyBudgetSpend {
      nextToken
      __typename
    }
    transactions {
      nextToken
      __typename
    }
    groupAdmins {
      nextToken
      __typename
    }
    deletedAt
    glCodeVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    projectVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    hasReviewers
    spentThisMonth {
      amount
      yearAndMonth
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCardGroupMutationVariables,
  APITypes.CreateCardGroupMutation
>;
export const updateCardGroup = /* GraphQL */ `mutation UpdateCardGroup(
  $input: UpdateCardGroupInput!
  $condition: ModelCardGroupConditionInput
) {
  updateCardGroup(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    groupProjects
    paymentCards {
      nextToken
      __typename
    }
    monthlyBudget {
      value
      currency
      __typename
    }
    isMonthlyBudgetUnlimited
    spendGroupId
    spendGroup {
      id
      paidolId
      authPaidolId
      name
      paymentCards
      merchantCountrySpendRuleId
      merchantCategorySpendRuleId
      amountLimitSpendRuleId
      monthlyLimitSpendRuleId
      monthlyLimitCumulativeRuleId
      merchantCategoryAllowed
      merchantCategoryBlocked
      merchantCountryAllowed
      merchantCountryBlocked
      monthlyLimitResetTimestamp
      createdAt
      updatedAt
      __typename
    }
    monthlyBudgetSpend {
      nextToken
      __typename
    }
    transactions {
      nextToken
      __typename
    }
    groupAdmins {
      nextToken
      __typename
    }
    deletedAt
    glCodeVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    projectVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    hasReviewers
    spentThisMonth {
      amount
      yearAndMonth
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCardGroupMutationVariables,
  APITypes.UpdateCardGroupMutation
>;
export const deleteCardGroup = /* GraphQL */ `mutation DeleteCardGroup(
  $input: DeleteCardGroupInput!
  $condition: ModelCardGroupConditionInput
) {
  deleteCardGroup(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    groupProjects
    paymentCards {
      nextToken
      __typename
    }
    monthlyBudget {
      value
      currency
      __typename
    }
    isMonthlyBudgetUnlimited
    spendGroupId
    spendGroup {
      id
      paidolId
      authPaidolId
      name
      paymentCards
      merchantCountrySpendRuleId
      merchantCategorySpendRuleId
      amountLimitSpendRuleId
      monthlyLimitSpendRuleId
      monthlyLimitCumulativeRuleId
      merchantCategoryAllowed
      merchantCategoryBlocked
      merchantCountryAllowed
      merchantCountryBlocked
      monthlyLimitResetTimestamp
      createdAt
      updatedAt
      __typename
    }
    monthlyBudgetSpend {
      nextToken
      __typename
    }
    transactions {
      nextToken
      __typename
    }
    groupAdmins {
      nextToken
      __typename
    }
    deletedAt
    glCodeVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    projectVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    hasReviewers
    spentThisMonth {
      amount
      yearAndMonth
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCardGroupMutationVariables,
  APITypes.DeleteCardGroupMutation
>;
export const createUserNotificationPreferences = /* GraphQL */ `mutation CreateUserNotificationPreferences(
  $input: CreateUserNotificationPreferencesInput!
  $condition: ModelUserNotificationPreferencesConditionInput
) {
  createUserNotificationPreferences(input: $input, condition: $condition) {
    id
    userId
    paidolId
    transactionAlertSms
    transactionAlertEmail
    cardLockedSms
    cardLockedEmail
    manualCardActionSms
    manualCardActionEmail
    lowBalanceAlertSms
    lowBalanceAlertEmail
    cardActivationSms
    cardActivationEmail
    statementReadySms
    statementReadyEmail
    txnReviewFrequency
    txnReviewCodeUpdateSms
    txnReviewCodeUpdateEmail
    txnReviewNoteUpdateSms
    txnReviewNoteUpdateEmail
    txnReviewReceiptUpdateSms
    txnReviewReceiptUpdateEmail
    txnReviewResubmissionSms
    txnReviewResubmissionEmail
    txnReviewReadySms
    txnReviewReadyEmail
    returnedTransactionSms
    returnedTransactionEmail
    smsConsentAccepted
    smsConsentAcceptedAt
    platformAgreementVersion
    hasReceivedWelcomeSms
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserNotificationPreferencesMutationVariables,
  APITypes.CreateUserNotificationPreferencesMutation
>;
export const updateUserNotificationPreferences = /* GraphQL */ `mutation UpdateUserNotificationPreferences(
  $input: UpdateUserNotificationPreferencesInput!
  $condition: ModelUserNotificationPreferencesConditionInput
) {
  updateUserNotificationPreferences(input: $input, condition: $condition) {
    id
    userId
    paidolId
    transactionAlertSms
    transactionAlertEmail
    cardLockedSms
    cardLockedEmail
    manualCardActionSms
    manualCardActionEmail
    lowBalanceAlertSms
    lowBalanceAlertEmail
    cardActivationSms
    cardActivationEmail
    statementReadySms
    statementReadyEmail
    txnReviewFrequency
    txnReviewCodeUpdateSms
    txnReviewCodeUpdateEmail
    txnReviewNoteUpdateSms
    txnReviewNoteUpdateEmail
    txnReviewReceiptUpdateSms
    txnReviewReceiptUpdateEmail
    txnReviewResubmissionSms
    txnReviewResubmissionEmail
    txnReviewReadySms
    txnReviewReadyEmail
    returnedTransactionSms
    returnedTransactionEmail
    smsConsentAccepted
    smsConsentAcceptedAt
    platformAgreementVersion
    hasReceivedWelcomeSms
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserNotificationPreferencesMutationVariables,
  APITypes.UpdateUserNotificationPreferencesMutation
>;
export const createMerchantSpendRule = /* GraphQL */ `mutation CreateMerchantSpendRule(
  $input: CreateMerchantSpendRuleInput!
  $condition: ModelMerchantSpendRuleConditionInput
) {
  createMerchantSpendRule(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    paymentCards
    merchantCountrySpendRuleId
    merchantCategorySpendRuleId
    amountLimitSpendRuleId
    monthlyLimitSpendRuleId
    monthlyLimitCumulativeRuleId
    maximumAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    monthlyLimitAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    merchantCategoryAllowed
    merchantCategoryBlocked
    merchantCountryAllowed
    merchantCountryBlocked
    monthlyLimitResetTimestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateMerchantSpendRuleMutationVariables,
  APITypes.CreateMerchantSpendRuleMutation
>;
export const updateMerchantSpendRule = /* GraphQL */ `mutation UpdateMerchantSpendRule(
  $input: UpdateMerchantSpendRuleInput!
  $condition: ModelMerchantSpendRuleConditionInput
) {
  updateMerchantSpendRule(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    paymentCards
    merchantCountrySpendRuleId
    merchantCategorySpendRuleId
    amountLimitSpendRuleId
    monthlyLimitSpendRuleId
    monthlyLimitCumulativeRuleId
    maximumAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    monthlyLimitAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    merchantCategoryAllowed
    merchantCategoryBlocked
    merchantCountryAllowed
    merchantCountryBlocked
    monthlyLimitResetTimestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateMerchantSpendRuleMutationVariables,
  APITypes.UpdateMerchantSpendRuleMutation
>;
export const deleteMerchantSpendRule = /* GraphQL */ `mutation DeleteMerchantSpendRule(
  $input: DeleteMerchantSpendRuleInput!
  $condition: ModelMerchantSpendRuleConditionInput
) {
  deleteMerchantSpendRule(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    paymentCards
    merchantCountrySpendRuleId
    merchantCategorySpendRuleId
    amountLimitSpendRuleId
    monthlyLimitSpendRuleId
    monthlyLimitCumulativeRuleId
    maximumAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    monthlyLimitAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    merchantCategoryAllowed
    merchantCategoryBlocked
    merchantCountryAllowed
    merchantCountryBlocked
    monthlyLimitResetTimestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteMerchantSpendRuleMutationVariables,
  APITypes.DeleteMerchantSpendRuleMutation
>;
export const createTransactionsDownloadQueue = /* GraphQL */ `mutation CreateTransactionsDownloadQueue(
  $input: CreateTransactionsDownloadQueueInput!
  $condition: ModelTransactionsDownloadQueueConditionInput
) {
  createTransactionsDownloadQueue(input: $input, condition: $condition) {
    id
    user_id
    paidol_id
    range_option
    start_date
    end_date
    columns
    s3_key
    cron_status
    createdAt
    paidolUserId
    mark_as_exported
    exported_count
    skipped_count
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTransactionsDownloadQueueMutationVariables,
  APITypes.CreateTransactionsDownloadQueueMutation
>;
export const updateTransactionsDownloadQueue = /* GraphQL */ `mutation UpdateTransactionsDownloadQueue(
  $input: UpdateTransactionsDownloadQueueInput!
  $condition: ModelTransactionsDownloadQueueConditionInput
) {
  updateTransactionsDownloadQueue(input: $input, condition: $condition) {
    id
    user_id
    paidol_id
    range_option
    start_date
    end_date
    columns
    s3_key
    cron_status
    createdAt
    paidolUserId
    mark_as_exported
    exported_count
    skipped_count
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTransactionsDownloadQueueMutationVariables,
  APITypes.UpdateTransactionsDownloadQueueMutation
>;
export const deleteTransactionsDownloadQueue = /* GraphQL */ `mutation DeleteTransactionsDownloadQueue(
  $input: DeleteTransactionsDownloadQueueInput!
  $condition: ModelTransactionsDownloadQueueConditionInput
) {
  deleteTransactionsDownloadQueue(input: $input, condition: $condition) {
    id
    user_id
    paidol_id
    range_option
    start_date
    end_date
    columns
    s3_key
    cron_status
    createdAt
    paidolUserId
    mark_as_exported
    exported_count
    skipped_count
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTransactionsDownloadQueueMutationVariables,
  APITypes.DeleteTransactionsDownloadQueueMutation
>;
export const createTransactionsReceiptsDownloadQueue = /* GraphQL */ `mutation CreateTransactionsReceiptsDownloadQueue(
  $input: CreateTransactionsReceiptsDownloadQueueInput!
  $condition: ModelTransactionsReceiptsDownloadQueueConditionInput
) {
  createTransactionsReceiptsDownloadQueue(
    input: $input
    condition: $condition
  ) {
    id
    user_id
    paidol_id
    paidolUserId
    s3_key
    range_option
    start_date
    end_date
    cron_status
    error_code
    createdAt
    filteredTransactionIds
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTransactionsReceiptsDownloadQueueMutationVariables,
  APITypes.CreateTransactionsReceiptsDownloadQueueMutation
>;
export const updateTransactionsReceiptsDownloadQueue = /* GraphQL */ `mutation UpdateTransactionsReceiptsDownloadQueue(
  $input: UpdateTransactionsReceiptsDownloadQueueInput!
  $condition: ModelTransactionsReceiptsDownloadQueueConditionInput
) {
  updateTransactionsReceiptsDownloadQueue(
    input: $input
    condition: $condition
  ) {
    id
    user_id
    paidol_id
    paidolUserId
    s3_key
    range_option
    start_date
    end_date
    cron_status
    error_code
    createdAt
    filteredTransactionIds
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTransactionsReceiptsDownloadQueueMutationVariables,
  APITypes.UpdateTransactionsReceiptsDownloadQueueMutation
>;
export const deleteTransactionsReceiptsDownloadQueue = /* GraphQL */ `mutation DeleteTransactionsReceiptsDownloadQueue(
  $input: DeleteTransactionsReceiptsDownloadQueueInput!
  $condition: ModelTransactionsReceiptsDownloadQueueConditionInput
) {
  deleteTransactionsReceiptsDownloadQueue(
    input: $input
    condition: $condition
  ) {
    id
    user_id
    paidol_id
    paidolUserId
    s3_key
    range_option
    start_date
    end_date
    cron_status
    error_code
    createdAt
    filteredTransactionIds
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTransactionsReceiptsDownloadQueueMutationVariables,
  APITypes.DeleteTransactionsReceiptsDownloadQueueMutation
>;
export const createSpendRuleConfig = /* GraphQL */ `mutation CreateSpendRuleConfig(
  $input: CreateSpendRuleConfigInput!
  $condition: ModelSpendRuleConfigConditionInput
) {
  createSpendRuleConfig(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    ruleId
    ruleType
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSpendRuleConfigMutationVariables,
  APITypes.CreateSpendRuleConfigMutation
>;
export const updateSpendRuleConfig = /* GraphQL */ `mutation UpdateSpendRuleConfig(
  $input: UpdateSpendRuleConfigInput!
  $condition: ModelSpendRuleConfigConditionInput
) {
  updateSpendRuleConfig(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    ruleId
    ruleType
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSpendRuleConfigMutationVariables,
  APITypes.UpdateSpendRuleConfigMutation
>;
export const deleteSpendRuleConfig = /* GraphQL */ `mutation DeleteSpendRuleConfig(
  $input: DeleteSpendRuleConfigInput!
  $condition: ModelSpendRuleConfigConditionInput
) {
  deleteSpendRuleConfig(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    ruleId
    ruleType
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSpendRuleConfigMutationVariables,
  APITypes.DeleteSpendRuleConfigMutation
>;
export const createJobCodeImport = /* GraphQL */ `mutation CreateJobCodeImport(
  $input: CreateJobCodeImportInput!
  $condition: ModelJobCodeImportConditionInput
) {
  createJobCodeImport(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    createdAt
    storageFileKey
    fileName
    status
    errors
    jobCodes {
      nextToken
      __typename
    }
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateJobCodeImportMutationVariables,
  APITypes.CreateJobCodeImportMutation
>;
export const updateJobCodeImport = /* GraphQL */ `mutation UpdateJobCodeImport(
  $input: UpdateJobCodeImportInput!
  $condition: ModelJobCodeImportConditionInput
) {
  updateJobCodeImport(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    createdAt
    storageFileKey
    fileName
    status
    errors
    jobCodes {
      nextToken
      __typename
    }
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateJobCodeImportMutationVariables,
  APITypes.UpdateJobCodeImportMutation
>;
export const deleteJobCodeImport = /* GraphQL */ `mutation DeleteJobCodeImport(
  $input: DeleteJobCodeImportInput!
  $condition: ModelJobCodeImportConditionInput
) {
  deleteJobCodeImport(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    createdAt
    storageFileKey
    fileName
    status
    errors
    jobCodes {
      nextToken
      __typename
    }
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteJobCodeImportMutationVariables,
  APITypes.DeleteJobCodeImportMutation
>;
export const createJobCode = /* GraphQL */ `mutation CreateJobCode(
  $input: CreateJobCodeInput!
  $condition: ModelJobCodeConditionInput
) {
  createJobCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    description
    code
    isActive
    budget
    jobCodeImportId
    jobCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      storageFileKey
      fileName
      status
      errors
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateJobCodeMutationVariables,
  APITypes.CreateJobCodeMutation
>;
export const updateJobCode = /* GraphQL */ `mutation UpdateJobCode(
  $input: UpdateJobCodeInput!
  $condition: ModelJobCodeConditionInput
) {
  updateJobCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    description
    code
    isActive
    budget
    jobCodeImportId
    jobCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      storageFileKey
      fileName
      status
      errors
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateJobCodeMutationVariables,
  APITypes.UpdateJobCodeMutation
>;
export const deleteJobCode = /* GraphQL */ `mutation DeleteJobCode(
  $input: DeleteJobCodeInput!
  $condition: ModelJobCodeConditionInput
) {
  deleteJobCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    description
    code
    isActive
    budget
    jobCodeImportId
    jobCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      storageFileKey
      fileName
      status
      errors
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteJobCodeMutationVariables,
  APITypes.DeleteJobCodeMutation
>;
export const createFlexCodeImport = /* GraphQL */ `mutation CreateFlexCodeImport(
  $input: CreateFlexCodeImportInput!
  $condition: ModelFlexCodeImportConditionInput
) {
  createFlexCodeImport(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    createdAt
    updatedAt
    storageFileKey
    fileName
    status
    errors
    searchSynced
    flexCodes {
      nextToken
      __typename
    }
    type
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFlexCodeImportMutationVariables,
  APITypes.CreateFlexCodeImportMutation
>;
export const updateFlexCodeImport = /* GraphQL */ `mutation UpdateFlexCodeImport(
  $input: UpdateFlexCodeImportInput!
  $condition: ModelFlexCodeImportConditionInput
) {
  updateFlexCodeImport(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    createdAt
    updatedAt
    storageFileKey
    fileName
    status
    errors
    searchSynced
    flexCodes {
      nextToken
      __typename
    }
    type
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFlexCodeImportMutationVariables,
  APITypes.UpdateFlexCodeImportMutation
>;
export const deleteFlexCodeImport = /* GraphQL */ `mutation DeleteFlexCodeImport(
  $input: DeleteFlexCodeImportInput!
  $condition: ModelFlexCodeImportConditionInput
) {
  deleteFlexCodeImport(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    createdAt
    updatedAt
    storageFileKey
    fileName
    status
    errors
    searchSynced
    flexCodes {
      nextToken
      __typename
    }
    type
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFlexCodeImportMutationVariables,
  APITypes.DeleteFlexCodeImportMutation
>;
export const createV2FlexRelationships = /* GraphQL */ `mutation CreateV2FlexRelationships(
  $input: CreateV2FlexRelationshipsInput!
  $condition: ModelV2FlexRelationshipsConditionInput
) {
  createV2FlexRelationships(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    flexGlCodeId
    flexCodeId
    flexCostCodeId
    flexCostTypeId
    flexVendorId
    flexCodeImportId
    flexGlCodeName
    projectName
    projectCode
    flexCostCodeName
    flexCostTypeName
    flexVendorName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateV2FlexRelationshipsMutationVariables,
  APITypes.CreateV2FlexRelationshipsMutation
>;
export const updateV2FlexRelationships = /* GraphQL */ `mutation UpdateV2FlexRelationships(
  $input: UpdateV2FlexRelationshipsInput!
  $condition: ModelV2FlexRelationshipsConditionInput
) {
  updateV2FlexRelationships(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    flexGlCodeId
    flexCodeId
    flexCostCodeId
    flexCostTypeId
    flexVendorId
    flexCodeImportId
    flexGlCodeName
    projectName
    projectCode
    flexCostCodeName
    flexCostTypeName
    flexVendorName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateV2FlexRelationshipsMutationVariables,
  APITypes.UpdateV2FlexRelationshipsMutation
>;
export const deleteV2FlexRelationships = /* GraphQL */ `mutation DeleteV2FlexRelationships(
  $input: DeleteV2FlexRelationshipsInput!
  $condition: ModelV2FlexRelationshipsConditionInput
) {
  deleteV2FlexRelationships(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    flexGlCodeId
    flexCodeId
    flexCostCodeId
    flexCostTypeId
    flexVendorId
    flexCodeImportId
    flexGlCodeName
    projectName
    projectCode
    flexCostCodeName
    flexCostTypeName
    flexVendorName
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteV2FlexRelationshipsMutationVariables,
  APITypes.DeleteV2FlexRelationshipsMutation
>;
export const createFlexGlCode = /* GraphQL */ `mutation CreateFlexGlCode(
  $input: CreateFlexGlCodeInput!
  $condition: ModelFlexGlCodeConditionInput
) {
  createFlexGlCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFlexGlCodeMutationVariables,
  APITypes.CreateFlexGlCodeMutation
>;
export const updateFlexGlCode = /* GraphQL */ `mutation UpdateFlexGlCode(
  $input: UpdateFlexGlCodeInput!
  $condition: ModelFlexGlCodeConditionInput
) {
  updateFlexGlCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFlexGlCodeMutationVariables,
  APITypes.UpdateFlexGlCodeMutation
>;
export const deleteFlexGlCode = /* GraphQL */ `mutation DeleteFlexGlCode(
  $input: DeleteFlexGlCodeInput!
  $condition: ModelFlexGlCodeConditionInput
) {
  deleteFlexGlCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFlexGlCodeMutationVariables,
  APITypes.DeleteFlexGlCodeMutation
>;
export const createFlexCode = /* GraphQL */ `mutation CreateFlexCode(
  $input: CreateFlexCodeInput!
  $condition: ModelFlexCodeConditionInput
) {
  createFlexCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    projectName
    projectCode
    isActive
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFlexCodeMutationVariables,
  APITypes.CreateFlexCodeMutation
>;
export const updateFlexCode = /* GraphQL */ `mutation UpdateFlexCode(
  $input: UpdateFlexCodeInput!
  $condition: ModelFlexCodeConditionInput
) {
  updateFlexCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    projectName
    projectCode
    isActive
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFlexCodeMutationVariables,
  APITypes.UpdateFlexCodeMutation
>;
export const deleteFlexCode = /* GraphQL */ `mutation DeleteFlexCode(
  $input: DeleteFlexCodeInput!
  $condition: ModelFlexCodeConditionInput
) {
  deleteFlexCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    projectName
    projectCode
    isActive
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFlexCodeMutationVariables,
  APITypes.DeleteFlexCodeMutation
>;
export const createFlexCostCode = /* GraphQL */ `mutation CreateFlexCostCode(
  $input: CreateFlexCostCodeInput!
  $condition: ModelFlexCostCodeConditionInput
) {
  createFlexCostCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    code
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFlexCostCodeMutationVariables,
  APITypes.CreateFlexCostCodeMutation
>;
export const updateFlexCostCode = /* GraphQL */ `mutation UpdateFlexCostCode(
  $input: UpdateFlexCostCodeInput!
  $condition: ModelFlexCostCodeConditionInput
) {
  updateFlexCostCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    code
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFlexCostCodeMutationVariables,
  APITypes.UpdateFlexCostCodeMutation
>;
export const deleteFlexCostCode = /* GraphQL */ `mutation DeleteFlexCostCode(
  $input: DeleteFlexCostCodeInput!
  $condition: ModelFlexCostCodeConditionInput
) {
  deleteFlexCostCode(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    code
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFlexCostCodeMutationVariables,
  APITypes.DeleteFlexCostCodeMutation
>;
export const createFlexCostType = /* GraphQL */ `mutation CreateFlexCostType(
  $input: CreateFlexCostTypeInput!
  $condition: ModelFlexCostTypeConditionInput
) {
  createFlexCostType(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFlexCostTypeMutationVariables,
  APITypes.CreateFlexCostTypeMutation
>;
export const updateFlexCostType = /* GraphQL */ `mutation UpdateFlexCostType(
  $input: UpdateFlexCostTypeInput!
  $condition: ModelFlexCostTypeConditionInput
) {
  updateFlexCostType(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFlexCostTypeMutationVariables,
  APITypes.UpdateFlexCostTypeMutation
>;
export const deleteFlexCostType = /* GraphQL */ `mutation DeleteFlexCostType(
  $input: DeleteFlexCostTypeInput!
  $condition: ModelFlexCostTypeConditionInput
) {
  deleteFlexCostType(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFlexCostTypeMutationVariables,
  APITypes.DeleteFlexCostTypeMutation
>;
export const createFlexVendor = /* GraphQL */ `mutation CreateFlexVendor(
  $input: CreateFlexVendorInput!
  $condition: ModelFlexVendorConditionInput
) {
  createFlexVendor(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFlexVendorMutationVariables,
  APITypes.CreateFlexVendorMutation
>;
export const updateFlexVendor = /* GraphQL */ `mutation UpdateFlexVendor(
  $input: UpdateFlexVendorInput!
  $condition: ModelFlexVendorConditionInput
) {
  updateFlexVendor(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFlexVendorMutationVariables,
  APITypes.UpdateFlexVendorMutation
>;
export const deleteFlexVendor = /* GraphQL */ `mutation DeleteFlexVendor(
  $input: DeleteFlexVendorInput!
  $condition: ModelFlexVendorConditionInput
) {
  deleteFlexVendor(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    flexCodeImportId
    flexCodeImport {
      id
      paidolId
      authPaidolId
      createdAt
      updatedAt
      storageFileKey
      fileName
      status
      errors
      searchSynced
      type
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFlexVendorMutationVariables,
  APITypes.DeleteFlexVendorMutation
>;
export const createFlexField = /* GraphQL */ `mutation CreateFlexField(
  $input: CreateFlexFieldInput!
  $condition: ModelFlexFieldConditionInput
) {
  createFlexField(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    alias
    order
    source
    createdBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFlexFieldMutationVariables,
  APITypes.CreateFlexFieldMutation
>;
export const updateFlexField = /* GraphQL */ `mutation UpdateFlexField(
  $input: UpdateFlexFieldInput!
  $condition: ModelFlexFieldConditionInput
) {
  updateFlexField(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    alias
    order
    source
    createdBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFlexFieldMutationVariables,
  APITypes.UpdateFlexFieldMutation
>;
export const deleteFlexField = /* GraphQL */ `mutation DeleteFlexField(
  $input: DeleteFlexFieldInput!
  $condition: ModelFlexFieldConditionInput
) {
  deleteFlexField(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    name
    alias
    order
    source
    createdBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFlexFieldMutationVariables,
  APITypes.DeleteFlexFieldMutation
>;
export const createFlexFieldValue = /* GraphQL */ `mutation CreateFlexFieldValue(
  $input: CreateFlexFieldValueInput!
  $condition: ModelFlexFieldValueConditionInput
) {
  createFlexFieldValue(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    flexFieldId
    externalId
    value
    status
    flexFieldUploadId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFlexFieldValueMutationVariables,
  APITypes.CreateFlexFieldValueMutation
>;
export const updateFlexFieldValue = /* GraphQL */ `mutation UpdateFlexFieldValue(
  $input: UpdateFlexFieldValueInput!
  $condition: ModelFlexFieldValueConditionInput
) {
  updateFlexFieldValue(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    flexFieldId
    externalId
    value
    status
    flexFieldUploadId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFlexFieldValueMutationVariables,
  APITypes.UpdateFlexFieldValueMutation
>;
export const deleteFlexFieldValue = /* GraphQL */ `mutation DeleteFlexFieldValue(
  $input: DeleteFlexFieldValueInput!
  $condition: ModelFlexFieldValueConditionInput
) {
  deleteFlexFieldValue(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    flexFieldId
    externalId
    value
    status
    flexFieldUploadId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFlexFieldValueMutationVariables,
  APITypes.DeleteFlexFieldValueMutation
>;
export const createFlexFieldUpload = /* GraphQL */ `mutation CreateFlexFieldUpload(
  $input: CreateFlexFieldUploadInput!
  $condition: ModelFlexFieldUploadConditionInput
) {
  createFlexFieldUpload(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    flexFieldId
    storageFileKey
    fileName
    status
    errors
    rowCount
    createdBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFlexFieldUploadMutationVariables,
  APITypes.CreateFlexFieldUploadMutation
>;
export const updateFlexFieldUpload = /* GraphQL */ `mutation UpdateFlexFieldUpload(
  $input: UpdateFlexFieldUploadInput!
  $condition: ModelFlexFieldUploadConditionInput
) {
  updateFlexFieldUpload(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    flexFieldId
    storageFileKey
    fileName
    status
    errors
    rowCount
    createdBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFlexFieldUploadMutationVariables,
  APITypes.UpdateFlexFieldUploadMutation
>;
export const deleteFlexFieldUpload = /* GraphQL */ `mutation DeleteFlexFieldUpload(
  $input: DeleteFlexFieldUploadInput!
  $condition: ModelFlexFieldUploadConditionInput
) {
  deleteFlexFieldUpload(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    flexFieldId
    storageFileKey
    fileName
    status
    errors
    rowCount
    createdBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteFlexFieldUploadMutationVariables,
  APITypes.DeleteFlexFieldUploadMutation
>;
export const createStatementSummary = /* GraphQL */ `mutation CreateStatementSummary(
  $input: CreateStatementSummaryInput!
  $condition: ModelStatementSummaryConditionInput
) {
  createStatementSummary(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    startDate
    endDate
    statementBalance
    paymentDueDate
    pdfLink
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStatementSummaryMutationVariables,
  APITypes.CreateStatementSummaryMutation
>;
export const updateStatementSummary = /* GraphQL */ `mutation UpdateStatementSummary(
  $input: UpdateStatementSummaryInput!
  $condition: ModelStatementSummaryConditionInput
) {
  updateStatementSummary(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    startDate
    endDate
    statementBalance
    paymentDueDate
    pdfLink
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateStatementSummaryMutationVariables,
  APITypes.UpdateStatementSummaryMutation
>;
export const deleteStatementSummary = /* GraphQL */ `mutation DeleteStatementSummary(
  $input: DeleteStatementSummaryInput!
  $condition: ModelStatementSummaryConditionInput
) {
  deleteStatementSummary(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    startDate
    endDate
    statementBalance
    paymentDueDate
    pdfLink
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteStatementSummaryMutationVariables,
  APITypes.DeleteStatementSummaryMutation
>;
export const createAutoPayment = /* GraphQL */ `mutation CreateAutoPayment(
  $input: CreateAutoPaymentInput!
  $condition: ModelAutoPaymentConditionInput
) {
  createAutoPayment(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    amountType
    fixedAmountCents
    paymentDayOfMonth
    externalBankAccountId
    financialAccountId
    active
    createdBy
    updatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAutoPaymentMutationVariables,
  APITypes.CreateAutoPaymentMutation
>;
export const updateAutoPayment = /* GraphQL */ `mutation UpdateAutoPayment(
  $input: UpdateAutoPaymentInput!
  $condition: ModelAutoPaymentConditionInput
) {
  updateAutoPayment(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    amountType
    fixedAmountCents
    paymentDayOfMonth
    externalBankAccountId
    financialAccountId
    active
    createdBy
    updatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAutoPaymentMutationVariables,
  APITypes.UpdateAutoPaymentMutation
>;
export const deleteAutoPayment = /* GraphQL */ `mutation DeleteAutoPayment(
  $input: DeleteAutoPaymentInput!
  $condition: ModelAutoPaymentConditionInput
) {
  deleteAutoPayment(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    amountType
    fixedAmountCents
    paymentDayOfMonth
    externalBankAccountId
    financialAccountId
    active
    createdBy
    updatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAutoPaymentMutationVariables,
  APITypes.DeleteAutoPaymentMutation
>;
export const createTransactionFilterOptions = /* GraphQL */ `mutation CreateTransactionFilterOptions(
  $input: CreateTransactionFilterOptionsInput!
  $condition: ModelTransactionFilterOptionsConditionInput
) {
  createTransactionFilterOptions(input: $input, condition: $condition) {
    paidolId
    authPaidolId
    last4
    userId {
      id
      label
      projectId
      __typename
    }
    merchantName {
      id
      label
      projectId
      __typename
    }
    merchantCategory {
      id
      label
      projectId
      __typename
    }
    cardGroup {
      id
      label
      projectId
      __typename
    }
    projectGroup {
      id
      label
      projectId
      __typename
    }
    receiptStatus {
      id
      label
      projectId
      __typename
    }
    highnoteTransactionStatus {
      id
      label
      projectId
      __typename
    }
    flexCodeTransactionStatus {
      id
      label
      projectId
      __typename
    }
    flexGlCodeIds {
      id
      label
      projectId
      __typename
    }
    flexCodeIds {
      id
      label
      projectId
      __typename
    }
    flexCostCodeIds {
      id
      label
      projectId
      __typename
    }
    flexCostTypeIds {
      id
      label
      projectId
      __typename
    }
    flexVendorIds {
      id
      label
      projectId
      __typename
    }
    agaveTransactionStatus {
      id
      label
      projectId
      __typename
    }
    agaveGlCodeIds {
      id
      label
      projectId
      __typename
    }
    agaveProjectIds {
      id
      label
      projectId
      __typename
    }
    agaveCostCodeIds {
      id
      label
      projectId
      __typename
    }
    agaveCostTypeIds {
      id
      label
      projectId
      __typename
    }
    agaveVendorIds {
      id
      label
      projectId
      __typename
    }
    agaveLocationIds {
      id
      label
      projectId
      __typename
    }
    agaveDepartmentIds {
      id
      label
      projectId
      __typename
    }
    agaveSubaccountIds {
      id
      label
      projectId
      __typename
    }
    agaveSubJobIds {
      id
      label
      projectId
      __typename
    }
    agaveEquipmentIds {
      id
      label
      projectId
      __typename
    }
    agaveEmCostCodeIds {
      id
      label
      projectId
      __typename
    }
    agaveEmCostTypeIds {
      id
      label
      projectId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTransactionFilterOptionsMutationVariables,
  APITypes.CreateTransactionFilterOptionsMutation
>;
export const updateTransactionFilterOptions = /* GraphQL */ `mutation UpdateTransactionFilterOptions(
  $input: UpdateTransactionFilterOptionsInput!
  $condition: ModelTransactionFilterOptionsConditionInput
) {
  updateTransactionFilterOptions(input: $input, condition: $condition) {
    paidolId
    authPaidolId
    last4
    userId {
      id
      label
      projectId
      __typename
    }
    merchantName {
      id
      label
      projectId
      __typename
    }
    merchantCategory {
      id
      label
      projectId
      __typename
    }
    cardGroup {
      id
      label
      projectId
      __typename
    }
    projectGroup {
      id
      label
      projectId
      __typename
    }
    receiptStatus {
      id
      label
      projectId
      __typename
    }
    highnoteTransactionStatus {
      id
      label
      projectId
      __typename
    }
    flexCodeTransactionStatus {
      id
      label
      projectId
      __typename
    }
    flexGlCodeIds {
      id
      label
      projectId
      __typename
    }
    flexCodeIds {
      id
      label
      projectId
      __typename
    }
    flexCostCodeIds {
      id
      label
      projectId
      __typename
    }
    flexCostTypeIds {
      id
      label
      projectId
      __typename
    }
    flexVendorIds {
      id
      label
      projectId
      __typename
    }
    agaveTransactionStatus {
      id
      label
      projectId
      __typename
    }
    agaveGlCodeIds {
      id
      label
      projectId
      __typename
    }
    agaveProjectIds {
      id
      label
      projectId
      __typename
    }
    agaveCostCodeIds {
      id
      label
      projectId
      __typename
    }
    agaveCostTypeIds {
      id
      label
      projectId
      __typename
    }
    agaveVendorIds {
      id
      label
      projectId
      __typename
    }
    agaveLocationIds {
      id
      label
      projectId
      __typename
    }
    agaveDepartmentIds {
      id
      label
      projectId
      __typename
    }
    agaveSubaccountIds {
      id
      label
      projectId
      __typename
    }
    agaveSubJobIds {
      id
      label
      projectId
      __typename
    }
    agaveEquipmentIds {
      id
      label
      projectId
      __typename
    }
    agaveEmCostCodeIds {
      id
      label
      projectId
      __typename
    }
    agaveEmCostTypeIds {
      id
      label
      projectId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTransactionFilterOptionsMutationVariables,
  APITypes.UpdateTransactionFilterOptionsMutation
>;
export const deleteTransactionFilterOptions = /* GraphQL */ `mutation DeleteTransactionFilterOptions(
  $input: DeleteTransactionFilterOptionsInput!
  $condition: ModelTransactionFilterOptionsConditionInput
) {
  deleteTransactionFilterOptions(input: $input, condition: $condition) {
    paidolId
    authPaidolId
    last4
    userId {
      id
      label
      projectId
      __typename
    }
    merchantName {
      id
      label
      projectId
      __typename
    }
    merchantCategory {
      id
      label
      projectId
      __typename
    }
    cardGroup {
      id
      label
      projectId
      __typename
    }
    projectGroup {
      id
      label
      projectId
      __typename
    }
    receiptStatus {
      id
      label
      projectId
      __typename
    }
    highnoteTransactionStatus {
      id
      label
      projectId
      __typename
    }
    flexCodeTransactionStatus {
      id
      label
      projectId
      __typename
    }
    flexGlCodeIds {
      id
      label
      projectId
      __typename
    }
    flexCodeIds {
      id
      label
      projectId
      __typename
    }
    flexCostCodeIds {
      id
      label
      projectId
      __typename
    }
    flexCostTypeIds {
      id
      label
      projectId
      __typename
    }
    flexVendorIds {
      id
      label
      projectId
      __typename
    }
    agaveTransactionStatus {
      id
      label
      projectId
      __typename
    }
    agaveGlCodeIds {
      id
      label
      projectId
      __typename
    }
    agaveProjectIds {
      id
      label
      projectId
      __typename
    }
    agaveCostCodeIds {
      id
      label
      projectId
      __typename
    }
    agaveCostTypeIds {
      id
      label
      projectId
      __typename
    }
    agaveVendorIds {
      id
      label
      projectId
      __typename
    }
    agaveLocationIds {
      id
      label
      projectId
      __typename
    }
    agaveDepartmentIds {
      id
      label
      projectId
      __typename
    }
    agaveSubaccountIds {
      id
      label
      projectId
      __typename
    }
    agaveSubJobIds {
      id
      label
      projectId
      __typename
    }
    agaveEquipmentIds {
      id
      label
      projectId
      __typename
    }
    agaveEmCostCodeIds {
      id
      label
      projectId
      __typename
    }
    agaveEmCostTypeIds {
      id
      label
      projectId
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTransactionFilterOptionsMutationVariables,
  APITypes.DeleteTransactionFilterOptionsMutation
>;
export const createHighnoteDisputeEvent = /* GraphQL */ `mutation CreateHighnoteDisputeEvent(
  $input: CreateHighnoteDisputeEventInput!
  $condition: ModelHighnoteDisputeEventConditionInput
) {
  createHighnoteDisputeEvent(input: $input, condition: $condition) {
    id
    disputeId
    paidolId
    paymentCardId
    transactionEventId
    amount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    enableListing
    status
    creditStatus
    category
    liability
    eventType
    eventDate
    source
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHighnoteDisputeEventMutationVariables,
  APITypes.CreateHighnoteDisputeEventMutation
>;
export const updateHighnoteDisputeEvent = /* GraphQL */ `mutation UpdateHighnoteDisputeEvent(
  $input: UpdateHighnoteDisputeEventInput!
  $condition: ModelHighnoteDisputeEventConditionInput
) {
  updateHighnoteDisputeEvent(input: $input, condition: $condition) {
    id
    disputeId
    paidolId
    paymentCardId
    transactionEventId
    amount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    enableListing
    status
    creditStatus
    category
    liability
    eventType
    eventDate
    source
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateHighnoteDisputeEventMutationVariables,
  APITypes.UpdateHighnoteDisputeEventMutation
>;
export const deleteHighnoteDisputeEvent = /* GraphQL */ `mutation DeleteHighnoteDisputeEvent(
  $input: DeleteHighnoteDisputeEventInput!
  $condition: ModelHighnoteDisputeEventConditionInput
) {
  deleteHighnoteDisputeEvent(input: $input, condition: $condition) {
    id
    disputeId
    paidolId
    paymentCardId
    transactionEventId
    amount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    enableListing
    status
    creditStatus
    category
    liability
    eventType
    eventDate
    source
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteHighnoteDisputeEventMutationVariables,
  APITypes.DeleteHighnoteDisputeEventMutation
>;
export const createHighnoteTransactionEvent = /* GraphQL */ `mutation CreateHighnoteTransactionEvent(
  $input: CreateHighnoteTransactionEventInput!
  $condition: ModelHighnoteTransactionEventConditionInput
) {
  createHighnoteTransactionEvent(input: $input, condition: $condition) {
    id
    transactionId
    transaction {
      transactionId
      paymentCardId
      paidolId
      authPaidolId
      cardGroupId
      status
      transactionDate
      merchantName
      merchantCategoryCode
      merchantCategory
      transactionEvents
      note
      jobCodeId
      procoreCompanyId
      procoreProjectId
      procoreWBSCodeId
      procoreDirectCostId
      procoreDirectCostLineItemId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveExpenseId
      agaveVendorId
      agaveGlCodeId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      receiptPath
      receiptId
      erpApprovalStatus
      erpBypassStatus
      last4
      userId
      email
      approvedAmountValue
      approvedAmountCurrencyCode
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      selectedCodingOption
      agaveGlCostTypeId
      flexCodeTransactionStatus
      approveWithoutNotes
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      createdAt
      updatedAt
      __typename
    }
    paymentCardId
    paymentCard {
      paymentCardId
      paidolId
      authPaidolId
      name
      cardGroupId
      status
      bin
      last4
      network
      formFactor
      expirationDate
      hasPin
      cardholderId
      cardholderName
      isAdminLocked
      lastActionByRole
      lastActionByPaidolUserId
      lastActionByName
      lastActionByEmail
      lastActionAt
      merchantSpendRuleId
      isAuthorizedUserCard
      createdAt
      updatedAt
      __typename
    }
    paidolId
    reconciliationId
    authPaidolId
    eventDate
    processedAt
    origin
    status
    partial
    settlementImpact
    approvedAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    fees {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    approvedAmountValue
    approvedAmountCurrencyCode
    eventData
    transactionOldState
    transactionNewState
    enableListing
    email
    userId
    user {
      id
      username
      email
      first_name
      middle_name
      last_name
      suffix
      picture
      is_speedster
      birthdate
      address
      phone_number
      phone_extension
      password_updated_at
      finicityCustomerId
      dwollaCustomerId
      is_support
      deletedAt
      createdAt
      updatedAt
      __typename
    }
    last4
    card {
      paymentCardId
      paidolId
      authPaidolId
      name
      cardGroupId
      status
      bin
      last4
      network
      formFactor
      expirationDate
      hasPin
      cardholderId
      cardholderName
      isAdminLocked
      lastActionByRole
      lastActionByPaidolUserId
      lastActionByName
      lastActionByEmail
      lastActionAt
      merchantSpendRuleId
      isAuthorizedUserCard
      createdAt
      updatedAt
      __typename
    }
    groupApprovalLevels
    owningProjectGroupIds
    cardGroupId
    cardGroup {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    merchantCategory
    merchantCategoryCode
    merchantName
    jobCodeId
    jobCode {
      id
      paidolId
      authPaidolId
      description
      code
      isActive
      budget
      jobCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCodeTransactionStatus
    workflowStatus
    returnedStatus
    flexCodeId
    flexCode {
      id
      paidolId
      authPaidolId
      projectName
      projectCode
      isActive
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostCodeId
    flexCostCode {
      id
      paidolId
      authPaidolId
      code
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostTypeId
    flexCostType {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexGlCodeId
    flexGlCode {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexVendorId
    flexVendor {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    agaveDepartment {
      id
      paidolId
      authPaidolId
      code
      name
      fullName
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveDepartmentId
    agaveLocation {
      id
      paidolId
      authPaidolId
      name
      fullName
      parent_id
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveLocationId
    agaveSubaccount {
      id
      paidolId
      authPaidolId
      code
      name
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveSubaccountId
    agaveEmployee {
      id
      paidolId
      authPaidolId
      name
      fullName
      firstName
      lastName
      email
      status
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveEmployeeId
    agaveExpense {
      id
      source_id
      amount
      amount_due
      ap_payment_ids
      batch
      batch_id
      creator_id
      currency_code
      description
      discount_amount
      discount_date
      due_date
      issue_date
      misc_amount
      net_amount
      number
      project_id
      retention_amount
      retention_percent
      status
      subtotal_amount
      tax_amount
      total_amount
      type
      vendor_id
      source_create_time
      source_update_time
      __typename
    }
    agaveExpenseId
    agaveProject {
      id
      paidolId
      authPaidolId
      source_id
      amount
      completion_date
      name
      number
      start_date
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveProjectId
    agaveCostCode {
      id
      paidolId
      authPaidolId
      asset_account_id
      source_id
      formatted_full_code
      code
      full_code
      cost_unit_of_measure
      description
      expense_account_id
      income_account_id
      name
      parent_id
      project_id
      price_unit_of_measure
      source_create_time
      source_update_time
      status
      type
      unit_cost
      unit_price
      vendor_id
      sub_job_id
      createdAt
      updatedAt
      projectId
      paidolProject
      projectIds
      cost_type_ids
      fullName
      __typename
    }
    agaveCostCodeId
    agaveCostTypeId
    agaveCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      project_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      paidolProject
      __typename
    }
    agaveGlCode {
      id
      paidolId
      authPaidolId
      source_id
      classification
      currency_code
      current_balance
      description
      name
      number
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveGlCodeId
    agaveVendor {
      id
      paidolId
      authPaidolId
      source_id
      code
      email
      fax
      name
      phone
      status
      tax_number
      terms
      type
      website
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      __typename
    }
    agaveVendorId
    agaveSubJob {
      id
      agaveSubJobId
      paidolId
      authPaidolId
      source_id
      name
      number
      code
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      fullName
      cost_code_ids
      __typename
    }
    agaveSubJobId
    agaveEquipment {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCo
      category
      department
      status
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEquipmentId
    agaveEmCostCode {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCostTypeCodes
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostCodeId
    agaveEmCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      abbreviation
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostTypeId
    codingType
    accountingDate
    procoreDirectCostId
    procoreDirectCostLineItemId
    procoreProject {
      id
      active
      display_name
      name
      created_at
      start_date
      completion_date
      project_number
      total_value
      __typename
    }
    procoreProjectId
    procoreWBSCode {
      id
      flat_code
      flat_name
      description
      status
      __typename
    }
    procoreWBSCodeId
    erpApprovalStatus
    erpBypassStatus
    erpBillableItemId
    erpBillableItemName
    erpBillable
    erpPostingStatus
    erpPostingError
    erpPostingWarning
    sage300APInvoiceStatus
    sage300APInvoiceError
    note
    approveWithoutNotes
    receiptPath
    receiptId
    receipt {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    hasReceipt
    approveWithoutReceipts
    fuelVehicleId
    fuelOdometerReading
    fuelGallons
    fuelCostPerGallon
    codedAt
    codingMethod
    receiptUploadedAt
    receiptUploadMethod
    erpExportedAt
    erpExportBatchId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHighnoteTransactionEventMutationVariables,
  APITypes.CreateHighnoteTransactionEventMutation
>;
export const updateHighnoteTransactionEvent = /* GraphQL */ `mutation UpdateHighnoteTransactionEvent(
  $input: UpdateHighnoteTransactionEventInput!
  $condition: ModelHighnoteTransactionEventConditionInput
) {
  updateHighnoteTransactionEvent(input: $input, condition: $condition) {
    id
    transactionId
    transaction {
      transactionId
      paymentCardId
      paidolId
      authPaidolId
      cardGroupId
      status
      transactionDate
      merchantName
      merchantCategoryCode
      merchantCategory
      transactionEvents
      note
      jobCodeId
      procoreCompanyId
      procoreProjectId
      procoreWBSCodeId
      procoreDirectCostId
      procoreDirectCostLineItemId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveExpenseId
      agaveVendorId
      agaveGlCodeId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      receiptPath
      receiptId
      erpApprovalStatus
      erpBypassStatus
      last4
      userId
      email
      approvedAmountValue
      approvedAmountCurrencyCode
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      selectedCodingOption
      agaveGlCostTypeId
      flexCodeTransactionStatus
      approveWithoutNotes
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      createdAt
      updatedAt
      __typename
    }
    paymentCardId
    paymentCard {
      paymentCardId
      paidolId
      authPaidolId
      name
      cardGroupId
      status
      bin
      last4
      network
      formFactor
      expirationDate
      hasPin
      cardholderId
      cardholderName
      isAdminLocked
      lastActionByRole
      lastActionByPaidolUserId
      lastActionByName
      lastActionByEmail
      lastActionAt
      merchantSpendRuleId
      isAuthorizedUserCard
      createdAt
      updatedAt
      __typename
    }
    paidolId
    reconciliationId
    authPaidolId
    eventDate
    processedAt
    origin
    status
    partial
    settlementImpact
    approvedAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    fees {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    approvedAmountValue
    approvedAmountCurrencyCode
    eventData
    transactionOldState
    transactionNewState
    enableListing
    email
    userId
    user {
      id
      username
      email
      first_name
      middle_name
      last_name
      suffix
      picture
      is_speedster
      birthdate
      address
      phone_number
      phone_extension
      password_updated_at
      finicityCustomerId
      dwollaCustomerId
      is_support
      deletedAt
      createdAt
      updatedAt
      __typename
    }
    last4
    card {
      paymentCardId
      paidolId
      authPaidolId
      name
      cardGroupId
      status
      bin
      last4
      network
      formFactor
      expirationDate
      hasPin
      cardholderId
      cardholderName
      isAdminLocked
      lastActionByRole
      lastActionByPaidolUserId
      lastActionByName
      lastActionByEmail
      lastActionAt
      merchantSpendRuleId
      isAuthorizedUserCard
      createdAt
      updatedAt
      __typename
    }
    groupApprovalLevels
    owningProjectGroupIds
    cardGroupId
    cardGroup {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    merchantCategory
    merchantCategoryCode
    merchantName
    jobCodeId
    jobCode {
      id
      paidolId
      authPaidolId
      description
      code
      isActive
      budget
      jobCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCodeTransactionStatus
    workflowStatus
    returnedStatus
    flexCodeId
    flexCode {
      id
      paidolId
      authPaidolId
      projectName
      projectCode
      isActive
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostCodeId
    flexCostCode {
      id
      paidolId
      authPaidolId
      code
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostTypeId
    flexCostType {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexGlCodeId
    flexGlCode {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexVendorId
    flexVendor {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    agaveDepartment {
      id
      paidolId
      authPaidolId
      code
      name
      fullName
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveDepartmentId
    agaveLocation {
      id
      paidolId
      authPaidolId
      name
      fullName
      parent_id
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveLocationId
    agaveSubaccount {
      id
      paidolId
      authPaidolId
      code
      name
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveSubaccountId
    agaveEmployee {
      id
      paidolId
      authPaidolId
      name
      fullName
      firstName
      lastName
      email
      status
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveEmployeeId
    agaveExpense {
      id
      source_id
      amount
      amount_due
      ap_payment_ids
      batch
      batch_id
      creator_id
      currency_code
      description
      discount_amount
      discount_date
      due_date
      issue_date
      misc_amount
      net_amount
      number
      project_id
      retention_amount
      retention_percent
      status
      subtotal_amount
      tax_amount
      total_amount
      type
      vendor_id
      source_create_time
      source_update_time
      __typename
    }
    agaveExpenseId
    agaveProject {
      id
      paidolId
      authPaidolId
      source_id
      amount
      completion_date
      name
      number
      start_date
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveProjectId
    agaveCostCode {
      id
      paidolId
      authPaidolId
      asset_account_id
      source_id
      formatted_full_code
      code
      full_code
      cost_unit_of_measure
      description
      expense_account_id
      income_account_id
      name
      parent_id
      project_id
      price_unit_of_measure
      source_create_time
      source_update_time
      status
      type
      unit_cost
      unit_price
      vendor_id
      sub_job_id
      createdAt
      updatedAt
      projectId
      paidolProject
      projectIds
      cost_type_ids
      fullName
      __typename
    }
    agaveCostCodeId
    agaveCostTypeId
    agaveCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      project_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      paidolProject
      __typename
    }
    agaveGlCode {
      id
      paidolId
      authPaidolId
      source_id
      classification
      currency_code
      current_balance
      description
      name
      number
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveGlCodeId
    agaveVendor {
      id
      paidolId
      authPaidolId
      source_id
      code
      email
      fax
      name
      phone
      status
      tax_number
      terms
      type
      website
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      __typename
    }
    agaveVendorId
    agaveSubJob {
      id
      agaveSubJobId
      paidolId
      authPaidolId
      source_id
      name
      number
      code
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      fullName
      cost_code_ids
      __typename
    }
    agaveSubJobId
    agaveEquipment {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCo
      category
      department
      status
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEquipmentId
    agaveEmCostCode {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCostTypeCodes
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostCodeId
    agaveEmCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      abbreviation
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostTypeId
    codingType
    accountingDate
    procoreDirectCostId
    procoreDirectCostLineItemId
    procoreProject {
      id
      active
      display_name
      name
      created_at
      start_date
      completion_date
      project_number
      total_value
      __typename
    }
    procoreProjectId
    procoreWBSCode {
      id
      flat_code
      flat_name
      description
      status
      __typename
    }
    procoreWBSCodeId
    erpApprovalStatus
    erpBypassStatus
    erpBillableItemId
    erpBillableItemName
    erpBillable
    erpPostingStatus
    erpPostingError
    erpPostingWarning
    sage300APInvoiceStatus
    sage300APInvoiceError
    note
    approveWithoutNotes
    receiptPath
    receiptId
    receipt {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    hasReceipt
    approveWithoutReceipts
    fuelVehicleId
    fuelOdometerReading
    fuelGallons
    fuelCostPerGallon
    codedAt
    codingMethod
    receiptUploadedAt
    receiptUploadMethod
    erpExportedAt
    erpExportBatchId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateHighnoteTransactionEventMutationVariables,
  APITypes.UpdateHighnoteTransactionEventMutation
>;
export const deleteHighnoteTransactionEvent = /* GraphQL */ `mutation DeleteHighnoteTransactionEvent(
  $input: DeleteHighnoteTransactionEventInput!
  $condition: ModelHighnoteTransactionEventConditionInput
) {
  deleteHighnoteTransactionEvent(input: $input, condition: $condition) {
    id
    transactionId
    transaction {
      transactionId
      paymentCardId
      paidolId
      authPaidolId
      cardGroupId
      status
      transactionDate
      merchantName
      merchantCategoryCode
      merchantCategory
      transactionEvents
      note
      jobCodeId
      procoreCompanyId
      procoreProjectId
      procoreWBSCodeId
      procoreDirectCostId
      procoreDirectCostLineItemId
      agaveProjectId
      agaveCostCodeId
      agaveCostTypeId
      agaveExpenseId
      agaveVendorId
      agaveGlCodeId
      agaveDepartmentId
      agaveLocationId
      agaveSubaccountId
      receiptPath
      receiptId
      erpApprovalStatus
      erpBypassStatus
      last4
      userId
      email
      approvedAmountValue
      approvedAmountCurrencyCode
      flexCodeId
      flexCostCodeId
      flexCostTypeId
      flexGlCodeId
      flexVendorId
      selectedCodingOption
      agaveGlCostTypeId
      flexCodeTransactionStatus
      approveWithoutNotes
      approveWithoutReceipts
      fuelVehicleId
      fuelOdometerReading
      fuelGallons
      fuelCostPerGallon
      createdAt
      updatedAt
      __typename
    }
    paymentCardId
    paymentCard {
      paymentCardId
      paidolId
      authPaidolId
      name
      cardGroupId
      status
      bin
      last4
      network
      formFactor
      expirationDate
      hasPin
      cardholderId
      cardholderName
      isAdminLocked
      lastActionByRole
      lastActionByPaidolUserId
      lastActionByName
      lastActionByEmail
      lastActionAt
      merchantSpendRuleId
      isAuthorizedUserCard
      createdAt
      updatedAt
      __typename
    }
    paidolId
    reconciliationId
    authPaidolId
    eventDate
    processedAt
    origin
    status
    partial
    settlementImpact
    approvedAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    fees {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    approvedAmountValue
    approvedAmountCurrencyCode
    eventData
    transactionOldState
    transactionNewState
    enableListing
    email
    userId
    user {
      id
      username
      email
      first_name
      middle_name
      last_name
      suffix
      picture
      is_speedster
      birthdate
      address
      phone_number
      phone_extension
      password_updated_at
      finicityCustomerId
      dwollaCustomerId
      is_support
      deletedAt
      createdAt
      updatedAt
      __typename
    }
    last4
    card {
      paymentCardId
      paidolId
      authPaidolId
      name
      cardGroupId
      status
      bin
      last4
      network
      formFactor
      expirationDate
      hasPin
      cardholderId
      cardholderName
      isAdminLocked
      lastActionByRole
      lastActionByPaidolUserId
      lastActionByName
      lastActionByEmail
      lastActionAt
      merchantSpendRuleId
      isAuthorizedUserCard
      createdAt
      updatedAt
      __typename
    }
    groupApprovalLevels
    owningProjectGroupIds
    cardGroupId
    cardGroup {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    merchantCategory
    merchantCategoryCode
    merchantName
    jobCodeId
    jobCode {
      id
      paidolId
      authPaidolId
      description
      code
      isActive
      budget
      jobCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCodeTransactionStatus
    workflowStatus
    returnedStatus
    flexCodeId
    flexCode {
      id
      paidolId
      authPaidolId
      projectName
      projectCode
      isActive
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostCodeId
    flexCostCode {
      id
      paidolId
      authPaidolId
      code
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostTypeId
    flexCostType {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexGlCodeId
    flexGlCode {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexVendorId
    flexVendor {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    agaveDepartment {
      id
      paidolId
      authPaidolId
      code
      name
      fullName
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveDepartmentId
    agaveLocation {
      id
      paidolId
      authPaidolId
      name
      fullName
      parent_id
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveLocationId
    agaveSubaccount {
      id
      paidolId
      authPaidolId
      code
      name
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveSubaccountId
    agaveEmployee {
      id
      paidolId
      authPaidolId
      name
      fullName
      firstName
      lastName
      email
      status
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveEmployeeId
    agaveExpense {
      id
      source_id
      amount
      amount_due
      ap_payment_ids
      batch
      batch_id
      creator_id
      currency_code
      description
      discount_amount
      discount_date
      due_date
      issue_date
      misc_amount
      net_amount
      number
      project_id
      retention_amount
      retention_percent
      status
      subtotal_amount
      tax_amount
      total_amount
      type
      vendor_id
      source_create_time
      source_update_time
      __typename
    }
    agaveExpenseId
    agaveProject {
      id
      paidolId
      authPaidolId
      source_id
      amount
      completion_date
      name
      number
      start_date
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveProjectId
    agaveCostCode {
      id
      paidolId
      authPaidolId
      asset_account_id
      source_id
      formatted_full_code
      code
      full_code
      cost_unit_of_measure
      description
      expense_account_id
      income_account_id
      name
      parent_id
      project_id
      price_unit_of_measure
      source_create_time
      source_update_time
      status
      type
      unit_cost
      unit_price
      vendor_id
      sub_job_id
      createdAt
      updatedAt
      projectId
      paidolProject
      projectIds
      cost_type_ids
      fullName
      __typename
    }
    agaveCostCodeId
    agaveCostTypeId
    agaveCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      project_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      paidolProject
      __typename
    }
    agaveGlCode {
      id
      paidolId
      authPaidolId
      source_id
      classification
      currency_code
      current_balance
      description
      name
      number
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveGlCodeId
    agaveVendor {
      id
      paidolId
      authPaidolId
      source_id
      code
      email
      fax
      name
      phone
      status
      tax_number
      terms
      type
      website
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      __typename
    }
    agaveVendorId
    agaveSubJob {
      id
      agaveSubJobId
      paidolId
      authPaidolId
      source_id
      name
      number
      code
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      fullName
      cost_code_ids
      __typename
    }
    agaveSubJobId
    agaveEquipment {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCo
      category
      department
      status
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEquipmentId
    agaveEmCostCode {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCostTypeCodes
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostCodeId
    agaveEmCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      abbreviation
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostTypeId
    codingType
    accountingDate
    procoreDirectCostId
    procoreDirectCostLineItemId
    procoreProject {
      id
      active
      display_name
      name
      created_at
      start_date
      completion_date
      project_number
      total_value
      __typename
    }
    procoreProjectId
    procoreWBSCode {
      id
      flat_code
      flat_name
      description
      status
      __typename
    }
    procoreWBSCodeId
    erpApprovalStatus
    erpBypassStatus
    erpBillableItemId
    erpBillableItemName
    erpBillable
    erpPostingStatus
    erpPostingError
    erpPostingWarning
    sage300APInvoiceStatus
    sage300APInvoiceError
    note
    approveWithoutNotes
    receiptPath
    receiptId
    receipt {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    hasReceipt
    approveWithoutReceipts
    fuelVehicleId
    fuelOdometerReading
    fuelGallons
    fuelCostPerGallon
    codedAt
    codingMethod
    receiptUploadedAt
    receiptUploadMethod
    erpExportedAt
    erpExportBatchId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteHighnoteTransactionEventMutationVariables,
  APITypes.DeleteHighnoteTransactionEventMutation
>;
export const createSyncBalanceCurrentCycle = /* GraphQL */ `mutation CreateSyncBalanceCurrentCycle(
  $input: CreateSyncBalanceCurrentCycleInput!
  $condition: ModelSyncBalanceCurrentCycleConditionInput
) {
  createSyncBalanceCurrentCycle(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    startDate
    endDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSyncBalanceCurrentCycleMutationVariables,
  APITypes.CreateSyncBalanceCurrentCycleMutation
>;
export const updateSyncBalanceCurrentCycle = /* GraphQL */ `mutation UpdateSyncBalanceCurrentCycle(
  $input: UpdateSyncBalanceCurrentCycleInput!
  $condition: ModelSyncBalanceCurrentCycleConditionInput
) {
  updateSyncBalanceCurrentCycle(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    startDate
    endDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSyncBalanceCurrentCycleMutationVariables,
  APITypes.UpdateSyncBalanceCurrentCycleMutation
>;
export const deleteSyncBalanceCurrentCycle = /* GraphQL */ `mutation DeleteSyncBalanceCurrentCycle(
  $input: DeleteSyncBalanceCurrentCycleInput!
  $condition: ModelSyncBalanceCurrentCycleConditionInput
) {
  deleteSyncBalanceCurrentCycle(input: $input, condition: $condition) {
    id
    paidolId
    authPaidolId
    startDate
    endDate
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSyncBalanceCurrentCycleMutationVariables,
  APITypes.DeleteSyncBalanceCurrentCycleMutation
>;
export const createSyncBalanceCurrentCyclePaymentCards = /* GraphQL */ `mutation CreateSyncBalanceCurrentCyclePaymentCards(
  $input: CreateSyncBalanceCurrentCyclePaymentCardsInput!
  $condition: ModelSyncBalanceCurrentCyclePaymentCardsConditionInput
) {
  createSyncBalanceCurrentCyclePaymentCards(
    input: $input
    condition: $condition
  ) {
    id
    authPaidolId
    paidolId
    syncBalanceCurrentCycleId
    paymentCardId
    balance {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    syncedAt
    error
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSyncBalanceCurrentCyclePaymentCardsMutationVariables,
  APITypes.CreateSyncBalanceCurrentCyclePaymentCardsMutation
>;
export const updateSyncBalanceCurrentCyclePaymentCards = /* GraphQL */ `mutation UpdateSyncBalanceCurrentCyclePaymentCards(
  $input: UpdateSyncBalanceCurrentCyclePaymentCardsInput!
  $condition: ModelSyncBalanceCurrentCyclePaymentCardsConditionInput
) {
  updateSyncBalanceCurrentCyclePaymentCards(
    input: $input
    condition: $condition
  ) {
    id
    authPaidolId
    paidolId
    syncBalanceCurrentCycleId
    paymentCardId
    balance {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    syncedAt
    error
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSyncBalanceCurrentCyclePaymentCardsMutationVariables,
  APITypes.UpdateSyncBalanceCurrentCyclePaymentCardsMutation
>;
export const deleteSyncBalanceCurrentCyclePaymentCards = /* GraphQL */ `mutation DeleteSyncBalanceCurrentCyclePaymentCards(
  $input: DeleteSyncBalanceCurrentCyclePaymentCardsInput!
  $condition: ModelSyncBalanceCurrentCyclePaymentCardsConditionInput
) {
  deleteSyncBalanceCurrentCyclePaymentCards(
    input: $input
    condition: $condition
  ) {
    id
    authPaidolId
    paidolId
    syncBalanceCurrentCycleId
    paymentCardId
    balance {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    syncedAt
    error
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSyncBalanceCurrentCyclePaymentCardsMutationVariables,
  APITypes.DeleteSyncBalanceCurrentCyclePaymentCardsMutation
>;
export const createExpenseTypeToMCC = /* GraphQL */ `mutation CreateExpenseTypeToMCC(
  $input: CreateExpenseTypeToMCCInput!
  $condition: ModelExpenseTypeToMCCConditionInput
) {
  createExpenseTypeToMCC(input: $input, condition: $condition) {
    id
    mccID
    expenseTypeID
    mcc {
      id
      code
      highnoteDescription
      highnoteCategoryDescription
      speedchainDescription
      createdAt
      updatedAt
      __typename
    }
    expenseType {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateExpenseTypeToMCCMutationVariables,
  APITypes.CreateExpenseTypeToMCCMutation
>;
export const updateExpenseTypeToMCC = /* GraphQL */ `mutation UpdateExpenseTypeToMCC(
  $input: UpdateExpenseTypeToMCCInput!
  $condition: ModelExpenseTypeToMCCConditionInput
) {
  updateExpenseTypeToMCC(input: $input, condition: $condition) {
    id
    mccID
    expenseTypeID
    mcc {
      id
      code
      highnoteDescription
      highnoteCategoryDescription
      speedchainDescription
      createdAt
      updatedAt
      __typename
    }
    expenseType {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateExpenseTypeToMCCMutationVariables,
  APITypes.UpdateExpenseTypeToMCCMutation
>;
export const deleteExpenseTypeToMCC = /* GraphQL */ `mutation DeleteExpenseTypeToMCC(
  $input: DeleteExpenseTypeToMCCInput!
  $condition: ModelExpenseTypeToMCCConditionInput
) {
  deleteExpenseTypeToMCC(input: $input, condition: $condition) {
    id
    mccID
    expenseTypeID
    mcc {
      id
      code
      highnoteDescription
      highnoteCategoryDescription
      speedchainDescription
      createdAt
      updatedAt
      __typename
    }
    expenseType {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteExpenseTypeToMCCMutationVariables,
  APITypes.DeleteExpenseTypeToMCCMutation
>;
export const assignCard = /* GraphQL */ `mutation AssignCard(
  $input: InviteUserToPaidol!
  $hostname: String!
  $highnotePaymentCardId: String
) {
  assignCard(
    input: $input
    hostname: $hostname
    highnotePaymentCardId: $highnotePaymentCardId
  ) {
    id
    paidol_id
    paidol {
      id
      id_base58
      id_base58_short
      owner_paidol_id
      slug
      legal_name
      account_balance
      name
      dba
      ein
      mcc
      corp_type
      industry
      company_email
      customer_facing_email
      company_phone
      website
      business_owner_ssn
      dwolla_business_industry_classification
      admin_user_id
      low_balance_alert_threshold
      low_balance_auto_funding_amount
      low_balance_auto_funding_threshold
      speedscore
      priority_status
      deleted_at
      company_id
      logo
      priority_response
      agave_data_sync_in_progress
      submittedBankAccounts
      achEnabled
      virtualCardRequested
      virtualCardEnabled
      achRequested
      cron_status
      owner_sub
      is_test_fixture
      is_migration
      enablePCards
      approveWithoutReceipts
      isConstructionType
      agaveAccountToken
      agaveSourceSystemSlug
      isAgaveClient
      erpSpeedchain
      erpConnectionId
      priorErpRealmId
      priorErpName
      erpCutoverReconciledAt
      selectedERP
      logoUrl
      isProcoreClient
      creditLimit
      intacctProjectsNotLicensed
      intacctTopLevelProjectPosting
      paymentTermDays
      createdAt
      updatedAt
      __typename
    }
    user_id
    user {
      id
      username
      email
      first_name
      middle_name
      last_name
      suffix
      picture
      is_speedster
      birthdate
      address
      phone_number
      phone_extension
      password_updated_at
      finicityCustomerId
      dwollaCustomerId
      is_support
      deletedAt
      createdAt
      updatedAt
      __typename
    }
    email
    position
    phone
    address {
      address1
      address2
      city
      state
      country
      postal_code
      __typename
    }
    roles
    is_test_fixture
    paymentCards {
      nextToken
      __typename
    }
    authorizedUserId
    authorizedUserApplicationId
    allowedJobCodes
    employee_id
    managedGroups {
      nextToken
      __typename
    }
    managedProjectsGroups {
      nextToken
      __typename
    }
    glCodeVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    projectVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    departmentVisibilitySettings {
      isAllAvailable
      ids
      __typename
    }
    columnPreferences {
      paidolId
      __typename
    }
    widgetPreferences {
      widgetId
      hidden
      __typename
    }
    defaultAgaveEmployeeId
    defaultAgaveEmployee {
      id
      paidolId
      authPaidolId
      name
      fullName
      firstName
      lastName
      email
      status
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    deletedAt
    landingPagePreference
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AssignCardMutationVariables,
  APITypes.AssignCardMutation
>;
export const removeUserFromPaymentCard = /* GraphQL */ `mutation RemoveUserFromPaymentCard($paidolUserToHighnotePaymentCardId: ID!) {
  removeUserFromPaymentCard(
    paidolUserToHighnotePaymentCardId: $paidolUserToHighnotePaymentCardId
  ) {
    id
    paidolUserID
    highnotePaymentCardID
    paidolUser {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    highnotePaymentCard {
      paymentCardId
      paidolId
      authPaidolId
      name
      cardGroupId
      status
      bin
      last4
      network
      formFactor
      expirationDate
      hasPin
      cardholderId
      cardholderName
      isAdminLocked
      lastActionByRole
      lastActionByPaidolUserId
      lastActionByName
      lastActionByEmail
      lastActionAt
      merchantSpendRuleId
      isAuthorizedUserCard
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RemoveUserFromPaymentCardMutationVariables,
  APITypes.RemoveUserFromPaymentCardMutation
>;
export const updateSupplier = /* GraphQL */ `mutation UpdateSupplier($input: SupplierUpdateInput!) {
  updateSupplier(input: $input)
}
` as GeneratedMutation<
  APITypes.UpdateSupplierMutationVariables,
  APITypes.UpdateSupplierMutation
>;
export const hnGenerateTokenizeAccountHolderClientToken = /* GraphQL */ `mutation HnGenerateTokenizeAccountHolderClientToken {
  hnGenerateTokenizeAccountHolderClientToken {
    ... on HNClientToken {
      value
      expirationDate
      usage
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnGenerateTokenizeAccountHolderClientTokenMutationVariables,
  APITypes.HnGenerateTokenizeAccountHolderClientTokenMutation
>;
export const hnGeneratePaymentCardClientToken = /* GraphQL */ `mutation HnGeneratePaymentCardClientToken(
  $input: HNGeneratePaymentCardClientTokenInput!
) {
  hnGeneratePaymentCardClientToken(input: $input) {
    ... on HNClientToken {
      value
      expirationDate
      usage
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnGeneratePaymentCardClientTokenMutationVariables,
  APITypes.HnGeneratePaymentCardClientTokenMutation
>;
export const hnAddExternalBankAccountVerifiedThroughPlaid = /* GraphQL */ `mutation HnAddExternalBankAccountVerifiedThroughPlaid(
  $input: HNAddExternalBankAccountVerifiedThroughPlaidInput!
) {
  hnAddExternalBankAccountVerifiedThroughPlaid(input: $input) {
    ... on HNExternalFinancialBankAccount {
      id
      ledgers {
        id
        name
        description
        normalBalance
        asOf
        __typename
      }
      owner {
        ... on HNOrganization {
          id
        }
        ... on HNPaymentCard {
          id
          externalId
          bin
          last4
          expirationDate
          expirationMonth
          expirationYear
          network
          status
          formFactor
          suspensionFlags
        }
        ... on HNUSPersonAccountHolder {
          id
          email
          dateOfBirth
          externalId
          createdAt
          updatedAt
        }
        ... on HNUSBusinessAccountHolder {
          id
          externalId
          createdAt
          updatedAt
        }
      }
      name
      provider
      accountStatus
      features {
        enabled
        createdAt
        updatedAt
        effectiveFrom
        effectiveThrough

        ... on HNOnDemandFundingFinancialAccountFeature {
          sourceFinancialAccountId
          pseudoBalanceEnabled
        }
      }
      createdAt
      updatedAt
      externalBankAccountDetails {
        id
        last4
        type
        routingNumber
        createdAt
        updatedAt
        __typename
      }
      integratorInitiatedAchTransfers {
        __typename
      }
      externallyInitiatedAchTransfers {
        __typename
      }
      integratorInitiatedACHTransfer {
        __typename
      }
      integratorACHTransfers {
        __typename
      }
      externallyInitiatedACHTransfer {
        __typename
      }
      externalACHTransfers {
        __typename
      }
      originatedAchTransfers {
        ... on HNAccessDeniedError {
          message
        }
      }
      nonOriginatedAchTransfers {
        ... on HNAccessDeniedError {
          message
        }
      }
      transactionEvents {
        __typename
      }
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnAddExternalBankAccountVerifiedThroughPlaidMutationVariables,
  APITypes.HnAddExternalBankAccountVerifiedThroughPlaidMutation
>;
export const hnAddExternalBankAccountVerifiedThroughFinicity = /* GraphQL */ `mutation HnAddExternalBankAccountVerifiedThroughFinicity(
  $input: HNAddExternalBankAccountVerifiedThroughFinicityInput!
) {
  hnAddExternalBankAccountVerifiedThroughFinicity(input: $input) {
    ... on HNExternalFinancialBankAccount {
      id
      ledgers {
        id
        name
        description
        normalBalance
        asOf
        __typename
      }
      owner {
        ... on HNOrganization {
          id
        }
        ... on HNPaymentCard {
          id
          externalId
          bin
          last4
          expirationDate
          expirationMonth
          expirationYear
          network
          status
          formFactor
          suspensionFlags
        }
        ... on HNUSPersonAccountHolder {
          id
          email
          dateOfBirth
          externalId
          createdAt
          updatedAt
        }
        ... on HNUSBusinessAccountHolder {
          id
          externalId
          createdAt
          updatedAt
        }
      }
      name
      provider
      accountStatus
      features {
        enabled
        createdAt
        updatedAt
        effectiveFrom
        effectiveThrough

        ... on HNOnDemandFundingFinancialAccountFeature {
          sourceFinancialAccountId
          pseudoBalanceEnabled
        }
      }
      createdAt
      updatedAt
      externalBankAccountDetails {
        id
        last4
        type
        routingNumber
        createdAt
        updatedAt
        __typename
      }
      integratorInitiatedAchTransfers {
        __typename
      }
      externallyInitiatedAchTransfers {
        __typename
      }
      integratorInitiatedACHTransfer {
        __typename
      }
      integratorACHTransfers {
        __typename
      }
      externallyInitiatedACHTransfer {
        __typename
      }
      externalACHTransfers {
        __typename
      }
      originatedAchTransfers {
        ... on HNAccessDeniedError {
          message
        }
      }
      nonOriginatedAchTransfers {
        ... on HNAccessDeniedError {
          message
        }
      }
      transactionEvents {
        __typename
      }
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnAddExternalBankAccountVerifiedThroughFinicityMutationVariables,
  APITypes.HnAddExternalBankAccountVerifiedThroughFinicityMutation
>;
export const hnCreateOneTimeACHTransfer = /* GraphQL */ `mutation HnCreateOneTimeACHTransfer($input: HNCreateOneTimeACHTransferInput!) {
  hnCreateOneTimeACHTransfer(input: $input) {
    ... on HNOneTimeACHTransfer {
      id
      fromFinancialAccount {
        ... on HNFinancialAccount {
          id
          externalId
          name
          createdAt
          updatedAt
          accountClosureBlockers
          accountStatus
          accountAttributes
          partnerBankName
        }
        ... on HNExternalFinancialBankAccount {
          id
          name
          provider
          accountStatus
          createdAt
          updatedAt
        }
        ... on HNNonVerifiedExternalUSFinancialBankAccount {
          id
          name
          accountStatus
          createdAt
          updatedAt
        }
      }
      toFinancialAccount {
        ... on HNFinancialAccount {
          id
          externalId
          name
          createdAt
          updatedAt
          accountClosureBlockers
          accountStatus
          accountAttributes
          partnerBankName
        }
        ... on HNExternalFinancialBankAccount {
          id
          name
          provider
          accountStatus
          createdAt
          updatedAt
        }
        ... on HNNonVerifiedExternalUSFinancialBankAccount {
          id
          name
          accountStatus
          createdAt
          updatedAt
        }
      }
      descriptor {
        companyEntryDescription
        individualName
        individualIdentificationNumber
        __typename
      }
      transferAmount {
        ... on HNTransferAmountCalculation {
          calculatedType
        }
      }
      status
      scheduledTransferDate
      transferEvents {
        __typename
      }
      createdAt
      updatedAt
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnCreateOneTimeACHTransferMutationVariables,
  APITypes.HnCreateOneTimeACHTransferMutation
>;
export const hnCancelScheduledTransfer = /* GraphQL */ `mutation HnCancelScheduledTransfer($input: HNCancelScheduledTransferInput!) {
  hnCancelScheduledTransfer(input: $input) {
    ... on HNRecurringACHTransfer {
      id
      fromFinancialAccount {
        ... on HNFinancialAccount {
          id
          externalId
          name
          createdAt
          updatedAt
          accountClosureBlockers
          accountStatus
          accountAttributes
          partnerBankName
        }
        ... on HNExternalFinancialBankAccount {
          id
          name
          provider
          accountStatus
          createdAt
          updatedAt
        }
        ... on HNNonVerifiedExternalUSFinancialBankAccount {
          id
          name
          accountStatus
          createdAt
          updatedAt
        }
      }
      toFinancialAccount {
        ... on HNFinancialAccount {
          id
          externalId
          name
          createdAt
          updatedAt
          accountClosureBlockers
          accountStatus
          accountAttributes
          partnerBankName
        }
        ... on HNExternalFinancialBankAccount {
          id
          name
          provider
          accountStatus
          createdAt
          updatedAt
        }
        ... on HNNonVerifiedExternalUSFinancialBankAccount {
          id
          name
          accountStatus
          createdAt
          updatedAt
        }
      }
      descriptor {
        companyEntryDescription
        individualName
        individualIdentificationNumber
        __typename
      }
      transferAmount {
        ... on HNTransferAmountCalculation {
          calculatedType
        }
      }
      frequency
      balanceAmountType
      status
      nextScheduledTransferDate
      transferEvents {
        __typename
      }
      createdAt
      updatedAt
    }
    ... on HNOneTimeACHTransfer {
      id
      fromFinancialAccount {
        ... on HNFinancialAccount {
          id
          externalId
          name
          createdAt
          updatedAt
          accountClosureBlockers
          accountStatus
          accountAttributes
          partnerBankName
        }
        ... on HNExternalFinancialBankAccount {
          id
          name
          provider
          accountStatus
          createdAt
          updatedAt
        }
        ... on HNNonVerifiedExternalUSFinancialBankAccount {
          id
          name
          accountStatus
          createdAt
          updatedAt
        }
      }
      toFinancialAccount {
        ... on HNFinancialAccount {
          id
          externalId
          name
          createdAt
          updatedAt
          accountClosureBlockers
          accountStatus
          accountAttributes
          partnerBankName
        }
        ... on HNExternalFinancialBankAccount {
          id
          name
          provider
          accountStatus
          createdAt
          updatedAt
        }
        ... on HNNonVerifiedExternalUSFinancialBankAccount {
          id
          name
          accountStatus
          createdAt
          updatedAt
        }
      }
      descriptor {
        companyEntryDescription
        individualName
        individualIdentificationNumber
        __typename
      }
      transferAmount {
        ... on HNTransferAmountCalculation {
          calculatedType
        }
      }
      status
      scheduledTransferDate
      transferEvents {
        __typename
      }
      createdAt
      updatedAt
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnCancelScheduledTransferMutationVariables,
  APITypes.HnCancelScheduledTransferMutation
>;
export const hnCreateRecurringACHTransfer = /* GraphQL */ `mutation HnCreateRecurringACHTransfer(
  $input: HNCreateRecurringACHTransferInput!
) {
  hnCreateRecurringACHTransfer(input: $input) {
    ... on HNRecurringACHTransfer {
      id
      fromFinancialAccount {
        ... on HNFinancialAccount {
          id
          externalId
          name
          createdAt
          updatedAt
          accountClosureBlockers
          accountStatus
          accountAttributes
          partnerBankName
        }
        ... on HNExternalFinancialBankAccount {
          id
          name
          provider
          accountStatus
          createdAt
          updatedAt
        }
        ... on HNNonVerifiedExternalUSFinancialBankAccount {
          id
          name
          accountStatus
          createdAt
          updatedAt
        }
      }
      toFinancialAccount {
        ... on HNFinancialAccount {
          id
          externalId
          name
          createdAt
          updatedAt
          accountClosureBlockers
          accountStatus
          accountAttributes
          partnerBankName
        }
        ... on HNExternalFinancialBankAccount {
          id
          name
          provider
          accountStatus
          createdAt
          updatedAt
        }
        ... on HNNonVerifiedExternalUSFinancialBankAccount {
          id
          name
          accountStatus
          createdAt
          updatedAt
        }
      }
      descriptor {
        companyEntryDescription
        individualName
        individualIdentificationNumber
        __typename
      }
      transferAmount {
        ... on HNTransferAmountCalculation {
          calculatedType
        }
      }
      frequency
      balanceAmountType
      status
      nextScheduledTransferDate
      transferEvents {
        __typename
      }
      createdAt
      updatedAt
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnCreateRecurringACHTransferMutationVariables,
  APITypes.HnCreateRecurringACHTransferMutation
>;
export const hnInitiateFundsDepositACHTransfer = /* GraphQL */ `mutation HnInitiateFundsDepositACHTransfer(
  $input: HNInitiateFundsDepositACHTransferInput!
) {
  hnInitiateFundsDepositACHTransfer(input: $input) {
    ... on HNIntegratorInitiatedFundsDepositACHTransfer {
      id
      amount {
        value
        currencyCode
        decimalPlaces
        __typename
      }
      createdAt
      updatedAt
      ledgers {
        id
        name
        description
        normalBalance
        asOf
        __typename
      }
      status {
        ... on HNNonFailureIntegratorInitiatedACHStatus {
          status
        }
        ... on HNFailureIntegratorInitiatedACHStatus {
          status
          statusReasonCode
        }
      }
      fromFinancialAccount {
        ... on HNFinancialAccount {
          id
          externalId
          name
          createdAt
          updatedAt
          accountClosureBlockers
          accountStatus
          accountAttributes
          partnerBankName
        }
        ... on HNExternalFinancialBankAccount {
          id
          name
          provider
          accountStatus
          createdAt
          updatedAt
        }
        ... on HNNonVerifiedExternalUSFinancialBankAccount {
          id
          name
          accountStatus
          createdAt
          updatedAt
        }
      }
      toFinancialAccount {
        ... on HNFinancialAccount {
          id
          externalId
          name
          createdAt
          updatedAt
          accountClosureBlockers
          accountStatus
          accountAttributes
          partnerBankName
        }
        ... on HNExternalFinancialBankAccount {
          id
          name
          provider
          accountStatus
          createdAt
          updatedAt
        }
        ... on HNNonVerifiedExternalUSFinancialBankAccount {
          id
          name
          accountStatus
          createdAt
          updatedAt
        }
      }
      companyName
      descriptor {
        companyEntryDescription
        individualName
        individualIdentificationNumber
        __typename
      }
      companyIdentifier
      settlementDate
      fundsAvailableDate
      sameDay
      cardProduct {
        id
        name
        usage
        vertical
        commercial
        sourceTemplateId
        __typename
      }
      paymentRelatedInformation
      returnDate
      traceNumber
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnInitiateFundsDepositACHTransferMutationVariables,
  APITypes.HnInitiateFundsDepositACHTransferMutation
>;
export const hnActivatePaymentCard = /* GraphQL */ `mutation HnActivatePaymentCard($input: HNActivatePaymentCardInput!) {
  hnActivatePaymentCard(input: $input) {
    ... on HNPaymentCard {
      id
      externalId
      bin
      last4
      expirationDate
      expirationMonth
      expirationYear
      network
      cardProduct {
        id
        name
        usage
        vertical
        commercial
        sourceTemplateId
        __typename
      }
      cardProductApplication {
        ... on HNAccountHolderCardProductApplication {
          id
          applicationDenialReason
          createdAt
          updatedAt
        }
        ... on HNAuthorizedUserCardProductApplication {
          id
          applicationDenialReason
          createdAt
          updatedAt
        }
      }
      application {
        id
        applicationDenialReason
        createdAt
        updatedAt
        __typename
      }
      status
      formFactor
      originalPaymentCard {
        id
        externalId
        bin
        last4
        expirationDate
        expirationMonth
        expirationYear
        network
        status
        formFactor
        suspensionFlags
        __typename
      }
      restrictedDetails {
        ... on HNPaymentCardRestrictedDetails {
          number
          cvv
        }
        ... on HNAccessDeniedError {
          message
        }
      }
      atmLocations {
        ... on HNAccessDeniedError {
          message
        }
      }
      transactionEvents {
        __typename
      }
      financialAccounts {
        id
        externalId
        name
        createdAt
        updatedAt
        accountClosureBlockers
        accountStatus
        accountAttributes
        partnerBankName
        __typename
      }
      physicalPaymentCardOrders {
        id
        createdAt
        updatedAt
        __typename
      }
      attachedSpendRules {
        __typename
      }
      cardDigitalWalletTokens {
        __typename
      }
      velocityRuleBalances {
        __typename
      }
      velocitySpendRuleBalances {
        ... on HNVelocitySpendRuleAmountBalance {
          asOfDate
          attachedLevel
        }
        ... on HNVelocitySpendRuleCountBalance {
          currentCountBalance
          remainingCountBalance
          computedCurrentCountBalance
          computedRemainingCountBalance
          asOfDate
          attachedLevel
        }
      }
      attachedVelocityRules {
        __typename
      }
      paymentCardHolderDetails {
        __typename
      }
      customFields {
        key

        ... on HNCustomStringField {
          value
        }
      }
      revisionSnapshots {
        __typename
      }
      cardProfileSet {
        id
        status
        name
        intent
        network
        preferredConfiguration
        createdAt
        updatedAt
        description
        __typename
      }
      pinDetails {
        isSet
        __typename
      }
      suspensionFlags
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnActivatePaymentCardMutationVariables,
  APITypes.HnActivatePaymentCardMutation
>;
export const hnCreateAccountHolderCardProductApplication = /* GraphQL */ `mutation HnCreateAccountHolderCardProductApplication(
  $input: HNCreateAccountHolderCardProductApplicationInput!
) {
  hnCreateAccountHolderCardProductApplication(input: $input) {
    ... on HNAccountHolderCardProductApplication {
      id
      applicationState {
        status
        __typename
      }
      adverseActionReasons {
        code
        description
        __typename
      }
      applicationDenialReason
      accountHolderSnapshot {
        ... on HNUSPersonAccountHolderSnapshot {
          email
          dateOfBirth
        }
      }
      cardProduct {
        id
        name
        usage
        vertical
        commercial
        sourceTemplateId
        __typename
      }
      applicationHistory {
        __typename
      }
      createdAt
      updatedAt
      financialAccounts {
        __typename
      }
      offers {
        __typename
      }
      creditReportFraudAlertVerificationResult {
        accountHolderInitiatedApplication
        name
        dateOfBirth
        address
        __typename
      }
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnCreateAccountHolderCardProductApplicationMutationVariables,
  APITypes.HnCreateAccountHolderCardProductApplicationMutation
>;
export const hnStartDocumentUploadSession = /* GraphQL */ `mutation HnStartDocumentUploadSession(
  $input: HNStartDocumentUploadSessionInput!
) {
  hnStartDocumentUploadSession(input: $input) {
    ... on HNUSAccountHolderApplicationDocumentUploadSession {
      id
      status
      primaryDocumentTypes
      secondaryDocumentTypes
      supportingDocumentTypes
      uploadRequirements {
        __typename
      }
      uploadLinks {
        id
        status
        uploadUrl
        createdAt
        updatedAt

        ... on HNDocumentUploadLink {
          documentType
          documentCategoryType
        }
        ... on HNCardArtDocument {
          documentType
          downloadUrl
        }
      }
      recommendedDocumentTypes
      createdAt
      updatedAt
    }
    ... on HNCardProfileDocumentUploadSession {
      cardArtDocuments {
        createdAt
        documentType
        id
        status
        updatedAt
        uploadUrl
        downloadUrl
        __typename
      }
      id
      status
      updatedAt
      createdAt
      expiration
      cardProduct {
        id
        name
        usage
        vertical
        commercial
        sourceTemplateId
        __typename
      }
      allowedDocumentTypes
    }
    ... on HNIdentityVerificationDocumentUploadSession {
      id
      status
      createdAt
      updatedAt
      expiresAt
      requestedDocuments
      uploadLinks {
        id
        status
        uploadUrl
        createdAt
        updatedAt

        ... on HNDocumentUploadLink {
          documentType
          documentCategoryType
        }
        ... on HNCardArtDocument {
          documentType
          downloadUrl
        }
      }
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnStartDocumentUploadSessionMutationVariables,
  APITypes.HnStartDocumentUploadSessionMutation
>;
export const hnCreateDocumentUploadLink = /* GraphQL */ `mutation HnCreateDocumentUploadLink($input: HNCreateDocumentUploadLinkInput!) {
  hnCreateDocumentUploadLink(input: $input) {
    ... on HNDocumentUploadLink {
      id
      documentUploadSession {
        id
        status
        createdAt
        updatedAt

        ... on HNIdentityVerificationDocumentUploadSession {
          expiresAt
          requestedDocuments
        }
        ... on HNUSAccountHolderApplicationDocumentUploadSession {
          primaryDocumentTypes
          secondaryDocumentTypes
          supportingDocumentTypes
          recommendedDocumentTypes
        }
        ... on HNCardProfileDocumentUploadSession {
          expiration
          allowedDocumentTypes
        }
      }
      documentType
      status
      documentCategoryType
      uploadUrl
      createdAt
      updatedAt
    }
    ... on HNCardArtDocument {
      createdAt
      documentType
      documentUploadSession {
        id
        status
        updatedAt
        createdAt
        expiration
        allowedDocumentTypes
        __typename
      }
      id
      status
      updatedAt
      uploadUrl
      downloadUrl
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnCreateDocumentUploadLinkMutationVariables,
  APITypes.HnCreateDocumentUploadLinkMutation
>;
export const hnEndDocumentUploadSession = /* GraphQL */ `mutation HnEndDocumentUploadSession($input: HNEndDocumentUploadSessionInput!) {
  hnEndDocumentUploadSession(input: $input) {
    ... on HNUSAccountHolderApplicationDocumentUploadSession {
      id
      status
      primaryDocumentTypes
      secondaryDocumentTypes
      supportingDocumentTypes
      uploadRequirements {
        __typename
      }
      uploadLinks {
        id
        status
        uploadUrl
        createdAt
        updatedAt

        ... on HNDocumentUploadLink {
          documentType
          documentCategoryType
        }
        ... on HNCardArtDocument {
          documentType
          downloadUrl
        }
      }
      recommendedDocumentTypes
      createdAt
      updatedAt
    }
    ... on HNCardProfileDocumentUploadSession {
      cardArtDocuments {
        createdAt
        documentType
        id
        status
        updatedAt
        uploadUrl
        downloadUrl
        __typename
      }
      id
      status
      updatedAt
      createdAt
      expiration
      cardProduct {
        id
        name
        usage
        vertical
        commercial
        sourceTemplateId
        __typename
      }
      allowedDocumentTypes
    }
    ... on HNIdentityVerificationDocumentUploadSession {
      id
      status
      createdAt
      updatedAt
      expiresAt
      requestedDocuments
      uploadLinks {
        id
        status
        uploadUrl
        createdAt
        updatedAt

        ... on HNDocumentUploadLink {
          documentType
          documentCategoryType
        }
        ... on HNCardArtDocument {
          documentType
          downloadUrl
        }
      }
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnEndDocumentUploadSessionMutationVariables,
  APITypes.HnEndDocumentUploadSessionMutation
>;
export const plaidLinkTokenCreate = /* GraphQL */ `mutation PlaidLinkTokenCreate(
  $userId: ID!
  $redirectUri: String!
  $stepUpGrant: String
) {
  plaidLinkTokenCreate(
    userId: $userId
    redirectUri: $redirectUri
    stepUpGrant: $stepUpGrant
  ) {
    link_token
    expiration
    request_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PlaidLinkTokenCreateMutationVariables,
  APITypes.PlaidLinkTokenCreateMutation
>;
export const plaidLinkTokenExchange = /* GraphQL */ `mutation PlaidLinkTokenExchange(
  $publicToken: String!
  $accountId: String!
  $accountType: String!
) {
  plaidLinkTokenExchange(
    publicToken: $publicToken
    accountId: $accountId
    accountType: $accountType
  ) {
    processor_token
    request_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PlaidLinkTokenExchangeMutationVariables,
  APITypes.PlaidLinkTokenExchangeMutation
>;
export const plaidExchangeForAccessToken = /* GraphQL */ `mutation PlaidExchangeForAccessToken($publicToken: String!) {
  plaidExchangeForAccessToken(publicToken: $publicToken) {
    access_token
    item_id
    request_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PlaidExchangeForAccessTokenMutationVariables,
  APITypes.PlaidExchangeForAccessTokenMutation
>;
export const linkPlaidBankAccount = /* GraphQL */ `mutation LinkPlaidBankAccount($input: LinkPlaidBankAccountInput!) {
  linkPlaidBankAccount(input: $input) {
    id
    paidolId
    plaidAccountId
    plaidItemId
    highnoteAccountId
    accountName
    accountMask
    accountType
    verificationMethod
    status
    linkedAt
    verifiedAt
    closedAt
    failureReason
    __typename
  }
}
` as GeneratedMutation<
  APITypes.LinkPlaidBankAccountMutationVariables,
  APITypes.LinkPlaidBankAccountMutation
>;
export const updatePlaidLinkedBankAccountStatus = /* GraphQL */ `mutation UpdatePlaidLinkedBankAccountStatus(
  $id: ID!
  $status: String!
  $highnoteAccountId: String
  $failureReason: String
) {
  updatePlaidLinkedBankAccountStatus(
    id: $id
    status: $status
    highnoteAccountId: $highnoteAccountId
    failureReason: $failureReason
  ) {
    id
    paidolId
    plaidAccountId
    plaidItemId
    highnoteAccountId
    accountName
    accountMask
    accountType
    verificationMethod
    status
    linkedAt
    verifiedAt
    closedAt
    failureReason
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdatePlaidLinkedBankAccountStatusMutationVariables,
  APITypes.UpdatePlaidLinkedBankAccountStatusMutation
>;
export const createVerificationLinkTokenForAccount = /* GraphQL */ `mutation CreateVerificationLinkTokenForAccount(
  $accountId: ID!
  $userId: ID!
  $stepUpGrant: String
) {
  createVerificationLinkTokenForAccount(
    accountId: $accountId
    userId: $userId
    stepUpGrant: $stepUpGrant
  ) {
    link_token
    expiration
    request_id
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateVerificationLinkTokenForAccountMutationVariables,
  APITypes.CreateVerificationLinkTokenForAccountMutation
>;
export const completeVerificationAndCreateProcessorToken = /* GraphQL */ `mutation CompleteVerificationAndCreateProcessorToken(
  $accountId: ID!
  $highnoteAccountId: String
) {
  completeVerificationAndCreateProcessorToken(
    accountId: $accountId
    highnoteAccountId: $highnoteAccountId
  ) {
    processorToken
    accountId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CompleteVerificationAndCreateProcessorTokenMutationVariables,
  APITypes.CompleteVerificationAndCreateProcessorTokenMutation
>;
export const hnCreateMerchantCategorySpendRule = /* GraphQL */ `mutation HnCreateMerchantCategorySpendRule(
  $input: HNCreateMerchantCategorySpendRuleInput!
) {
  hnCreateMerchantCategorySpendRule(input: $input) {
    ... on HNMerchantCategorySpendRule {
      id
      name
      allowed
      blocked
      allowedMcc
      blockedMcc
      version
      createdAt
      updatedAt
      revisions {
        __typename
      }
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnCreateMerchantCategorySpendRuleMutationVariables,
  APITypes.HnCreateMerchantCategorySpendRuleMutation
>;
export const hnCreateMerchantCountrySpendRule = /* GraphQL */ `mutation HnCreateMerchantCountrySpendRule(
  $input: HNCreateMerchantCountrySpendRuleInput!
) {
  hnCreateMerchantCountrySpendRule(input: $input) {
    ... on HNMerchantCountrySpendRule {
      id
      name
      allowed
      blocked
      version
      createdAt
      updatedAt
      revisions {
        __typename
      }
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnCreateMerchantCountrySpendRuleMutationVariables,
  APITypes.HnCreateMerchantCountrySpendRuleMutation
>;
export const hnUpdateMerchantCategorySpendRule = /* GraphQL */ `mutation HnUpdateMerchantCategorySpendRule(
  $input: HNUpdateMerchantCategorySpendRuleInput!
) {
  hnUpdateMerchantCategorySpendRule(input: $input) {
    ... on HNMerchantCategorySpendRule {
      id
      name
      allowed
      blocked
      allowedMcc
      blockedMcc
      version
      createdAt
      updatedAt
      revisions {
        __typename
      }
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnUpdateMerchantCategorySpendRuleMutationVariables,
  APITypes.HnUpdateMerchantCategorySpendRuleMutation
>;
export const hnUpdateMerchantCountrySpendRule = /* GraphQL */ `mutation HnUpdateMerchantCountrySpendRule(
  $input: HNUpdateMerchantCountrySpendRuleInput!
) {
  hnUpdateMerchantCountrySpendRule(input: $input) {
    ... on HNMerchantCountrySpendRule {
      id
      name
      allowed
      blocked
      version
      createdAt
      updatedAt
      revisions {
        __typename
      }
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnUpdateMerchantCountrySpendRuleMutationVariables,
  APITypes.HnUpdateMerchantCountrySpendRuleMutation
>;
export const hnCreateAmountLimitSpendRule = /* GraphQL */ `mutation HnCreateAmountLimitSpendRule(
  $input: HNCreateAmountLimitSpendRuleInput!
) {
  hnCreateAmountLimitSpendRule(input: $input) {
    ... on HNAmountLimitSpendRule {
      id
      name
      maximumAmount {
        value
        currencyCode
        decimalPlaces
        __typename
      }
      version
      createdAt
      updatedAt
      revisions {
        __typename
      }
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnCreateAmountLimitSpendRuleMutationVariables,
  APITypes.HnCreateAmountLimitSpendRuleMutation
>;
export const hnSuspendPaymentCard = /* GraphQL */ `mutation HnSuspendPaymentCard($input: HNSuspendPaymentCardInput!) {
  hnSuspendPaymentCard(input: $input) {
    ... on HNPaymentCard {
      id
      externalId
      bin
      last4
      expirationDate
      expirationMonth
      expirationYear
      network
      cardProduct {
        id
        name
        usage
        vertical
        commercial
        sourceTemplateId
        __typename
      }
      cardProductApplication {
        ... on HNAccountHolderCardProductApplication {
          id
          applicationDenialReason
          createdAt
          updatedAt
        }
        ... on HNAuthorizedUserCardProductApplication {
          id
          applicationDenialReason
          createdAt
          updatedAt
        }
      }
      application {
        id
        applicationDenialReason
        createdAt
        updatedAt
        __typename
      }
      status
      formFactor
      originalPaymentCard {
        id
        externalId
        bin
        last4
        expirationDate
        expirationMonth
        expirationYear
        network
        status
        formFactor
        suspensionFlags
        __typename
      }
      restrictedDetails {
        ... on HNPaymentCardRestrictedDetails {
          number
          cvv
        }
        ... on HNAccessDeniedError {
          message
        }
      }
      atmLocations {
        ... on HNAccessDeniedError {
          message
        }
      }
      transactionEvents {
        __typename
      }
      financialAccounts {
        id
        externalId
        name
        createdAt
        updatedAt
        accountClosureBlockers
        accountStatus
        accountAttributes
        partnerBankName
        __typename
      }
      physicalPaymentCardOrders {
        id
        createdAt
        updatedAt
        __typename
      }
      attachedSpendRules {
        __typename
      }
      cardDigitalWalletTokens {
        __typename
      }
      velocityRuleBalances {
        __typename
      }
      velocitySpendRuleBalances {
        ... on HNVelocitySpendRuleAmountBalance {
          asOfDate
          attachedLevel
        }
        ... on HNVelocitySpendRuleCountBalance {
          currentCountBalance
          remainingCountBalance
          computedCurrentCountBalance
          computedRemainingCountBalance
          asOfDate
          attachedLevel
        }
      }
      attachedVelocityRules {
        __typename
      }
      paymentCardHolderDetails {
        __typename
      }
      customFields {
        key

        ... on HNCustomStringField {
          value
        }
      }
      revisionSnapshots {
        __typename
      }
      cardProfileSet {
        id
        status
        name
        intent
        network
        preferredConfiguration
        createdAt
        updatedAt
        description
        __typename
      }
      pinDetails {
        isSet
        __typename
      }
      suspensionFlags
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnSuspendPaymentCardMutationVariables,
  APITypes.HnSuspendPaymentCardMutation
>;
export const hnClosePaymentCard = /* GraphQL */ `mutation HnClosePaymentCard($input: HNClosePaymentCardInput!) {
  hnClosePaymentCard(input: $input) {
    ... on HNPaymentCard {
      id
      externalId
      bin
      last4
      expirationDate
      expirationMonth
      expirationYear
      network
      cardProduct {
        id
        name
        usage
        vertical
        commercial
        sourceTemplateId
        __typename
      }
      cardProductApplication {
        ... on HNAccountHolderCardProductApplication {
          id
          applicationDenialReason
          createdAt
          updatedAt
        }
        ... on HNAuthorizedUserCardProductApplication {
          id
          applicationDenialReason
          createdAt
          updatedAt
        }
      }
      application {
        id
        applicationDenialReason
        createdAt
        updatedAt
        __typename
      }
      status
      formFactor
      originalPaymentCard {
        id
        externalId
        bin
        last4
        expirationDate
        expirationMonth
        expirationYear
        network
        status
        formFactor
        suspensionFlags
        __typename
      }
      restrictedDetails {
        ... on HNPaymentCardRestrictedDetails {
          number
          cvv
        }
        ... on HNAccessDeniedError {
          message
        }
      }
      atmLocations {
        ... on HNAccessDeniedError {
          message
        }
      }
      transactionEvents {
        __typename
      }
      financialAccounts {
        id
        externalId
        name
        createdAt
        updatedAt
        accountClosureBlockers
        accountStatus
        accountAttributes
        partnerBankName
        __typename
      }
      physicalPaymentCardOrders {
        id
        createdAt
        updatedAt
        __typename
      }
      attachedSpendRules {
        __typename
      }
      cardDigitalWalletTokens {
        __typename
      }
      velocityRuleBalances {
        __typename
      }
      velocitySpendRuleBalances {
        ... on HNVelocitySpendRuleAmountBalance {
          asOfDate
          attachedLevel
        }
        ... on HNVelocitySpendRuleCountBalance {
          currentCountBalance
          remainingCountBalance
          computedCurrentCountBalance
          computedRemainingCountBalance
          asOfDate
          attachedLevel
        }
      }
      attachedVelocityRules {
        __typename
      }
      paymentCardHolderDetails {
        __typename
      }
      customFields {
        key

        ... on HNCustomStringField {
          value
        }
      }
      revisionSnapshots {
        __typename
      }
      cardProfileSet {
        id
        status
        name
        intent
        network
        preferredConfiguration
        createdAt
        updatedAt
        description
        __typename
      }
      pinDetails {
        isSet
        __typename
      }
      suspensionFlags
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnClosePaymentCardMutationVariables,
  APITypes.HnClosePaymentCardMutation
>;
export const hnGenerateDirectDepositDetailClientToken = /* GraphQL */ `mutation HnGenerateDirectDepositDetailClientToken(
  $input: HNGenerateDirectDepositDetailClientTokenInput!
) {
  hnGenerateDirectDepositDetailClientToken(input: $input) {
    ... on HNClientToken {
      value
      expirationDate
      usage
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnGenerateDirectDepositDetailClientTokenMutationVariables,
  APITypes.HnGenerateDirectDepositDetailClientTokenMutation
>;
export const issuePaymentCard = /* GraphQL */ `mutation IssuePaymentCard($input: IssuePaymentCard!) {
  issuePaymentCard(input: $input) {
    statusCode
    errorMessage
    errorType
    paymentCardId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.IssuePaymentCardMutationVariables,
  APITypes.IssuePaymentCardMutation
>;
export const hnCloseExternalFinancialBankAccount = /* GraphQL */ `mutation HnCloseExternalFinancialBankAccount(
  $input: HNCloseExternalFinancialBankAccountInput!
) {
  hnCloseExternalFinancialBankAccount(input: $input) {
    ... on HNExternalFinancialBankAccount {
      id
      ledgers {
        id
        name
        description
        normalBalance
        asOf
        __typename
      }
      owner {
        ... on HNOrganization {
          id
        }
        ... on HNPaymentCard {
          id
          externalId
          bin
          last4
          expirationDate
          expirationMonth
          expirationYear
          network
          status
          formFactor
          suspensionFlags
        }
        ... on HNUSPersonAccountHolder {
          id
          email
          dateOfBirth
          externalId
          createdAt
          updatedAt
        }
        ... on HNUSBusinessAccountHolder {
          id
          externalId
          createdAt
          updatedAt
        }
      }
      name
      provider
      accountStatus
      features {
        enabled
        createdAt
        updatedAt
        effectiveFrom
        effectiveThrough

        ... on HNOnDemandFundingFinancialAccountFeature {
          sourceFinancialAccountId
          pseudoBalanceEnabled
        }
      }
      createdAt
      updatedAt
      externalBankAccountDetails {
        id
        last4
        type
        routingNumber
        createdAt
        updatedAt
        __typename
      }
      integratorInitiatedAchTransfers {
        __typename
      }
      externallyInitiatedAchTransfers {
        __typename
      }
      integratorInitiatedACHTransfer {
        __typename
      }
      integratorACHTransfers {
        __typename
      }
      externallyInitiatedACHTransfer {
        __typename
      }
      externalACHTransfers {
        __typename
      }
      originatedAchTransfers {
        ... on HNAccessDeniedError {
          message
        }
      }
      nonOriginatedAchTransfers {
        ... on HNAccessDeniedError {
          message
        }
      }
      transactionEvents {
        __typename
      }
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnCloseExternalFinancialBankAccountMutationVariables,
  APITypes.HnCloseExternalFinancialBankAccountMutation
>;
export const hnIssueFinancialAccountForApplication = /* GraphQL */ `mutation HnIssueFinancialAccountForApplication(
  $input: HNIssueFinancialAccountForApplicationInput!
) {
  hnIssueFinancialAccountForApplication(input: $input) {
    ... on HNFinancialAccount {
      paymentCardTransactionChargebacks {
        __typename
      }
      globalNotes {
        ... on HNAccessDeniedError {
          message
        }
      }
      accountReviewHistory {
        ... on HNAccessDeniedError {
          message
        }
      }
      id
      externalId
      ledgers {
        id
        name
        description
        normalBalance
        asOf
        __typename
      }
      owner {
        ... on HNOrganization {
          id
        }
        ... on HNPaymentCard {
          id
          externalId
          bin
          last4
          expirationDate
          expirationMonth
          expirationYear
          network
          status
          formFactor
          suspensionFlags
        }
        ... on HNUSPersonAccountHolder {
          id
          email
          dateOfBirth
          externalId
          createdAt
          updatedAt
        }
        ... on HNUSBusinessAccountHolder {
          id
          externalId
          createdAt
          updatedAt
        }
      }
      name
      cardProduct {
        id
        name
        usage
        vertical
        commercial
        sourceTemplateId
        __typename
      }
      application {
        id
        applicationDenialReason
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      features {
        enabled
        createdAt
        updatedAt
        effectiveFrom
        effectiveThrough

        ... on HNOnDemandFundingFinancialAccountFeature {
          sourceFinancialAccountId
          pseudoBalanceEnabled
        }
      }
      directDepositDetails {
        id
        createdAt
        updatedAt
        __typename
      }
      activeBillingCycleConfiguration {
        id
        paymentDueDayOfMonth
        billingCycleStartDayOfMonth
        billingCycleEndDayOfMonth
        from
        through
        __typename
      }
      statementSnapshot {
        asOf
        updatedAt
      }
      statements {
        __typename
      }
      financialAccountActivities {
        __typename
      }
      integratorInitiatedAchTransfers {
        __typename
      }
      integratorInitiatedACHTransfer {
        __typename
      }
      integratorACHTransfers {
        __typename
      }
      externallyInitiatedAchTransfers {
        __typename
      }
      externallyInitiatedACHTransfer {
        __typename
      }
      externalACHTransfers {
        __typename
      }
      originatedAchTransfers {
        ... on HNAccessDeniedError {
          message
        }
      }
      nonOriginatedAchTransfers {
        ... on HNAccessDeniedError {
          message
        }
      }
      incomingScheduledTransfers {
        __typename
      }
      transactionEvents {
        __typename
      }
      interFinancialAccountTransfers {
        __typename
      }
      accountClosureBlockers
      accountStatus
      accountAttributes
      financialAccountAttributesWithReason {
        attribute
        reason
        __typename
      }
      paymentCards {
        __typename
      }
      velocityRuleBalances {
        __typename
      }
      velocitySpendRuleBalances {
        ... on HNVelocitySpendRuleAmountBalance {
          asOfDate
          attachedLevel
        }
        ... on HNVelocitySpendRuleCountBalance {
          currentCountBalance
          remainingCountBalance
          computedCurrentCountBalance
          computedRemainingCountBalance
          asOfDate
          attachedLevel
        }
      }
      partnerBankName
      delinquency {
        delinquencyStartedOn
        totalDaysDelinquent
        numberOfCycles
      }
      delinquencyState {
        state
        updatedAt
        __typename
      }
      billingCycleHistory {
        __typename
      }
      creditConfiguration {
        __typename
      }
      feeTransferEvents {
        __typename
      }
      paymentCardTransactionDisputes {
        ... on HNAccessDeniedError {
          message
        }
      }
      customFields {
        key

        ... on HNCustomStringField {
          value
        }
      }
      revisionSnapshots {
        __typename
      }
      rewardPointsTransfers {
        ... on HNAccessDeniedError {
          message
        }
      }
      attachedSpendRules {
        __typename
      }
      attachedVelocityRules {
        __typename
      }
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnIssueFinancialAccountForApplicationMutationVariables,
  APITypes.HnIssueFinancialAccountForApplicationMutation
>;
export const createDwollaFinicityConsentReceipt = /* GraphQL */ `mutation CreateDwollaFinicityConsentReceipt(
  $input: CreateFinicityConsentReceiptInput!
) {
  createDwollaFinicityConsentReceipt(input: $input) {
    receipt {
      profile
      version
      receiptId
      receiptVersion
      customerId
      partnerId
      __typename
    }
    proof {
      signature
      keyId
      timestamp
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDwollaFinicityConsentReceiptMutationVariables,
  APITypes.CreateDwollaFinicityConsentReceiptMutation
>;
export const createHighnoteFinicityConsentReceipt = /* GraphQL */ `mutation CreateHighnoteFinicityConsentReceipt(
  $input: CreateFinicityConsentReceiptInput!
) {
  createHighnoteFinicityConsentReceipt(input: $input) {
    receipt {
      profile
      version
      receiptId
      receiptVersion
      customerId
      partnerId
      __typename
    }
    proof {
      signature
      keyId
      timestamp
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateHighnoteFinicityConsentReceiptMutationVariables,
  APITypes.CreateHighnoteFinicityConsentReceiptMutation
>;
export const createFinicityCustomer = /* GraphQL */ `mutation CreateFinicityCustomer($input: CreateFinicityCustomerInput!) {
  createFinicityCustomer(input: $input) {
    id
    username
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFinicityCustomerMutationVariables,
  APITypes.CreateFinicityCustomerMutation
>;
export const deleteFinicityFinancialAccount = /* GraphQL */ `mutation DeleteFinicityFinancialAccount(
  $input: DeleteFinicityCustomerAccount!
) {
  deleteFinicityFinancialAccount(input: $input)
}
` as GeneratedMutation<
  APITypes.DeleteFinicityFinancialAccountMutationVariables,
  APITypes.DeleteFinicityFinancialAccountMutation
>;
export const getOrRefreshProcoreAccessToken = /* GraphQL */ `mutation GetOrRefreshProcoreAccessToken(
  $input: GetOrRefreshProcoreAccessTokenInput!
) {
  getOrRefreshProcoreAccessToken(input: $input) {
    access_token
    token_type
    expires_in
    refresh_token
    created_at
    __typename
  }
}
` as GeneratedMutation<
  APITypes.GetOrRefreshProcoreAccessTokenMutationVariables,
  APITypes.GetOrRefreshProcoreAccessTokenMutation
>;
export const createOrUpdateProcoreDirectCost = /* GraphQL */ `mutation CreateOrUpdateProcoreDirectCost(
  $input: CreateOrUpdateProcoreDirectCostInput!
) {
  createOrUpdateProcoreDirectCost(input: $input) {
    transactionId
    directCostId
    directCostLineItemId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateProcoreDirectCostMutationVariables,
  APITypes.CreateOrUpdateProcoreDirectCostMutation
>;
export const agaveLinkTokenCreate = /* GraphQL */ `mutation AgaveLinkTokenCreate {
  agaveLinkTokenCreate {
    link_token
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AgaveLinkTokenCreateMutationVariables,
  APITypes.AgaveLinkTokenCreateMutation
>;
export const agaveLinkTokenExchange = /* GraphQL */ `mutation AgaveLinkTokenExchange($input: AgaveAccountTokenInput!) {
  agaveLinkTokenExchange(input: $input) {
    account_token
    account_id
    connection {
      type
      __typename
    }
    created_at
    linked_company {
      id
      source_id
      name
      __typename
    }
    linked_user {
      id
      source_id
      name
      email
      __typename
    }
    reference_id
    source_system {
      name
      slug
      __typename
    }
    source_system_environment {
      name
      slug
      __typename
    }
    status
    supports_cross_account_uuid
    supports_cross_company_requests
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AgaveLinkTokenExchangeMutationVariables,
  APITypes.AgaveLinkTokenExchangeMutation
>;
export const agaveCreateExpense = /* GraphQL */ `mutation AgaveCreateExpense($input: CreateAgaveExpenseInput!) {
  agaveCreateExpense(input: $input) {
    ... on AgaveError {
      message
    }
    ... on CreateAgaveExpenseAPInvoice {
      id
      source_id
      amount
      amount_due
      ap_payment_ids
      attachments {
        id
        source_id
        name
        url
        source_create_time
        source_update_time
        __typename
      }
      batch
      batch_id
      contract {
        id
        type
        __typename
      }
      creator_id
      currency_code
      description
      discount_amount
      discount_date
      due_date
      issue_date
      line_items {
        id
        source_id
        amount
        cost_code_id
        cost_type_id
        customer_id
        description
        discount_amount
        item_id
        ledger_account_id
        project_id
        quantity
        retention_amount
        status
        sub_job_id
        tax_amount
        tax_code_id
        type
        unit_cost
        unit_of_measure
        vendor_id
        wbs_id
        source_create_time
        source_update_time
        __typename
      }
      misc_amount
      net_amount
      number
      project_id
      retention_amount
      retention_percent
      status
      subtotal_amount
      tax_amount
      total_amount
      type
      vendor_id
      source_create_time
      source_update_time
      source_data {
        path
        content_type
        data
        __typename
      }
    }
  }
}
` as GeneratedMutation<
  APITypes.AgaveCreateExpenseMutationVariables,
  APITypes.AgaveCreateExpenseMutation
>;
export const agavePostJobCost = /* GraphQL */ `mutation AgavePostJobCost($input: AgavePostJobCostInput!) {
  agavePostJobCost(input: $input) {
    ... on AgaveError {
      message
    }
    ... on AgaveJobCost {
      id
      source_id
      accounting_date
      actual_amount
      actual_quantity
      actual_unit_cost
      actual_unit_of_measure
      attachments
      cost_code_id
      cost_type_id
      description
      ledger_account_id
      name
      number
      posted_date
      prime_contract_id
      project_id
      reference_id
      reference_type
      status
      sub_job_id
      transaction_date
      type
      vendor_id
      wbs_id
      source_create_time
      source_update_time
      source_data
    }
  }
}
` as GeneratedMutation<
  APITypes.AgavePostJobCostMutationVariables,
  APITypes.AgavePostJobCostMutation
>;
export const agaveAPInvoicesCreateExpense = /* GraphQL */ `mutation AgaveAPInvoicesCreateExpense(
  $input: AgaveAPInvoicesCreateExpenseInput!
) {
  agaveAPInvoicesCreateExpense(input: $input) {
    ... on AgaveError {
      message
    }
    ... on AgaveAPInvoicesPayload {
      id
      source_id
      amount
      amount_due
      ap_payment_ids
      attachments {
        id
        source_id
        name
        url
        source_create_time
        source_update_time
        __typename
      }
      batch
      batch_id
      contract {
        id
        type
        __typename
      }
      creator_id
      currency_code
      description
      discount_amount
      discount_date
      due_date
      issue_date
      line_items {
        id
        source_id
        amount
        cost_code_id
        cost_type_id
        customer_id
        description
        discount_amount
        item_id
        ledger_account_id
        project_id
        quantity
        retention_amount
        status
        sub_job_id
        tax_amount
        tax_code_id
        type
        unit_cost
        unit_of_measure
        vendor_id
        wbs_id
        source_create_time
        source_update_time
        __typename
      }
      misc_amount
      net_amount
      number
      project_id
      retention_amount
      retention_percent
      status
      subtotal_amount
      tax_amount
      total_amount
      type
      vendor_id
      source_create_time
      source_update_time
      source_data {
        path
        content_type
        data
        __typename
      }
    }
  }
}
` as GeneratedMutation<
  APITypes.AgaveAPInvoicesCreateExpenseMutationVariables,
  APITypes.AgaveAPInvoicesCreateExpenseMutation
>;
export const agaveResolverMutation = /* GraphQL */ `mutation AgaveResolverMutation($input: AgaveResolverMutationInput!) {
  agaveResolverMutation(input: $input) {
    ... on AgaveError {
      message
    }
    ... on AgaveResolverMutationResponse {
      status
      content_type
      body
      headers {
        raw
        __typename
      }
    }
  }
}
` as GeneratedMutation<
  APITypes.AgaveResolverMutationMutationVariables,
  APITypes.AgaveResolverMutationMutation
>;
export const startSage300APInvoice = /* GraphQL */ `mutation StartSage300APInvoice($input: StartSage300APInvoiceInput!) {
  startSage300APInvoice(input: $input) {
    transactionId
    status
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.StartSage300APInvoiceMutationVariables,
  APITypes.StartSage300APInvoiceMutation
>;
export const startSage300JobCost = /* GraphQL */ `mutation StartSage300JobCost($input: StartSage300JobCostInput!) {
  startSage300JobCost(input: $input) {
    transactionId
    status
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.StartSage300JobCostMutationVariables,
  APITypes.StartSage300JobCostMutation
>;
export const startQBOPosting = /* GraphQL */ `mutation StartQBOPosting($input: StartQBOPostingInput!) {
  startQBOPosting(input: $input) {
    transactionId
    status
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.StartQBOPostingMutationVariables,
  APITypes.StartQBOPostingMutation
>;
export const startQBDPosting = /* GraphQL */ `mutation StartQBDPosting($input: StartQBDPostingInput!) {
  startQBDPosting(input: $input) {
    transactionId
    status
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.StartQBDPostingMutationVariables,
  APITypes.StartQBDPostingMutation
>;
export const startSageIntacctPosting = /* GraphQL */ `mutation StartSageIntacctPosting($input: StartSageIntacctPostingInput!) {
  startSageIntacctPosting(input: $input) {
    transactionId
    status
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.StartSageIntacctPostingMutationVariables,
  APITypes.StartSageIntacctPostingMutation
>;
export const startVistaPosting = /* GraphQL */ `mutation StartVistaPosting($input: StartVistaPostingInput!) {
  startVistaPosting(input: $input) {
    transactionId
    status
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.StartVistaPostingMutationVariables,
  APITypes.StartVistaPostingMutation
>;
export const startAcumaticaPosting = /* GraphQL */ `mutation StartAcumaticaPosting($input: StartAcumaticaPostingInput!) {
  startAcumaticaPosting(input: $input) {
    transactionId
    status
    error
    __typename
  }
}
` as GeneratedMutation<
  APITypes.StartAcumaticaPostingMutationVariables,
  APITypes.StartAcumaticaPostingMutation
>;
export const agaveCreateCreditCardCredit = /* GraphQL */ `mutation AgaveCreateCreditCardCredit($input: AgaveResolverMutationInput!) {
  agaveCreateCreditCardCredit(input: $input) {
    ... on AgaveError {
      message
    }
    ... on CreateAgaveExpenseAPInvoice {
      id
      source_id
      amount
      amount_due
      ap_payment_ids
      attachments {
        id
        source_id
        name
        url
        source_create_time
        source_update_time
        __typename
      }
      batch
      batch_id
      contract {
        id
        type
        __typename
      }
      creator_id
      currency_code
      description
      discount_amount
      discount_date
      due_date
      issue_date
      line_items {
        id
        source_id
        amount
        cost_code_id
        cost_type_id
        customer_id
        description
        discount_amount
        item_id
        ledger_account_id
        project_id
        quantity
        retention_amount
        status
        sub_job_id
        tax_amount
        tax_code_id
        type
        unit_cost
        unit_of_measure
        vendor_id
        wbs_id
        source_create_time
        source_update_time
        __typename
      }
      misc_amount
      net_amount
      number
      project_id
      retention_amount
      retention_percent
      status
      subtotal_amount
      tax_amount
      total_amount
      type
      vendor_id
      source_create_time
      source_update_time
      source_data {
        path
        content_type
        data
        __typename
      }
    }
  }
}
` as GeneratedMutation<
  APITypes.AgaveCreateCreditCardCreditMutationVariables,
  APITypes.AgaveCreateCreditCardCreditMutation
>;
export const attachDirectCostReceipt = /* GraphQL */ `mutation AttachDirectCostReceipt($input: AttachDirectCostReceiptInput!) {
  attachDirectCostReceipt(input: $input) {
    directCostId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AttachDirectCostReceiptMutationVariables,
  APITypes.AttachDirectCostReceiptMutation
>;
export const createReimbursementDirectCost = /* GraphQL */ `mutation CreateReimbursementDirectCost(
  $input: CreateReimbursementDirectCostInput!
) {
  createReimbursementDirectCost(input: $input) {
    reimbursementTransactionId
    directCostId
    directCostLineItemId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateReimbursementDirectCostMutationVariables,
  APITypes.CreateReimbursementDirectCostMutation
>;
export const completeFirstRunChecklist = /* GraphQL */ `mutation CompleteFirstRunChecklist($input: CompleteChecklistInput!) {
  completeFirstRunChecklist(input: $input) {
    paidolId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CompleteFirstRunChecklistMutationVariables,
  APITypes.CompleteFirstRunChecklistMutation
>;
export const checkAndUpdateChecklist = /* GraphQL */ `mutation CheckAndUpdateChecklist($input: CompleteChecklistInput!) {
  checkAndUpdateChecklist(input: $input) {
    paidolId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CheckAndUpdateChecklistMutationVariables,
  APITypes.CheckAndUpdateChecklistMutation
>;
export const completeFirstRunBanner = /* GraphQL */ `mutation CompleteFirstRunBanner($input: CompleteBannerInput!) {
  completeFirstRunBanner(input: $input) {
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CompleteFirstRunBannerMutationVariables,
  APITypes.CompleteFirstRunBannerMutation
>;
export const checkAndUpdateBanner = /* GraphQL */ `mutation CheckAndUpdateBanner($input: CompleteBannerInput!) {
  checkAndUpdateBanner(input: $input) {
    userId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CheckAndUpdateBannerMutationVariables,
  APITypes.CheckAndUpdateBannerMutation
>;
export const attachSpendRulesToGroupCards = /* GraphQL */ `mutation AttachSpendRulesToGroupCards(
  $input: AttachSpendRulesToGroupCardsInput!
) {
  attachSpendRulesToGroupCards(input: $input) {
    cardGroupId
    cardGroup {
      id
      paidolId
      authPaidolId
      name
      groupProjects
      isMonthlyBudgetUnlimited
      spendGroupId
      deletedAt
      hasReviewers
      createdAt
      updatedAt
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AttachSpendRulesToGroupCardsMutationVariables,
  APITypes.AttachSpendRulesToGroupCardsMutation
>;
export const postAgavePassThrough = /* GraphQL */ `mutation PostAgavePassThrough($input: AgavePassThroughInput!) {
  postAgavePassThrough(input: $input) {
    ... on AgaveError {
      message
    }
    ... on AgavePassThroughResponse {
      status
      content_type
      body
      headers {
        raw
        __typename
      }
    }
  }
}
` as GeneratedMutation<
  APITypes.PostAgavePassThroughMutationVariables,
  APITypes.PostAgavePassThroughMutation
>;
export const removeCardGroup = /* GraphQL */ `mutation RemoveCardGroup($input: RemoveCardGroupInput!) {
  removeCardGroup(input: $input) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RemoveCardGroupMutationVariables,
  APITypes.RemoveCardGroupMutation
>;
export const hnCreateVelocityRule = /* GraphQL */ `mutation HnCreateVelocityRule($input: HNCreateVelocityRuleInput!) {
  hnCreateVelocityRule(input: $input) {
    ... on HNVelocityRule {
      id
      name
      velocityRuleWindow
      cumulativeRule {
        id
        name
        version
        createdAt
        updatedAt

        ... on HNMerchantCategorySpendRule {
          allowed
          blocked
          allowedMcc
          blockedMcc
        }
        ... on HNCVVSpendRule {
          allowed
          blocked
        }
        ... on HNStreetAddressSpendRule {
          allowed
          blocked
        }
        ... on HNMerchantIdentifierSpendRule {
          allowed
          blocked
        }
        ... on HNMerchantCountrySpendRule {
          allowed
          blocked
        }
        ... on HNCountLimitSpendRule {
          maximumCount
        }
        ... on HNPointOfServiceCategorySpendRule {
          allowed
          blocked
        }
        ... on HNPostalCodeVerificationSpendRule {
          allowed
          blocked
        }
        ... on HNDepositProcessingNetworkSpendRule {
          allowed
          blocked
        }
        ... on HNDepositCountLimitSpendRule {
          maximumCount
        }
        ... on HNConditionalRuleSetSpendRule {
          allow
        }
        ... on HNCardTransactionProcessingTypeConditionSpendRule {
          allowed
          blocked
        }
        ... on HNRestrictedAccountHolderSpendRule {
          allowed
          blocked
        }
        ... on HNPanEntryModeSpendRule {
          allowed
          blocked
        }
        ... on HNCardDataInputCapabilitySpendRule {
          allowed
          blocked
        }
      }
      spendRules {
        id
        name
        version
        createdAt
        updatedAt

        ... on HNMerchantCategorySpendRule {
          allowed
          blocked
          allowedMcc
          blockedMcc
        }
        ... on HNCVVSpendRule {
          allowed
          blocked
        }
        ... on HNStreetAddressSpendRule {
          allowed
          blocked
        }
        ... on HNMerchantIdentifierSpendRule {
          allowed
          blocked
        }
        ... on HNMerchantCountrySpendRule {
          allowed
          blocked
        }
        ... on HNCountLimitSpendRule {
          maximumCount
        }
        ... on HNPointOfServiceCategorySpendRule {
          allowed
          blocked
        }
        ... on HNPostalCodeVerificationSpendRule {
          allowed
          blocked
        }
        ... on HNDepositProcessingNetworkSpendRule {
          allowed
          blocked
        }
        ... on HNDepositCountLimitSpendRule {
          maximumCount
        }
        ... on HNConditionalRuleSetSpendRule {
          allow
        }
        ... on HNCardTransactionProcessingTypeConditionSpendRule {
          allowed
          blocked
        }
        ... on HNRestrictedAccountHolderSpendRule {
          allowed
          blocked
        }
        ... on HNPanEntryModeSpendRule {
          allowed
          blocked
        }
        ... on HNCardDataInputCapabilitySpendRule {
          allowed
          blocked
        }
      }
      version
      createdAt
      updatedAt
      revisions {
        __typename
      }
      velocityConstraintLevelOverride
    }
    ... on HNUserError {
      errors {
        path
        code
        description
        errorPath
        __typename
      }
    }
    ... on HNAccessDeniedError {
      message
    }
  }
}
` as GeneratedMutation<
  APITypes.HnCreateVelocityRuleMutationVariables,
  APITypes.HnCreateVelocityRuleMutation
>;
export const persistAgaveData = /* GraphQL */ `mutation PersistAgaveData($input: PersistAgaveDataInput!) {
  persistAgaveData(input: $input) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PersistAgaveDataMutationVariables,
  APITypes.PersistAgaveDataMutation
>;
export const addMerchantSpendRule = /* GraphQL */ `mutation AddMerchantSpendRule($input: AddMerchantSpendRuleInput!) {
  addMerchantSpendRule(input: $input) {
    id
    paidolId
    authPaidolId
    name
    paymentCards
    merchantCountrySpendRuleId
    merchantCategorySpendRuleId
    amountLimitSpendRuleId
    monthlyLimitSpendRuleId
    monthlyLimitCumulativeRuleId
    maximumAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    monthlyLimitAmount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    merchantCategoryAllowed
    merchantCategoryBlocked
    merchantCountryAllowed
    merchantCountryBlocked
    monthlyLimitResetTimestamp
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddMerchantSpendRuleMutationVariables,
  APITypes.AddMerchantSpendRuleMutation
>;
export const v2UpdateBudgetSpent = /* GraphQL */ `mutation V2UpdateBudgetSpent($input: V2UpdateBudget!) {
  v2UpdateBudgetSpent(input: $input) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.V2UpdateBudgetSpentMutationVariables,
  APITypes.V2UpdateBudgetSpentMutation
>;
export const editMerchantSpendRule = /* GraphQL */ `mutation EditMerchantSpendRule($input: EditMerchantSpendRuleInput!) {
  editMerchantSpendRule(input: $input) {
    ... on MerchantSpendRule {
      id
      paidolId
      authPaidolId
      name
      paymentCards
      merchantCountrySpendRuleId
      merchantCategorySpendRuleId
      amountLimitSpendRuleId
      monthlyLimitSpendRuleId
      monthlyLimitCumulativeRuleId
      maximumAmount {
        value
        currencyCode
        decimalPlaces
        __typename
      }
      monthlyLimitAmount {
        value
        currencyCode
        decimalPlaces
        __typename
      }
      merchantCategoryAllowed
      merchantCategoryBlocked
      merchantCountryAllowed
      merchantCountryBlocked
      monthlyLimitResetTimestamp
      createdAt
      updatedAt
    }
    ... on MerchantSpendRuleError {
      errors
    }
  }
}
` as GeneratedMutation<
  APITypes.EditMerchantSpendRuleMutationVariables,
  APITypes.EditMerchantSpendRuleMutation
>;
export const removeMerchantSpendRule = /* GraphQL */ `mutation RemoveMerchantSpendRule($input: String!) {
  removeMerchantSpendRule(input: $input) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RemoveMerchantSpendRuleMutationVariables,
  APITypes.RemoveMerchantSpendRuleMutation
>;
export const lockUnlockPaymentCard = /* GraphQL */ `mutation LockUnlockPaymentCard($input: LockUnlockPaymentCardInput!) {
  lockUnlockPaymentCard(input: $input) {
    statusCode
    status
    paymentCardId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.LockUnlockPaymentCardMutationVariables,
  APITypes.LockUnlockPaymentCardMutation
>;
export const removeProjectGroup = /* GraphQL */ `mutation RemoveProjectGroup($input: RemoveProjectGroupInput!) {
  removeProjectGroup(input: $input) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RemoveProjectGroupMutationVariables,
  APITypes.RemoveProjectGroupMutation
>;
export const v2CreateReimbursementTransaction = /* GraphQL */ `mutation V2CreateReimbursementTransaction(
  $input: CreateReimbursementTransactionInput!
) {
  v2CreateReimbursementTransaction(input: $input) {
    id
    paidolId
    authPaidolId
    dwollaTransferId
    transactionDate
    amount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    status
    checkrunStatus
    note
    contestNote
    deniedNote
    merchantName
    receiptLineItems
    jobCodeId
    jobCode {
      id
      paidolId
      authPaidolId
      description
      code
      isActive
      budget
      jobCodeImportId
      createdAt
      updatedAt
      __typename
    }
    reimbursementDate
    decisionDate
    reviewedByPaidolUserId
    reviewedByName
    reviewedByRole
    reviewedAt
    paidolUserId
    paidolUser {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    transactionType
    expenseTypeId
    expenseType {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    receiptId
    receipt {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    procoreProjectId
    procoreProject {
      id
      active
      display_name
      name
      created_at
      start_date
      completion_date
      project_number
      total_value
      __typename
    }
    procoreWBSCodeId
    procoreWBSCode {
      id
      flat_code
      flat_name
      description
      status
      __typename
    }
    agaveGlCodeId
    agaveGlCode {
      id
      paidolId
      authPaidolId
      source_id
      classification
      currency_code
      current_balance
      description
      name
      number
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveProjectId
    agaveProject {
      id
      paidolId
      authPaidolId
      source_id
      amount
      completion_date
      name
      number
      start_date
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveCostCodeId
    agaveCostCode {
      id
      paidolId
      authPaidolId
      asset_account_id
      source_id
      formatted_full_code
      code
      full_code
      cost_unit_of_measure
      description
      expense_account_id
      income_account_id
      name
      parent_id
      project_id
      price_unit_of_measure
      source_create_time
      source_update_time
      status
      type
      unit_cost
      unit_price
      vendor_id
      sub_job_id
      createdAt
      updatedAt
      projectId
      paidolProject
      projectIds
      cost_type_ids
      fullName
      __typename
    }
    agaveCostTypeId
    agaveCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      project_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      paidolProject
      __typename
    }
    agaveVendorId
    agaveVendor {
      id
      paidolId
      authPaidolId
      source_id
      code
      email
      fax
      name
      phone
      status
      tax_number
      terms
      type
      website
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      __typename
    }
    agaveSubJobId
    agaveSubJob {
      id
      agaveSubJobId
      paidolId
      authPaidolId
      source_id
      name
      number
      code
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      fullName
      cost_code_ids
      __typename
    }
    agaveLocationId
    agaveLocation {
      id
      paidolId
      authPaidolId
      name
      fullName
      parent_id
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveDepartmentId
    agaveDepartment {
      id
      paidolId
      authPaidolId
      code
      name
      fullName
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveSubaccountId
    agaveSubaccount {
      id
      paidolId
      authPaidolId
      code
      name
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveEmployeeId
    agaveEmployee {
      id
      paidolId
      authPaidolId
      name
      fullName
      firstName
      lastName
      email
      status
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveEquipmentId
    agaveEquipment {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCo
      category
      department
      status
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostCodeId
    agaveEmCostCode {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCostTypeCodes
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostTypeId
    agaveEmCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      abbreviation
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    codingType
    accountingDate
    flexGlCodeId
    flexGlCode {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCodeId
    flexCode {
      id
      paidolId
      authPaidolId
      projectName
      projectCode
      isActive
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostCodeId
    flexCostCode {
      id
      paidolId
      authPaidolId
      code
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostTypeId
    flexCostType {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexVendorId
    flexVendor {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.V2CreateReimbursementTransactionMutationVariables,
  APITypes.V2CreateReimbursementTransactionMutation
>;
export const v2UpdateReimbursementTransaction = /* GraphQL */ `mutation V2UpdateReimbursementTransaction(
  $input: UpdateReimbursementTransactionInput!
) {
  v2UpdateReimbursementTransaction(input: $input) {
    id
    paidolId
    authPaidolId
    dwollaTransferId
    transactionDate
    amount {
      value
      currencyCode
      decimalPlaces
      __typename
    }
    status
    checkrunStatus
    note
    contestNote
    deniedNote
    merchantName
    receiptLineItems
    jobCodeId
    jobCode {
      id
      paidolId
      authPaidolId
      description
      code
      isActive
      budget
      jobCodeImportId
      createdAt
      updatedAt
      __typename
    }
    reimbursementDate
    decisionDate
    reviewedByPaidolUserId
    reviewedByName
    reviewedByRole
    reviewedAt
    paidolUserId
    paidolUser {
      id
      paidol_id
      user_id
      email
      position
      phone
      roles
      is_test_fixture
      authorizedUserId
      authorizedUserApplicationId
      allowedJobCodes
      employee_id
      defaultAgaveEmployeeId
      deletedAt
      landingPagePreference
      createdAt
      updatedAt
      __typename
    }
    transactionType
    expenseTypeId
    expenseType {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    receiptId
    receipt {
      id
      paidolId
      authPaidolId
      document
      status
      createdAt
      updatedAt
      __typename
    }
    procoreProjectId
    procoreProject {
      id
      active
      display_name
      name
      created_at
      start_date
      completion_date
      project_number
      total_value
      __typename
    }
    procoreWBSCodeId
    procoreWBSCode {
      id
      flat_code
      flat_name
      description
      status
      __typename
    }
    agaveGlCodeId
    agaveGlCode {
      id
      paidolId
      authPaidolId
      source_id
      classification
      currency_code
      current_balance
      description
      name
      number
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveProjectId
    agaveProject {
      id
      paidolId
      authPaidolId
      source_id
      amount
      completion_date
      name
      number
      start_date
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      relatedIds
      __typename
    }
    agaveCostCodeId
    agaveCostCode {
      id
      paidolId
      authPaidolId
      asset_account_id
      source_id
      formatted_full_code
      code
      full_code
      cost_unit_of_measure
      description
      expense_account_id
      income_account_id
      name
      parent_id
      project_id
      price_unit_of_measure
      source_create_time
      source_update_time
      status
      type
      unit_cost
      unit_price
      vendor_id
      sub_job_id
      createdAt
      updatedAt
      projectId
      paidolProject
      projectIds
      cost_type_ids
      fullName
      __typename
    }
    agaveCostTypeId
    agaveCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      project_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      paidolProject
      __typename
    }
    agaveVendorId
    agaveVendor {
      id
      paidolId
      authPaidolId
      source_id
      code
      email
      fax
      name
      phone
      status
      tax_number
      terms
      type
      website
      source_create_time
      source_update_time
      createdAt
      updatedAt
      fullName
      __typename
    }
    agaveSubJobId
    agaveSubJob {
      id
      agaveSubJobId
      paidolId
      authPaidolId
      source_id
      name
      number
      code
      status
      type
      source_create_time
      source_update_time
      createdAt
      updatedAt
      projectId
      fullName
      cost_code_ids
      __typename
    }
    agaveLocationId
    agaveLocation {
      id
      paidolId
      authPaidolId
      name
      fullName
      parent_id
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveDepartmentId
    agaveDepartment {
      id
      paidolId
      authPaidolId
      code
      name
      fullName
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      relatedIds
      __typename
    }
    agaveSubaccountId
    agaveSubaccount {
      id
      paidolId
      authPaidolId
      code
      name
      status
      type
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveEmployeeId
    agaveEmployee {
      id
      paidolId
      authPaidolId
      name
      fullName
      firstName
      lastName
      email
      status
      source_id
      source_create_time
      source_update_time
      createdAt
      updatedAt
      source_data
      __typename
    }
    agaveEquipmentId
    agaveEquipment {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCo
      category
      department
      status
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostCodeId
    agaveEmCostCode {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      emCostTypeCodes
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    agaveEmCostTypeId
    agaveEmCostType {
      id
      paidolId
      authPaidolId
      source_id
      code
      name
      fullName
      emGroup
      abbreviation
      source_create_time
      source_update_time
      lastSeenAt
      createdAt
      updatedAt
      __typename
    }
    codingType
    accountingDate
    flexGlCodeId
    flexGlCode {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCodeId
    flexCode {
      id
      paidolId
      authPaidolId
      projectName
      projectCode
      isActive
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostCodeId
    flexCostCode {
      id
      paidolId
      authPaidolId
      code
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexCostTypeId
    flexCostType {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    flexVendorId
    flexVendor {
      id
      paidolId
      authPaidolId
      name
      flexCodeImportId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.V2UpdateReimbursementTransactionMutationVariables,
  APITypes.V2UpdateReimbursementTransactionMutation
>;
export const v2CreateReceiptUpload = /* GraphQL */ `mutation V2CreateReceiptUpload($input: CreateReceiptUploadInput!) {
  v2CreateReceiptUpload(input: $input) {
    id
    paidolId
    authPaidolId
    document
    status
    summaryFields {
      nextToken
      __typename
    }
    lineItems {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.V2CreateReceiptUploadMutationVariables,
  APITypes.V2CreateReceiptUploadMutation
>;
export const v2UpdateReimbursementsSettings = /* GraphQL */ `mutation V2UpdateReimbursementsSettings(
  $input: UpdateReimbursementsSettingsInput!
) {
  v2UpdateReimbursementsSettings(input: $input) {
    statusCode
    body
    __typename
  }
}
` as GeneratedMutation<
  APITypes.V2UpdateReimbursementsSettingsMutationVariables,
  APITypes.V2UpdateReimbursementsSettingsMutation
>;
export const v2DeleteTransactionToReceiptUpload = /* GraphQL */ `mutation V2DeleteTransactionToReceiptUpload(
  $input: DeleteTransactionToReceiptUploadByReceiptIdInput!
) {
  v2DeleteTransactionToReceiptUpload(input: $input) {
    success
    message
    __typename
  }
}
` as GeneratedMutation<
  APITypes.V2DeleteTransactionToReceiptUploadMutationVariables,
  APITypes.V2DeleteTransactionToReceiptUploadMutation
>;
